
let dis = [
    {
        "title": "CNN - Breaking News, Latest News and Videos",
        "url": "https://www.cnn.com/",
        "description": "CNN.com delivers up-to-the-minute news and information on the latest top stories, weather entertainment, politics and more.",
        "votes": "27276684",
        "rss_url": "http://rss.cnn.com/rss/cnn_topstories.rss",
        "rss_image_url": " https://cdn.cnn.com/cnn/.e1mo/img/4.0/logos/logo_cnn_badge_2up.png",
       
        "category": "News",
        "e": "Error: Unquoted attribute value\nLine: 0\nColumn: 1260\nChar: ”"
    },
    {
        "title": "The New York Times",
        "url": "https://nytimes.com",
        "description": "The New York Times provides breaking news, multimedia, reviews & opinion on Washington, business, sports, movies, travel, books, jobs, education, real estate, cars & more.",
        "votes": "15195747",
        "category": "News",
        "rss_url": "https://rss.nytimes.com/services/xml/rss/nyt/HomePage.xml",
        "rss_title": "NYT > Home Page",
        "rss_image_url": "https://static01.nyt.com/images/misc/NYT_logo_rss_250x40.png",
        "rss_description": ""
    },
    {
        "title": "Fox News",
        "url": "https://foxnews.com",
        "description": "Fox News provides breaking news and videos on latest current news, U.S., World, Entertainment, Health, Business, Technology, Politics and Sports.",
        "votes": "16294717",
        "category": "News",
        "rss_url": "https://feeds.feedburner.com/foxnews/latest",
        "rss_title": "FOX News",
        "rss_image_url": "http://tools.foxnews.com/sites/tools.foxnews.com/files/images/fox-news-logo.png",
        "rss_description": "FOXNews.com - Breaking news and video. Latest Current News: U.S., World, Entertainment, Health, Business, Technology, Politics, Sports."
    },
    {
        "title": "USA TODAY",
        "url": "https://usatoday.com",
        "description": "USA TODAY delivers current local and national news, sports, entertainment, finance, technology, and more through award-winning journalism, photos, videos and VR.",
        "votes": "15077985",
        "category": "News",
        "e": "Error: Invalid character in entity name\nLine: 16\nColumn: 27\nChar: &"
    },
    {
        "title": "Reuters.com",
        "url": "https://Reuters.com",
        "description": "Reuters.com is your online source for the latest U.S. news stories from coast to coast and stay current on the events that shape our nation.",
        "votes": "3999722",
        "category": "News",
        "e": "Error: Malformed comment\nLine: 1\nColumn: 58\nChar: i"
    },
    {
        "title": "POLITICO",
        "url": "https://politico.com",
        "description": "POLITICO launched in January 2007 with the mission of covering the politics of Capitol Hill, the presidential campaign, and the business of Washington lobbying and advocacy with enterprise, style, and impact. Political news about Congress, the White House, campaigns, lobbyists and issues.",
        "votes": "1697168",
        "category": "News",
        "rss_url": "https://www.politico.com/rss/politicopicks.xml",
        "rss_title": "Politics, Policy, Political News Top Stories",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Politics, Policy, Political News Top Stories"
    },
    {
        "title": "Yahoo News",
        "url": "https://yahoo.com/news ",
        "description": "The latest news and headlines from Yahoo! News. Get breaking news stories and in-depth coverage with videos and photos.",
        "votes": "7500000",
        "category": "News",
        "e": "Error: Request timed out after 10000ms"
    },
    {
        "title": "NBC News",
        "url": "https://nbcnews.com",
        "description": "NBC News is a leading source of global news and information for more than 75 years. Go to NBCNews.com for breaking news, videos, and the latest top stories in world news, business, politics, health and pop culture.",
        "votes": "4800000",
        "category": "News",
        "e": "Error: unable to verify the first certificate"
    },
    {
        "title": "New York Post",
        "url": "https://nypost.com",
        "description": "New York Post is your source for breaking news, news about New York, sports, business, entertainment, opinion, real estate, culture, fashion, and more.",
        "votes": "4700000",
        "category": "News",
        "e": "Error: Invalid character in entity name\nLine: 13\nColumn: 147\nChar: &"
    },
    {
        "title": "ABC News",
        "url": "https://abcnews.go.com",
        "description": "ABC News is your trusted source for breaking news, analysis, exclusive interviews, headlines, and videos. They are updated around the clock with breaking news, top stories, videos, photos, special reports and exclusive interviews.",
        "votes": "4600000",
        "category": "News",
        "rss_url": "http://feeds.abcnews.com/abcnews/topstories",
        "rss_title": "ABC News: Top Stories",
        "rss_image_url": "https://s.abcnews.com/images/site/abcnews_google_rss_logo.png",
        "rss_description": ""
    },
    {
        "title": "The Points Guy",
        "url": "https://thepointsguy.com/",
        "description": "Great access to deal alerts, seat sales, maximizing points, and a few heart-warming travel stories to round things out. The essential reading links are a great first stop for any points collecting journey.",
        "votes": "1021",
        "category": "Travel",
        "rss_url": "https://thepointsguy.com/feed/",
        "rss_title": "The Points Guy",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Maximize your travel."
    },
    {
        "title": "Lonely Planet",
        "url": "http://www.lonelyplanet.com",
        "description": "This is a blog-loving traveler’s paradise for fans of Lonely Planet. There’s something for everyone on the site from destinations to forums, links to travel buddies, and specific interests (Beaches, coasts and islands anyone?).",
        "votes": "918",
        "category": "Travel",
        "e": "Error: Invalid character in entity name\nLine: 37\nColumn: 39\nChar: &"
    },
    {
        "title": "Adventure Journal",
        "url": "https://www.adventure-journal.com/",
        "description": "If you’re looking for active, challenging adventures, the adventure journal has you covered for camping, hiking, surfing, snow sports, and more. For some extra inspiration, check out their Historical Badass page and see who was adventuring long before it was cool.",
        "votes": "85",
        "category": "Travel",
        "rss_url": "https://www.adventure-journal.com/feed/",
        "rss_title": "Adventure Journal",
        "rss_image_url": "https://www.adventure-journal.com/wp-content/uploads/2017/03/aj-logo-small.jpg",
        "rss_description": "the deeper you get, the deeper you get"
    },
    {
        "title": "Adventure.com",
        "url": "https://adventure.com/",
        "description": "This site results from over a dozen season travel writers who take wild adventures that almost defy logic. If there’s an adventure in a far-off corner of the world, you’ll probably read about it here.",
        "votes": "75",
        "category": "Travel",
        "e": "Error: Invalid character in tag name\nLine: 7\nColumn: 367\nChar: ;"
    },
    {
        "title": "Nomadic Matt",
        "url": "https://www.nomadicmatt.com/",
        "description": "Complete resources for traveling on a budget to anywhere, plus blog posts on recent adventures. The site also has a very active forum with everything from finding travel buddies to older travelers.",
        "votes": "69",
        "category": "Travel",
        "rss_url": "https://www.nomadicmatt.com/feed/",
        "rss_title": "Nomadic Matt's Travel Site",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Travel Better, Cheaper, Longer"
    },
    {
        "title": "View from the Wing",
        "url": "http://viewfromthewing.boardingarea.com/",
        "description": "View From The Wing is a thought leader in travel, featuring information on air miles, technology and other flying related topics.",
        "votes": "34",
        "category": "Travel",
        "rss_url": "https://viewfromthewing.boardingarea.com/feed/",
        "rss_title": "View from the Wing",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Thought Leader in Travel"
    },
    {
        "title": "Johnny Jet",
        "url": "https://www.johnnyjet.com/",
        "description": "Newsy travel site with great resources for travel, points, and rewards how-to. Johnny is a real person who overcame a fear of flying, and he writes as well as facilitates information from a variety of travel experts.",
        "votes": "24",
        "category": "Travel",
        "rss_url": "https://www.johnnyjet.com/feed/",
        "rss_title": "Johnny Jet",
        "rss_image_url": "https://www.johnnyjet.com/wp-content/uploads/2019/03/cropped-2018-10-30-32x32.png",
        "rss_description": "REWARDS CREDIT CARDS, DEALS, TIPS, DESTINATIONS AND MORE!"
    },
    {
        "title": "The Everywhereist",
        "url": "http://www.everywhereist.com/",
        "description": "Witty, entertaining, and well-written blog about traveling, life, and feminism. Her descriptions of her travels (and food) make you want to follow exactly in her footsteps.",
        "votes": "22",
        "category": "Travel",
        "rss_url": "http://www.everywhereist.com/home/feed/",
        "rss_title": "The Everywhereist",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "travel advice, tips, and stories"
    },
    {
        "title": "Ordinary Traveler",
        "url": "https://ordinarytraveler.com/",
        "description": "Travel advice and photography for people who love to travel and keep a home base to come back to. Great blogs on active travel with tips on making the most out of your vacation days.",
        "votes": "19",
        "category": "Travel",
        "e": "Error: Attribute without value\nLine: 0\nColumn: 26095\nChar: >"
    },
    {
        "title": "Everything Everywhere",
        "url": "https://everything-everywhere.com/",
        "description": "Travel blog and travel photos by Gary Arndt, who has been traveling the world full time since 2007. Great writing and photos, and some amazing adventures from a guy who isn’t in his 20s anymore.",
        "votes": "18",
        "category": "Travel",
        "e": "Error: Attribute without value\nLine: 2\nColumn: 697\nChar: s"
    },
    {
        "title": "Expert Vagabond",
        "url": "http://expertvagabond.com/",
        "description": "Adventure and travel with destinations, travel resources, and photography tips. New in 2018 is a chance to join vagabond Matt on a travel and photography tour—to Russia!",
        "votes": "17",
        "category": "Travel",
        "e": "Error: Unexpected close tag\nLine: 6\nColumn: 16488\nChar: >"
    },
    {
        "title": "Loyalty Lobby",
        "url": "https://loyaltylobby.com/",
        "description": "First class travel and luxury accommodations through carefully analyzed points and rewards strategies. Plus fascinating travel news that you might not read anywhere else.",
        "votes": "17",
        "category": "Travel",
        "rss_url": "https://loyaltylobby.com/feed/",
        "rss_title": "LoyaltyLobby",
        "rss_image_url": "https://loyaltylobby.com/wp-content/uploads/2014/10/ll-icon-ios-152x152-150x150.png",
        "rss_description": "Making sense of travel loyalty programs."
    },
    {
        "title": "Million Mile Secrets",
        "url": "https://millionmilesecrets.com/",
        "description": "Great tips on paying with points for travel around the world. Daraius, Emily, and their team have redeemed millions of miles and enjoy all kinds of luxury travel.",
        "votes": "16",
        "category": "Travel",
        "rss_url": "https://millionmilesecrets.com/feed/",
        "rss_title": "Million Mile Secrets",
        "rss_image_url": "https://millionmilesecrets.com/wp-content/uploads/2018/05/cropped-cropped-android-chrome-512x512-32x32.png",
        "rss_description": "Big Travel.  Small Money."
    },
    {
        "title": "Stuck in Customs",
        "url": "https://www.stuckincustoms.com/",
        "description": "Daily blog that specializes in spectacular travel photos and all things related to photography and photo editing. Short blogs, photos, and videos about photo editing.",
        "votes": "16",
        "category": "Travel",
        "e": "Error: read ECONNRESET"
    },
    {
        "title": "Frequent Miler",
        "url": "http://frequentmiler.boardingarea.com/",
        "description": "If you’re ready to build miles without flying, this is your go-to source for information about maximizing sign-up bonuses and getting big miles fast. It also keeps up to date on great travel offers and has a forum for discussing ways to get miles and points.",
        "votes": "13",
        "category": "Travel",
        "e": "Error: Invalid character in entity name\nLine: 63\nColumn: 433\nChar: &"
    },
    {
        "title": "Alex in Wanderland",
        "url": "https://www.alexinwanderland.com/",
        "description": "Fun read about travel, travel disasters, scuba diving, and permanent traveling. Alex has been traveling and blogging about it full-time for the past 6 years.",
        "votes": "10",
        "category": "Travel",
        "rss_url": "https://www.alexinwanderland.com/feed/",
        "rss_title": "Alex In Wanderland",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Working and playing around the world"
    },
    {
        "title": "The Art of Non-Conformity",
        "url": "https://chrisguillebeau.com/",
        "description": "Site with blogs about life, travel, and ‘et-cetera’ with a focus on achieving personal goals and helping others. Chris has also written a book with the same title, and both provide advice and stories about unconventional strategies.",
        "votes": "10",
        "category": "Travel",
        "e": "Error: Attribute without value\nLine: 42\nColumn: 77\nChar: >"
    },
    {
        "title": "Adventurous Kate",
        "url": "http://www.adventurouskate.com/",
        "description": "Empowering travel blog for adventure-loving women interested in solo travel. Kate blogs about unique and unusual travel experiences, safety, and how to make money as a travel blogger.",
        "votes": "7",
        "category": "Travel",
        "e": "Error: Unencoded <\nLine: 2\nColumn: 1523\nChar: 6"
    },
    {
        "title": "Travel Codex",
        "url": "https://travelcodex.com/",
        "description": "Flight deals, hotel and flight reviews, and current travel news. The team of writers also gives tips and hacks for using rewards to get great travel deals.",
        "votes": "7",
        "category": "Travel",
        "e": "Error: Invalid character in entity name\nLine: 71\nColumn: 56\nChar: ="
    },
    {
        "title": "Blogger at Large",
        "url": "https://www.bloggeratlarge.com/",
        "description": "Megan Singleton is the author of Blogger at Large and has been galavanting around the world travel writing full time since 2000 and blogging since 2006. “Travel inspiration made easy” is my tagline for the blog.",
        "votes": "6",
        "category": "Travel",
        "rss_url": "https://www.bloggeratlarge.com/feed/",
        "rss_title": "Blogger at Large",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Travel inspiration made easy"
    },
    {
        "title": "Loyalty Traveler",
        "url": "http://loyaltytraveler.boardingarea.com/",
        "description": "Find out about great airfare and hotel deals, learn about travel loyalty programs, and keep up to date on travel news. Owner-writer Ric Garrido has been operating Loyalty Traveler since 2006.",
        "votes": "5",
        "category": "Travel",
        "e": "Error: Invalid character in entity name\nLine: 119\nColumn: 433\nChar: &"
    },
    {
        "title": "TravelBloggerBuzz",
        "url": "http://travelbloggerbuzz.com/",
        "description": "Brutal but honest reviews of other blogs, rewards cards, and one of the only sites calling out other bloggers for aggressive selling. A look through the articles brings up an entertaining and eclectic mix of travel reviews and tips.",
        "votes": "4",
        "category": "Travel",
        "e": "Error: Attribute without value\nLine: 141\nColumn: 60\nChar: i"
    },
    {
        "title": "Location Rebel",
        "url": "http://www.locationrebel.com/",
        "description": "This site is for everyone who wants the freedom to work independent of location while traveling the world. The focus is the Location Rebel Academy where you can access courses that will teach you to create a business that lets you travel wherever you want.",
        "votes": "3",
        "category": "Travel",
        "rss_url": "https://www.locationrebel.com/feed/",
        "rss_title": "Location Rebel",
        "rss_image_url": "https://www.locationrebel.com/wp-content/uploads/2018/03/cropped-LR-Favicon-1-32x32.png",
        "rss_description": "Freelance Writing, Niche Sites, and Other Lifestyle Businesses"
    },
    {
        "title": "The Longest Way Home",
        "url": "https://www.thelongestwayhome.com/",
        "description": "The travel blog is the journal of Dave. Starting as a private diary of sorts it's developed into a modern day explorers journal which includes helpful guides and insights into local food. This world is constantly changing and this site documents it like no one else out there.",
        "votes": "3",
        "category": "Travel",
        "e": "Error: Invalid character in entity name\nLine: 39\nColumn: 59\nChar:  "
    },
    {
        "title": "Wandering Aramean",
        "url": "https://blog.wandr.me/",
        "description": "Travel resources, including a list of browser extensions specifically for United miles collectors. The main page has current travel news and links to podcasts.",
        "votes": "3",
        "category": "Travel",
        "e": "Error: socket hang up"
    },
    {
        "title": "Globetrotter Girls",
        "url": "https://globetrottergirls.com/",
        "description": "This site is packed with the adventures and information of traveler and nomad Dani. She’s been traveling nearly full time since 2010, and shares everything about inspiring destinations, travel how-to, and mistakes she’s made so you don’t have to.",
        "votes": "2",
        "category": "Travel",
        "rss_url": "https://globetrottergirls.com/feed/",
        "rss_title": "GlobetrotterGirls",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "One Globe. No Regrets."
    },
    {
        "title": "Go See Write",
        "url": "http://www.goseewrite.com/",
        "description": "Permanent traveler Michael Hodson and his team have written thorough and inspiring travel guides to destinations around the world. Michael’s best claim to fame may be traveling the world without leaving the ground.",
        "votes": "2",
        "category": "Travel",
        "e": "Error: Invalid character in entity name\nLine: 48\nColumn: 433\nChar: &"
    },
    {
        "title": "TravelSkills",
        "url": "http://travelskills.com/",
        "description": "Editor Chris McGinnis has signed on with SFGate/Hearst, but will continue providing travel-related news, tips, and reviews. Also has info on new hotels, a link to a weekly Twitter travel chat, and credit card deals.",
        "votes": "2",
        "category": "Travel",
        "rss_url": "https://travelskills.com/feed/",
        "rss_title": "TravelSkills",
        "rss_image_url": "https://travelskills.com/wp-content/plugins/genesis-favicon-uploader/favicons/favicon.ico",
        "rss_description": "News and Tips For Your Trips"
    },
    {
        "title": "Saverocity Travel",
        "url": "http://saverocity.com/travel",
        "description": "Forum and blogs about finances and traveling including investing, types of income, and rewards and points. The blogs are a collection from 8 different blogs on travel and money.",
        "votes": "1",
        "category": "Travel",
        "e": "Error: Invalid character in entity name\nLine: 5\nColumn: 144\nChar: &"
    },
    {
        "title": "Angelina Travels",
        "url": "http://angelinatravels.boardingarea.com/",
        "description": "",
        "votes": "1",
        "category": "Travel",
        "rss_url": "https://angelinatravels.boardingarea.com/feed/",
        "rss_title": "Angelina Travels",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "miles of inspiration, with all points in between"
    },
    {
        "title": "Frugal Travel Guy",
        "url": "https://www.frugaltravelguy.com/",
        "description": "Resource for all ways to save money traveling, from rewards cards to hotel deals, family travel, and tours. The FTG also has a great source for points rookies (those just beginning the points and rewards world), and a page that gives a great overview of most travel rewards cards, with links to each.",
        "votes": "1",
        "category": "Travel",
        "rss_url": "https://www.frugaltravelguy.com/home-alt-1/feed",
        "rss_title": "Comments on: Home Alt 1",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "The award-winning online home of free travel expert Rick Ingersoll, the author of The Frugal Travel Guy Handbook. Rick's mission is to teach others how to enjoy traveling the country or the world for free or nearly free -- especially those who don't think they can afford to travel."
    },
    {
        "title": "Extra Pack of Peanuts",
        "url": "http://extrapackofpeanuts.com/",
        "description": "Extra Pack of Peanuts shows it's audience how to travel the world, whilst spending less. They provide a range of tips on credit cards, flights and accommodation.",
        "votes": "1",
        "category": "Travel",
        "e": "Error: socket hang up"
    },
    {
        "title": "Travel With Grant",
        "url": "http://travelwithgrant.boardingarea.com/",
        "description": "Tips and tricks for qualifying purchases on rewards cards, bonuses, and travel reviews. Some specific smaller awards and tips that don’t seem to be on other sites.",
        "votes": "1",
        "category": "Travel",
        "e": "Error: Invalid character in entity name\nLine: 22\nColumn: 155\nChar: &"
    },
    {
        "title": "Well Traveled Mile",
        "url": "https://welltraveledmile.com/",
        "description": "An easy-to-navigate site with a large listing of ‘Best Of’ gear, miles and points, and travel tips and reviews. The primary focus is camping and outdoor adventure gear.",
        "votes": "0",
        "category": "Travel",
        "rss_url": "https://welltraveledmile.com/feed/",
        "rss_title": "Well Traveled Mile",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Maximize airline frequent flyer miles, hotel and credit card points"
    },
    {
        "title": "Geoff Whitmore",
        "url": "http://geoffwhitmore.com/",
        "description": "Geoff Whitmore is a writer and traveler whose work has been featured in a variety of top sites. He writes about flights and travel—often accompanied by his wife.",
        "votes": "0",
        "category": "Travel",
        "rss_url": "http://geoffwhitmore.com/feed/",
        "rss_title": "Geoff Whitmore",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": ""
    },
    {
        "title": "Mommy Points",
        "url": "http://mommypoints.boardingarea.com/",
        "description": "",
        "votes": "0",
        "category": "Travel",
        "rss_url": "https://thepointsguy.com/feed/",
        "rss_title": "The Points Guy",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Maximize your travel."
    },
    {
        "title": "One Mile At a Time",
        "url": "http://onemileatatime.boardingarea.com/",
        "description": "A massive amount of blogs about specific travel credit cards, hotel and airline bonuses and rewards changes, travel, and travel news. Also offers a link to an awards travel booking service and an active Q & A forum.",
        "votes": "0",
        "category": "Travel",
        "rss_url": "https://onemileatatime.com/feed/",
        "rss_title": "One Mile at a Time",
        "rss_image_url": "https://onemileatatime.com/wp-content/uploads/2018/11/cropped-site-icon-150x150.jpg",
        "rss_description": "Tips, Tricks, and Travel"
    },
    {
        "title": "Loophole Travel",
        "url": "https://loopholetravel.com/",
        "description": "Get connected to a bargain loving adventurer and the real travelers who use his advice. You can also read reviews on travel gear and find some exotic travel stories with a local connection.",
        "votes": "0",
        "category": "Travel",
        "e": "Error: socket hang up"
    },
    {
        "title": "Point Chaser",
        "url": "http://pointchaser.com/",
        "description": "Unique and very practical information on collecting and redeeming points. Top posts include how to buy gift cards with credit cards, redeeming travel vouchers, and eliminating visa gift card fees.",
        "votes": "0",
        "category": "Travel",
        "e": "Error: Invalid character in entity name\nLine: 113\nColumn: 433\nChar: &"
    },
    {
        "title": "Points, Miles & Martinis",
        "url": "http://pointsmilesandmartinis.com",
        "description": "All around travel and points information, with details about rewards program changes and bonuses. Trip reports are categorized into major areas for an easier access to information on your next destination.",
        "votes": "0",
        "category": "Travel",
        "e": "Error: Invalid character in entity name\nLine: 30\nColumn: 163\nChar: &"
    },
    {
        "title": "Rapid Travel Chai",
        "url": "http://rapidtravelchai.com",
        "description": "Business executive and blogger Stefan Krasowski writes about travels and points/rewards. The focus is on busy, working individuals who want to travel more.",
        "votes": "0",
        "category": "Travel",
        "e": "Error: Invalid character in entity name\nLine: 30\nColumn: 156\nChar: &"
    },
    {
        "title": "Gaijin Crew",
        "url": "https://gaijincrew.com/",
        "description": "Gaijin Crew’s goal is to help other aspiring nomads achieve a life of freedom and adventure through travel. So, whether you want to spend your days living and working wherever you want as a digital nomad, or you want to have the most amazing gap year after leaving school or even if you just want to go away somewhere for a couple of weeks with the family, this blog can help you get there, without breaking the bank in the process!",
        "votes": "0",
        "category": "Travel",
        "rss_url": "https://gaijincrew.com/feed/",
        "rss_title": "Gaijin Crew",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": ""
    },
    {
        "title": "MileNerd",
        "url": "http://www.milenerd.com/",
        "description": "Posts 5 days a week with real deals on flights, points promotions, and new points cards. Great links to car rental deals and cashback portals.",
        "votes": "0",
        "category": "Travel",
        "e": "Error: read ECONNRESET"
    },
    {
        "title": "MileCards",
        "url": "https://milecards.com/",
        "description": "Excellent resources for comparing travel credit cards with options for searching by airline, transferable points, hotel, business, or no fee. News includes how to maximize specific points and how to book rewards.",
        "votes": "0",
        "category": "Travel",
        "e": "Error: Inappropriately located doctype declaration\nLine: 3\nColumn: 9\nChar: E"
    },
    {
        "title": "The Adventure Blog",
        "url": "http://theadventureblog.blogspot.com/",
        "description": "The Adventure Blog features news, commentary and insights into adventures from around the globe.",
        "votes": "0",
        "category": "Travel",
        "e": "Error: Invalid character in entity name\nLine: 39\nColumn: 27\nChar: &"
    },
    {
        "title": "The Free-quent Flyer",
        "url": "http://freequentflyerbook.com/",
        "description": "General blogs about travel, entertainment, rewards apps, and travel news. Separate Hotel Promotions page gives a long run-down of current promotions.",
        "votes": "0",
        "category": "Travel",
        "rss_url": "http://feeds.feedburner.com/FreequentFlyer",
        "rss_title": "The Free-quent Flyer",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "The Free-quent Flyer blog, where you find all the tips and tricks you need <br/>to see the world like I do, for next to nothing!"
    },
    {
        "title": "Hacker News",
        "url": "https://news.ycombinator.com/",
        "description": "Hacker News is a social news website focusing on computer science and entrepreneurship. It is run by Paul Graham's investment fund and startup incubator, Y Combinator. In general, content that can be submitted is defined as anything that gratifies one's intellectual curiosity",
        "votes": "29043",
        "category": "Tech",
        "rss_url": "https://hnrss.org/frontpage",
        "rss_title": "Hacker News",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/images%2Fimages%2FLbG7xdmaVQzC1HkkYBh?alt=media&token=0cbc1c90-6f26-426f-981f-56a4d224d736",
        "rss_description": "Hacker News is a social news website focusing on computer science and entrepreneurship. It is run by Paul Graham's investment fund and startup incubator, Y Combinator. In general, content that can be submitted is defined as anything that gratifies one's intellectual curiosity"
   },
    {
        "title": "Business Insider",
        "url": "http://www.businessinsider.com/",
        "description": "After a record 2017, Henry Blodget and the team continue to grow Business Insiders reach across Instagram, Facebook and the blogosphere.",
        "votes": "23804",
        "category": "Tech",
        "e": "Error: Invalid character in entity name\nLine: 6\nColumn: 54\nChar: &"
    },
    {
        "title": "Wired",
        "url": "https://www.wired.com",
        "description": "Wired.com focuses on how emerging technologies affect culture, the economy, and politics.The website provides an in-depth coverage of current and future trends in technology.",
        "votes": "21047",
        "category": "Tech",
        "rss_url": "https://www.wired.com/feed/rss",
        "rss_title": "Wired",
        "rss_image_url": "https://www.wired.com/images/logos/wired.png",
        "rss_description": "The latest from www.wired.com"
    },
    {
        "title": "Engadget",
        "url": "https://www.engadget.com/",
        "description": "An original home for technology news and reviews, Engadget produces the internet's most compelling videos, reviews, features and breaking news about the people, products and ideas shaping our world.",
        "votes": "12803",
        "category": "Tech",
        "rss_url": "https://www.engadget.com/rss.xml",
        "rss_title": "Engadget RSS Feed",
        "rss_image_url": "https://o.aolcdn.com/engadget/brand-kit/eng-logo-white.png",
        "rss_description": "Engadget is a web magazine with obsessive daily coverage of everything new in gadgets and consumer electronics"
    },
    {
        "title": "The Verge",
        "url": "https://www.theverge.com/",
        "description": "The Verge is an ambitious multimedia effort founded in 2011 to examine how technology will change life in the future for a massive mainstream audience.",
        "votes": "11316",
        "category": "Tech",
        "rss_url": "https://www.theverge.com/rss/index.xml",
        "rss_title": "The Verge -  All Posts",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media"
    },
    {
        "title": "CNET",
        "url": "https://www.cnet.com/news/",
        "description": "CNET tracks all the latest consumer technology breakthroughs and shows you what's new, what matters and how technology can enrich your life. CNet also provides the information, tools and advice that helps when deciding what to buy.",
        "votes": "11214",
        "category": "Tech",
        "rss_url": "https://www.cnet.com/rss/all/",
        "rss_title": "CNET",
        "rss_image_url": "http://i.i.cbsi.com/cnwk.1d/i/ne/gr/prtnr/CNET_Logo_150.gif",
        "rss_description": "The latest tech news, product reviews, videos, and how tos from CNET."
    },
    {
        "title": "TechCrunch",
        "url": "https://techcrunch.com",
        "description": "Founded by Michael Arrington and later sold to AOL, TechCrunch has remained as one of the leaders covering tech industry news.",
        "votes": "10367",
        "category": "Tech",
        "rss_url": "https://techcrunch.com/feed/",
        "rss_title": "TechCrunch",
        "rss_image_url": "https://techcrunch.com/wp-content/uploads/2015/02/cropped-cropped-favicon-gradient.png?w=32",
        "rss_description": "Startup and Technology News"
    },
    {
        "title": "ZDNet",
        "url": "http://www.zdnet.com/",
        "description": "Founded in 1991, Zdnet is a business technology news website that provides news, analysis, and research on the the latest IT trends, issues and events for the technology professionals.",
        "votes": "7342",
        "category": "Tech",
        "e": "Error: Invalid character in entity name\nLine: 21\nColumn: 92\nChar: ="
    },
    {
        "title": "Mashable",
        "url": "https://mashable.com/",
        "description": "Mashable is a global, multi-platform media and entertainment company. Powered by its own proprietary technology, Mashable is the go-to source for tech, digital culture and entertainment content for its dedicated and influential audience around the globe.",
        "votes": "7148",
        "category": "Tech",
        "rss_url": "http://feeds.mashable.com/Mashable",
        "rss_title": "Mashable",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Mashable is a leading source for news, information & resources for the Connected Generation. Mashable reports on the importance of digital\r\r\ninnovation and how it empowers and inspires people around the world. Mashable's 25 million monthly unique visitors and 10 million social\r\r\nmedia followers have become one of the most engaged online news communities. Founded in 2005, Mashable is headquartered in New York\r\r\nCity with an office in San Francisco."
    },
    {
        "title": "Gizmodo",
        "url": "https://gizmodo.com/",
        "description": "Originally launched as a part of Gawker Media Network, Gizmodo is a design, technology, science and science fiction website that also features articles on politics.",
        "votes": "7138",
        "category": "Tech",
        "rss_url": "https://gizmodo.com/rss",
        "rss_title": "Gizmodo",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Tech and Science Tips, Reviews, News And More."
    },
    {
        "title": "Ars Technica",
        "url": "https://arstechnica.com/",
        "description": "Founded by Ken Fisher in 1998, Arstechnica (Art of Technology) is devoted to the latest technology that would cater to what he called \"alpha geeks\": technologists and IT professionals.",
        "votes": "6988",
        "category": "Tech",
        "rss_url": "http://feeds.arstechnica.com/arstechnica/index/",
        "rss_title": "Ars Technica",
        "rss_image_url": "https://cdn.arstechnica.net/wp-content/uploads/2016/10/cropped-ars-logo-512_480-32x32.png",
        "rss_description": "Serving the Technologist for more than a decade. IT news, reviews, and analysis."
    },
    {
        "title": "VentureBeat",
        "url": "https://venturebeat.com/",
        "description": "Founded in 2006, VentureBeat is the leading source for news, events, groundbreaking research and perspective on technology innovation. The content and events covered provide a deep context to help executives, entrepreneurs, and tech enthusiasts make smart decisions.",
        "votes": "3849",
        "category": "Tech",
        "rss_url": "https://feeds.feedburner.com/venturebeat/SZYF",
        "rss_title": "VentureBeat",
        "rss_image_url": "https://venturebeat.com/wp-content/themes/vb-news/brand/img/logos/VB_Extended_Logo_40H.png",
        "rss_description": "Tech news that matters"
    },
    {
        "title": "Hacker Noon",
        "url": "https://hackernoon.com/",
        "description": "Hacker Noon covers a range of topics across the tech sector. From development and programming, to cryptocurrencies and blockchain.",
        "votes": "2936",
        "category": "Tech",
        "e": "Error: Invalid character in entity name\nLine: 0\nColumn: 3088\nChar: &"
    },
    {
        "title": "TechRepublic",
        "url": "https://www.techrepublic.com",
        "description": "TechRepublic helps IT decision-makers identify technologies and strategies to empower workers and streamline business processes.",
        "votes": "1989",
        "category": "Tech",
        "rss_url": "https://www.techrepublic.com/rssfeeds/articles/?feedType=rssfeeds&amp;sort=latest",
        "rss_title": "Articles on TechRepublic",
        "rss_image_url": "https://tr2.cbsistatic.com/fly/bundles/techrepubliccss/images/logo-tr-70x70.png",
        "rss_description": "Articles on TechRepublic"
    },
    {
        "title": "The Next Web",
        "url": "https://thenextweb.com/",
        "description": "TheNextWeb brings insights to the world of technology, internet of things, development, coding, infrastructure, security, cloud. The website also deals with TNW conference and events and market intelligence platforms.",
        "votes": "1731",
        "category": "Tech",
        "rss_url": "http://feeds2.feedburner.com/thenextweb",
        "rss_title": "The Next Web",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Original and proudly opinionated perspectives for Generation T"
    },
    {
        "title": "Android Authority",
        "url": "https://www.androidauthority.com/",
        "description": "With over 7 million followers on social sites, AndroidAuthority is the largest publication dedicated to the world's most widely used operating system. The site has a love of mobile technology and the determination to deliver top-notch content.",
        "votes": "1516",
        "category": "Tech",
        "e": "Error: Invalid character in entity name\nLine: 92\nColumn: 47\nChar: ="
    },
    {
        "title": "Mac Rumors",
        "url": "https://www.macrumors.com/",
        "description": "Founded and owned by Arnold Kim, MacRumors attracts a broad audience of both consumers and professionals interested in the latest technologies and products.",
        "votes": "1291",
        "category": "Tech",
        "rss_url": "http://feeds.macrumors.com/MacRumors-All",
        "rss_title": "MacRumors: Mac News and Rumors - All Stories",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Apple, iPhone, iPad, Mac News and Rumors"
    },
    {
        "title": "9to5Mac",
        "url": "https://9to5mac.com/",
        "description": "Founded by Seth Weintraub in 2007, 9to5Mac is the leading website within the Apple News Community in terms of breaking impactful news. The site also contains reviews for Apple products, apps, and industry rumors.",
        "votes": "1280",
        "category": "Tech",
        "rss_url": "https://9to5mac.com/feed/",
        "rss_title": "9to5Mac",
        "rss_image_url": "https://9to5mac.com/wp-content/uploads/sites/6/2017/03/mac1.png?w=32",
        "rss_description": "Apple News & Mac Rumors Breaking All Day"
    },
    {
        "title": "GeekWire",
        "url": "https://www.geekwire.com/",
        "description": "Started in 2011, Geekwire is the technology news site that has a large audience of loyal, tech-savvy readers around the globe, who follow the site for breaking news, expert analysis and unique insights into the technology industry.",
        "votes": "700",
        "category": "Tech",
        "rss_url": "https://www.geekwire.com/feed/",
        "rss_title": "GeekWire",
        "rss_image_url": "https://www.geekwire.com/wp-content/themes/geekwire/dist/images/geekwire-logo-rss.png",
        "rss_description": "Breaking News in Technology & Business"
    },
    {
        "title": "Computer World",
        "url": "https://www.computerworld.com/",
        "description": "Computerworld focuses on empowering enterprise users and their managers, helping them create a business advantage by skillfully exploiting today's abundantly powerful web, mobile, and desktop applications.",
        "votes": "668",
        "category": "Tech",
        "rss_url": "http://www.computerworld.com/index.rss",
        "rss_title": "Computerworld",
        "rss_image_url": "https://idge.staticworld.net/ctw/computerworld-logo_510x510.png",
        "rss_description": ""
    },
    {
        "title": "SlashGear",
        "url": "https://www.slashgear.com/",
        "description": "SlashGear covers everything from cutting-edge tech gear to the latest digital lifestyle trends. Distinctive, informative and fresh, they’ll keep bringing you device information and reviews you can trust as well as thought-provoking commentary.",
        "votes": "585",
        "category": "Tech",
        "rss_url": "https://www.slashgear.com/feed/",
        "rss_title": "SlashGear",
        "rss_image_url": "https://www.slashgear.com/apple-touch-icon.png",
        "rss_description": "The Definitive Guide to Tech and Cars"
    },
    {
        "title": "Android Central",
        "url": "https://www.androidcentral.com/",
        "description": "AndroidCentral is led by a team of experts and backed by an engaged community of technology enthusiasts and taste-makers, Android Central navigates the competitive and often confusing world of Android!",
        "votes": "522",
        "category": "Tech",
        "rss_url": "https://www.androidcentral.com/rss.xml",
        "rss_title": "Android Central - Android Forums, News, Reviews, Help and Android Wallpapers",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": ""
    },
    {
        "title": "Apple Insider",
        "url": "http://appleinsider.com/",
        "description": "Launched in 1998 as a news and rumor website for Apple products and services, appleinsider.com includes a forum for discussion of news stories and other community news.",
        "votes": "456",
        "category": "Tech",
        "e": "Error: Invalid character in entity name\nLine: 73\nColumn: 58\nChar: ="
    },
    {
        "title": "BGR",
        "url": "http://bgr.com",
        "description": "BGR is a leading online destination for news and reviews focused on the mobile and consumer electronics markets. It is America’s #1 source of exclusive and breaking mobile news, and a technology category leader among early adopters.",
        "votes": "420",
        "category": "Tech",
        "e": "Error: read ECONNRESET"
    },
    {
        "title": "SiliconANGLE",
        "url": "https://siliconangle.com/",
        "description": "SiliconAngle is a modern data driven digital media platform that creates authoritative & engaging social experiences for audiences by combining a depth of research, the reach of publishing, and the relevance of live video.",
        "votes": "387",
        "category": "Tech",
        "rss_url": "https://siliconangle.com/feed/",
        "rss_title": "SiliconANGLE",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Extracting the signal from the noise."
    },
    {
        "title": "TechSpot",
        "url": "https://www.techspot.com",
        "description": "Established in 1998 with over 6 million readers monthly, TechSpot is a leading computer and technology publication viewed by power users, tech enthusiasts, IT decision makers and gamers.",
        "votes": "373",
        "category": "Tech",
        "rss_url": "https://www.techspot.com/backend.xml",
        "rss_title": "TechSpot",
        "rss_image_url": "https://static.techspot.com/images/techspot-rss-logo-small2.png",
        "rss_description": "TechSpot News - All Stories"
    },
    {
        "title": "Techdirt.",
        "url": "https://www.techdirt.com/",
        "description": "Techdirt is an internet blog that reports on technology's legal challenges and related business and economic policy issues, in context of the digital revolution. It focuses on intellectual property, patent, information privacy and copyright reform in particular.",
        "votes": "358",
        "category": "Tech",
        "rss_url": "https://www.techdirt.com/techdirt_rss.xml",
        "rss_title": "Techdirt.",
        "rss_image_url": "https://ii.techdirt.com/s/t/i/td-88x31.gif",
        "rss_description": "Easily digestible tech news..."
    },
    {
        "title": "Information Week",
        "url": "https://informationweek.com/",
        "description": "InformationWeek is a dedicated website towards connecting the business technology community. InformationWeek defines the value of technology in the age of digital business.",
        "votes": "346",
        "category": "Tech",
        "rss_url": "https://www.informationweek.com/rss_simple.asp",
        "rss_title": "InformationWeek: ",
        "rss_image_url": "https://twimgs.com/nojitter/informationweek/resources/images/spacer.gif",
        "rss_description": "InformationWeek: Connecting the Business Technology Community"
    },
    {
        "title": "ReadWrite",
        "url": "https://readwrite.com/",
        "description": "A next generation of tech media, ReadWrite aggregates professional communities dedicated to specific subjects of interest such as connected cars, smart homes, AR/VR, fintech and APIs.",
        "votes": "272",
        "category": "Tech",
        "rss_url": "https://readwrite.com/feed/",
        "rss_title": "ReadWrite",
        "rss_image_url": "https://images.readwrite.com/wp-content/uploads/2018/03/cropped-rw-32x32.jpg",
        "rss_description": "The Blog of Things"
    },
    {
        "title": "TorrentFreak",
        "url": "https://torrentfreak.com",
        "description": "Founded by Ernesto Van Der Sar, TorrentFreak is a publication dedicated to latest news about copyright, privacy, and everything related to file-sharing.",
        "votes": "242",
        "category": "Tech",
        "rss_url": "https://feeds.feedburner.com/Torrentfreak",
        "rss_title": "TorrentFreak",
        "rss_image_url": "http://creativecommons.org/images/public/somerights20.gif",
        "rss_description": "Breaking File-sharing, Copyright and Privacy News"
    },
    {
        "title": "e27",
        "url": "https://e27.co/",
        "description": "E27 is a wonderful platform for news, community, events, talent, funding and more for tech startups. Everything needed to build a billion-dollar company is covered here.",
        "votes": "212",
        "category": "Tech",
        "e": "Error: Attribute without value\nLine: 89\nColumn: 14\nChar: >"
    },
    {
        "title": "Tech in Asia",
        "url": "https://www.techinasia.com",
        "description": "Tech in Asia is a media, events, and jobs platform on a mission to build and serve Asia’s tech and startup community. On the website users can keep abreast of the latest news, share your own thoughts, and find talent or jobs best suited to their needs.",
        "votes": "198",
        "category": "Tech",
        "e": "Error: Attribute without value\nLine: 0\nColumn: 45\nChar: i"
    },
    {
        "title": "Macworld",
        "url": "https://www.macworld.com",
        "description": "A website dedicated to products and software of Apple Inc. Macworld combines product reviews, valuable tips, and analysis of the latest news and developments.",
        "votes": "197",
        "category": "Tech",
        "rss_url": "http://www.macworld.com/index.rss",
        "rss_title": "Macworld",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": ""
    },
    {
        "title": "Extreme Tech",
        "url": "http://www.extremetech.com",
        "description": "ExtremeTech is the internet's top destination for news and analysis of emerging science and technology trends, and important software, hardware, and gadgets.",
        "votes": "190",
        "category": "Tech",
        "rss_url": "https://www.extremetech.com/feed",
        "rss_title": "ExtremeTechExtremeTech",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "ExtremeTech is the Web's top destination for news and analysis of emerging science and technology trends, and important software, hardware, and gadgets."
    },
    {
        "title": "Stratechery",
        "url": "https://stratechery.com/",
        "description": "Stratechery provides analysis of the strategy and business side of technology and media, and the impact of technology on society. Weekly Articles are free, while three daily updates per week are provided for subscribers only.",
        "votes": "155",
        "category": "Tech",
        "e": "Error: Invalid character in entity name\nLine: 43\nColumn: 433\nChar: &"
    },
    {
        "title": "TrustedReviews",
        "url": "http://www.trustedreviews.com/",
        "description": "TrustedReviews provides expert reviews of the latest consumer electronics, IT and computing products. As well as technology industry news, analysis and product launches.",
        "votes": "107",
        "category": "Tech",
        "e": "Error: Invalid character in tag name\nLine: 3\nColumn: 411\nChar: ;"
    },
    {
        "title": "Gigaom",
        "url": "https://gigaom.com",
        "description": "With over 6.5 million unique visitors each month, Gigoam take on the trends and tools that are shaping the economy of the 21st century, including Cloud, Data, Mobile, Work Futures, and the Internet of Things.",
        "votes": "34",
        "category": "Tech",
        "e": "Error: Attribute without value\nLine: 64\nColumn: 15\nChar: s"
    },
    {
        "title": "The Loop",
        "url": "http://www.loopinsight.com/",
        "description": "Filled with latest titbits of news about Apple and the tech market in general, LoopInsight also provides a more in-depth coverage on the topics that matter to you.",
        "votes": "31",
        "category": "Tech",
        "e": "Error: Unexpected close tag\nLine: 19\nColumn: 784\nChar: >"
    },
    {
        "title": "Pando",
        "url": "https://pando.com",
        "description": "Founded by Sarah Lacy, Pando is a web publication that offers technology news, analysis, and commentary, with a focus on Silicon Valley and startup companies.",
        "votes": "27",
        "category": "Tech",
        "e": "Error: Unexpected close tag\nLine: 85\nColumn: 9\nChar: >"
    },
    {
        "title": "TechNewsWorld",
        "url": "https://www.technewsworld.com/",
        "description": "Technewsworld provides important technology news, developments and trends with insightful analysis and commentary. Coverage includes hardware, software, networking, wireless computing, personal technology, security.",
        "votes": "17",
        "category": "Tech",
        "rss_url": "https://www.technewsworld.com/perl/syndication/rssfull.pl",
        "rss_title": "TechNewsWorld",
        "rss_image_url": "\n\t\thttp://www.technewsworld.com/images/rss/tnw_100x36.jpg\n\t\t",
        "rss_description": "TechNewsWorld -- \"All Tech, All the Time\""
    },
    {
        "title": "The Gadgeteer",
        "url": "https://the-gadgeteer.com/",
        "description": "Founded by Julie Strietelmeier, Gadgeteer provides news and reviews about latest smartphones, gadgets and geek toys. They also inform their readers about what it’s like to use the products.",
        "votes": "0",
        "category": "Tech",
        "rss_url": "https://the-gadgeteer.com/feed/",
        "rss_title": "The Gadgeteer",
        "rss_image_url": "https://the-gadgeteer.com/wp-content/uploads/2017/11/cropped-wp-icon-gadgeteer-logo-32x32.jpg",
        "rss_description": "Gadget news and reviews since 1997!"
    },
    {
        "title": "Boing Boing",
        "url": "https://boingboing.net/",
        "description": "Dubbing itself as a \"directory of wonderful things\", Boing Boing has been around as long as the internet itself.",
        "votes": "0",
        "category": "Tech",
        "rss_url": "https://boingboing.net/feed",
        "rss_title": "Boing Boing",
        "rss_image_url": "https://i0.wp.com/boingboing.net/wp-content/uploads/2018/04/apple-touch-icon-1.png?fit=32%2C32&ssl=1",
        "rss_description": "Brain candy for Happy Mutants"
    },
    {
        "title": "Recode",
        "url": "https://www.recode.net/",
        "description": "Owned by VOX media, Recode is a technology news website that focuses on the business of Silicon Valley. It provides the latest independent tech news, reviews and analysis from Recode with the most informed and respected journalists in technology and media.",
        "votes": "0",
        "category": "Tech",
        "rss_url": "https://www.recode.net/rss/index.xml",
        "rss_title": "Recode -  All",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media"
    },
    {
        "title": "Tech Commuters",
        "url": "https://www.techcommuters.com/",
        "description": "Tech Commuters is a leading information technology and data property that is run by tenured technology professionals. They are focused on applied information on a range of topics that impacts users across various technology fields.",
        "votes": "0",
        "category": "Tech",
        "e": "Error: Request timed out after 10000ms"
    },
    {
        "title": "PetaPixel",
        "url": "https://petapixel.com",
        "description": "",
        "votes": "1236",
        "category": "Photography",
        "rss_url": "https://feedproxy.google.com/PetaPixel",
        "rss_title": "PetaPixel",
        "rss_image_url": "https://petapixel.com/assets/images/largelogo.jpg",
        "rss_description": "Photography and Camera News, Reviews, and Inspiration"
    },
    {
        "title": "Fstoppers",
        "url": "https://fstoppers.com/",
        "description": "",
        "votes": "237",
        "category": "Photography",
        "e": "Error: unable to get local issuer certificate"
    },
    {
        "title": "Digital Photography Review",
        "url": "https://dpreview.com/",
        "description": "",
        "votes": "235",
        "category": "Photography",
        "e": "Error: Invalid character in entity name\nLine: 74\nColumn: 129\nChar: ="
    },
    {
        "title": "Digital Photography School",
        "url": "https://digital-photography-school.com",
        "description": "Founded by Darren Rowse of Problogger fame, Digital Photography School helps both beginner and advanced photographers get to grips with the techniques and tips they need.",
        "votes": "203",
        "category": "Photography",
        "e": "Error: Invalid character in entity name\nLine: 47\nColumn: 113\nChar: ="
    },
    {
        "title": "The Phoblographer",
        "url": "https://thephoblographer.com/",
        "description": "The Phoblographer has the tag line 'the psychology of creative photography'. The articles on here range in focus from debates on the digital/film divide to roundups of the latest creative trends.",
        "votes": "65",
        "category": "Photography",
        "e": "Error: Invalid character in entity name\nLine: 9\nColumn: 87\nChar: &"
    },
    {
        "title": "Expert Photography",
        "url": "https://expertphotography.com/",
        "description": "Expert Photography is a blog with a lot of tutorials, and a large and concise beginners section. How-to guides and listicles feature heavily.",
        "votes": "53",
        "category": "Photography",
        "e": "Error: Invalid character in tag name\nLine: 5\nColumn: 367\nChar: ;"
    },
    {
        "title": "Light Stalking",
        "url": "https://lightstalking.com/",
        "description": "",
        "votes": "51",
        "category": "Photography",
        "e": "Error: Invalid character in entity name\nLine: 1\nColumn: 433\nChar: &"
    },
    {
        "title": "Photo Focus",
        "url": "https://photofocus.com/",
        "description": "Photo Focus is a dedicated blog full of photography related articles. They set themselves apart from the crowd by having a popular 'business' section which contains info on how photographers can organise their business best.",
        "votes": "33",
        "category": "Photography",
        "rss_url": "https://photofocus.com/feed/",
        "rss_title": "Photofocus - Feed",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Education and inspiration for visual storytellers"
    },
    {
        "title": "1X",
        "url": "https://1x.com/blog",
        "description": "",
        "votes": "29",
        "category": "Photography",
        "e": "Error: unable to get local issuer certificate"
    },
    {
        "title": "Outdoor Photographer",
        "url": "https://outdoorphotographer.com/blog",
        "description": "Outdoor Photography offers the snap-happy community current news and technology reviews. Guest posts from professionals and a daily 'photo of the day' post keep this blog active and lively.",
        "votes": "29",
        "category": "Photography",
        "e": "Error: Invalid character in entity name\nLine: 7\nColumn: 433\nChar: &"
    },
    {
        "title": "Feature Shoot",
        "url": "https://featureshoot.com/",
        "description": "",
        "votes": "27",
        "category": "Photography",
        "e": "Error: Invalid character in entity name\nLine: 116\nColumn: 433\nChar: &"
    },
    {
        "title": "Photography Life",
        "url": "https://photographylife.com/",
        "description": "Photography Life offers professionals and amateurs alike a classic combination of photography news, tips, and reviews. The forum here is a popular resource for photographers and fans of photography.",
        "votes": "23",
        "category": "Photography",
        "rss_url": "https://photographylife.com/feed",
        "rss_title": "Photography Life",
        "rss_image_url": "https://photographylife.com/apple-touch-icon-114x114.png",
        "rss_description": "PL provides various digital photography news, reviews, articles, tips, tutorials and guides to photographers of all levels"
    },
    {
        "title": "ISO 1200",
        "url": "http://www.iso1200.com/",
        "description": "The ISO 1200 Blog is brought to you by Matt, a self-proclaimed \"BTS Search Guru\". They cover events, equipment reviews, and diverse topics in both digital and film photography.",
        "votes": "21",
        "category": "Photography",
        "rss_url": "http://www.iso1200.com/feeds/posts/default",
        "rss_title": "Blog Photography Tips - ISO 1200 Magazine",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Blog: Creative Photography for digital and film photographers. "
    },
    {
        "title": "Photo Shelter",
        "url": "https://blog.photoshelter.com/",
        "description": "PhotoShelter is an active blog from the image sharing and watermarking platform of the same name. Covering industry news, opinion pieces, and the popular 'who shot it better' posts, you won't struggle to find a good read here.",
        "votes": "19",
        "category": "Photography",
        "e": "Error: Invalid character in entity name\nLine: 1\nColumn: 433\nChar: &"
    },
    {
        "title": "A Photo Editor",
        "url": "http://aphotoeditor.com/",
        "description": "A Photo Editor (APE) is edited by Rob Haggart, the former Director of Photography for Men's Journal and Outside Magazine. The blog offers up resources such as an agent list and a photography consultant list.",
        "votes": "12",
        "category": "Photography",
        "rss_url": "http://aphotoeditor.com/feed/",
        "rss_title": "A Photo Editor",
        "rss_image_url": "http://aphotoeditor.com/wp-content/themes/inspirin/images/apple-touch-icon.png",
        "rss_description": "Former Photography Director Rob Haggart"
    },
    {
        "title": "Contrastly",
        "url": "https://contrastly.com/",
        "description": "Contrastly is an online magazine about photography as well as an online store providing premium Lightroom & ACR Presets, and Photoshop Actions. Founded in late-2012, Contrastly is a collaboration between a team of roughly 20 photographers, writers and experts from all around the world, covering a wide range of topics related to photography.",
        "votes": "12",
        "category": "Photography",
        "rss_url": "https://contrastly.com/feed/",
        "rss_title": "Contrastly",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Photography Tools & Resources"
    },
    {
        "title": "Camera Jabber",
        "url": "https://camerajabber.com",
        "description": "The Camera Jabber blog covers in-depth reviews of new equipment and accessories, photography news, and offers a large tips sections full of how-to's and technique guides.",
        "votes": "10",
        "category": "Photography",
        "rss_url": "https://camerajabber.com/feed/",
        "rss_title": "Camera Jabber",
        "rss_image_url": "https://i0.wp.com/camerajabber.com/wp-content/uploads/2016/08/CJ-logoSocial.jpg?fit=32%2C32&ssl=1",
        "rss_description": "The latest news, reviews, tutorials and everything photography"
    },
    {
        "title": "Skip Cohen University",
        "url": "https://skipcohenuniversity.com/",
        "description": "SCU is an online and live photo educational resource for emerging professional photographers. It's part of Marketing Essentials International, an educational and marketing consulting company founded by Skip Cohen. ",
        "votes": "9",
        "category": "Photography",
        "e": "Error: Invalid character in entity name\nLine: 2\nColumn: 73\nChar: ="
    },
    {
        "title": "121 Clicks",
        "url": "http://121clicks.com/",
        "description": "121 Clicks offers longer-form reporting and analysis of works by renowned, and up and coming, artists. They also showcase a few how-to videos and technical guides.",
        "votes": "8",
        "category": "Photography",
        "rss_url": "http://121clicks.com/feed",
        "rss_title": "121clicks.com",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Useful Information for Hobby and Professional Photographers."
    },
    {
        "title": "Lightroom Killer Tips",
        "url": "https://lightroomkillertips.com/",
        "description": "Brought to you by KelbyOne, the online educational community for Photoshop and Lightroom, Lightroom Killer Tips is just that, a blog dedicated to getting the most out of your editing and organisational software.",
        "votes": "8",
        "category": "Photography",
        "e": "Error: socket hang up"
    },
    {
        "title": "Fro Knows Photo",
        "url": "https://froknowsphoto.com/",
        "description": "Fro Knows Photo is brought to you by Jared Polin, the editor in chief. The blog offers an extensive tip section and many short and informative video clips.",
        "votes": "7",
        "category": "Photography",
        "e": "Error: Invalid character in entity name\nLine: 40\nColumn: 55\nChar: ="
    },
    {
        "title": "The Photo Argus",
        "url": "https://www.thephotoargus.com/",
        "description": "",
        "votes": "5",
        "category": "Photography",
        "rss_url": "https://www.thephotoargus.com/feed/",
        "rss_title": "The Photo Argus",
        "rss_image_url": "https://www.thephotoargus.com/wp-content/uploads/2018/06/cropped-tpa-1-3-32x32.png",
        "rss_description": "Photography Inspiration and Resources"
    },
    {
        "title": "Brendan’s Adventures",
        "url": "https://www.brendansadventures.com/",
        "description": "Brendan's Adventures is a blog that covers the travelogue and photography of Brendan van Son. Brendan features destination posts as well as gear reviews, how-tos, and common errors.",
        "votes": "5",
        "category": "Photography",
        "rss_url": "https://www.brendansadventures.com/feed/",
        "rss_title": "Brendan van Son Photography",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Travel Photography Blog by Brendan van Son"
    },
    {
        "title": "Photodoto",
        "url": "http://photodoto.com/",
        "description": "The Photodoto tag line is \"photography is for everyone\". On their blog the content offered is diverse and appeals to a wide spectrum of budding and established photographers alike.",
        "votes": "5",
        "category": "Photography",
        "e": "Error: Invalid character in entity name\nLine: 53\nColumn: 433\nChar: &"
    },
    {
        "title": "Joe Mcnally's Blog",
        "url": "http://www.blog.joemcnally.com/",
        "description": "Joe McNally's blog is the personal blog of the award-winning photographer of the same name. Joe covers topics in both photography and photojournalism.",
        "votes": "4",
        "category": "Photography",
        "e": "Error: Invalid character in entity name\nLine: 76\nColumn: 433\nChar: &"
    },
    {
        "title": "Strobist",
        "url": "https://strobist.blogspot.com/",
        "description": "Strobist is a popular blog dedicated to helping photographers up their strobe skills to the next level. Beginners will find plenty of info under the 'Lighting 101' category.",
        "votes": "4",
        "category": "Photography",
        "rss_url": "https://strobist.blogspot.com/feeds/posts/default",
        "rss_title": "Strobist",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Learn How to Light."
    },
    {
        "title": "Focus Camera",
        "url": "https://www.focuscamera.com/wavelength/",
        "description": "Focus Camera delivers top-notch tools and equipment to help creators and innovators take the next step in their creative careers. We offer comprehensive guides, videos, and reviews to direct and inspire a new generation of artists.",
        "votes": "4",
        "category": "Photography",
        "rss_url": "https://www.focuscamera.com/wavelength/feed/",
        "rss_title": "Focus Camera",
        "rss_image_url": "https://www.focuscamera.com/wavelength/wp-content/uploads/2019/01/wavelength-blog-favicon.png",
        "rss_description": "Helping creators and innovators take the next step in their creative careers"
    },
    {
        "title": "iPhone Photography School",
        "url": "https://iphonephotographyschool.com/blog",
        "description": "As the name suggests iPhone Photography School is a blog dedicated to helping iPhone photographers take the best picture possible on their smart phones. Budding photographers will find plenty of interest here.",
        "votes": "3",
        "category": "Photography",
        "e": "Error: Feed not recognized as RSS 1 or 2."
    },
    {
        "title": "Deposit Photos Blog",
        "url": "https://blog.depositphotos.com/",
        "description": "Depositphotos is a commercial platform that brings authors of high-quality licensed stock photos together with buyers. Their blog contains a lot of entries and covers a diverse range of topics, including how to make the most of their own platform.",
        "votes": "1",
        "category": "Photography",
        "e": "Error: Invalid character in entity name\nLine: 29\nColumn: 92\nChar: &"
    },
    {
        "title": "Scott Kelby",
        "url": "https://scottkelby.com/",
        "description": "The personal blog page of Scott Kelby, the CEO of the KelbyOne online community. Scott is a photographer, author, and the original \"photoshop guy\".",
        "votes": "1",
        "category": "Photography",
        "e": "Error: socket hang up"
    },
    {
        "title": "Loaded Landscapes",
        "url": "https://loadedlandscapes.com/blog",
        "description": "Loaded Landscapes is a blog dedicated to all things landscape photography. They offer up interviews with landscape photographers, technique guides, and a range of diverse articles.",
        "votes": "1",
        "category": "Photography",
        "rss_url": "https://loadedlandscapes.com/feed/",
        "rss_title": "Loaded Landscapes",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Landscape Photography Blog"
    },
    {
        "title": "Resource",
        "url": "http://resourcemagonline.com/",
        "description": "",
        "votes": "1",
        "category": "Photography",
        "rss_url": "http://resourcemagonline.com/feed/",
        "rss_title": "Resource",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Photo. Video. Lifestyle."
    },
    {
        "title": "Photography Blogger",
        "url": "https://photographyblogger.net/",
        "description": "Photography Blogger, or P/B, is dedicated to inspiration for creatives, full-length features, and photographer profiles. They also offer up reviews, freebies, and showcases.",
        "votes": "0",
        "category": "Photography",
        "e": "Error: certificate has expired"
    },
    {
        "title": "Photography Spark",
        "url": "http://photographyspark.com/blog",
        "description": "The Photography Spark blog focuses less on how to be a better photographer, and more on the fundamentals of photography as a business. A popular resource for aspiring pros.",
        "votes": "0",
        "category": "Photography",
        "e": "Error: Attribute without value\nLine: 0\nColumn: 4019\nChar: >"
    },
    {
        "title": "Photojojo",
        "url": "https://content.photojojo.com/",
        "description": "The Photojojo blog is brought to you by the company of the same name which sells funky accessories for smartphone photographers. The best content is under the headings #inspo and #DIY",
        "votes": "0",
        "category": "Photography",
        "e": "Error: Client network socket disconnected before secure TLS connection was established"
    },
    {
        "title": "DIY Photography",
        "url": "https://www.diyphotography.net/",
        "description": "DIY Photography covers a broad range of topics and photography concerns. The guides are geared towards smartphone photographers, digital users, and film users alike.",
        "votes": "0",
        "category": "Photography",
        "rss_url": "http://feeds.feedburner.com/Diyphotographynet",
        "rss_title": "DIYPhotography.net -Hacking Photography, One Picture At A Time",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "A home devoted to DIY, Photography and Lighting"
    },
    {
        "title": "Photography Bay",
        "url": "http://www.photographybay.com/",
        "description": "Photography Bay offers tips, industry news, and equipment reviews. They also cover photography accessories, software, and technique how-to's.",
        "votes": "0",
        "category": "Photography",
        "rss_url": "http://feeds.feedburner.com/PhotographyBay",
        "rss_title": "Photography Bay",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Digital Camera News, Reviews and Tips"
    },
    {
        "title": "Click It Up a Notch",
        "url": "https://clickitupanotch.com/",
        "description": "Founded by Courtney Slazinik, a 'momtographer', Click it up a Notch is a blog with a firm focus on helping home photographers make the most of their DSLR cameras.",
        "votes": "0",
        "category": "Photography",
        "rss_url": "https://clickitupanotch.com/feed/rss/",
        "rss_title": "Click it Up a Notch®",
        "rss_image_url": "https://clickitupanotch.com/wp-content/uploads/2017/01/cheatsheets_FBadB.png",
        "rss_description": "Photograph Your Family, Beautifully"
    },
    {
        "title": "Photech Pro",
        "url": "http://www.photechpro.com/",
        "description": "Photechpro is brought to you by Atma Anand Tiwari, a self-taught photographer who is a graphic designer and animator by trade. His blog covers DSLR news, reviews, and tips and techniques.",
        "votes": "0",
        "category": "Photography",
        "e": "Error: Invalid character in entity name\nLine: 28\nColumn: 433\nChar: &"
    },
    {
        "title": "Samy’s Camera Photo Blog",
        "url": "http://blog.samys.com/",
        "description": "This is the blog for Samy's Camera Store and Samy's Photo School. Topics range from news and events to tips and techniques. There is also a dedicated underwater photography section.",
        "votes": "0",
        "category": "Photography",
        "rss_url": "http://blog.samys.com/feed/",
        "rss_title": "Samy's Camera Photo Blog",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Camera and Photography News, Reviews, Tips and Tutorials"
    },
    {
        "title": "Advancing Your Photography",
        "url": "https://www.silberstudios.tv/dev/",
        "description": "Advancing Your Photography is a blog from the photographer and author Marc Silber. Topics covered include gear, composition, and technique guides.",
        "votes": "0",
        "category": "Photography",
        "e": "Error: Invalid character in entity name\nLine: 1\nColumn: 433\nChar: &"
    },
    {
        "title": "The Wandering Lens",
        "url": "https://www.thewanderinglens.com/",
        "description": "The Wandering Lens offers articles and how-tos on everything related to travel photography. There is also a 'location guide' section which travellers will find useful.",
        "votes": "0",
        "category": "Photography",
        "rss_url": "https://www.thewanderinglens.com/feed/",
        "rss_title": "The Wandering Lens – Travel Photography Guides",
        "rss_image_url": "https://www.thewanderinglens.com/wp-content/uploads/2017/09/cropped-olympus-housing-32x32.jpg",
        "rss_description": "Photo Tips and Travel Guides for Photographers - Photography Locations + Photogenic Experiences"
    },
    {
        "title": "Anton Gorlin",
        "url": "https://antongorlin.com/blog/",
        "description": "Photography tips, guides and inspiration from professional photographer, Anton Gorlin.",
        "votes": "0",
        "category": "Photography",
        "rss_url": "https://antongorlin.com/feed/",
        "rss_title": "Beautiful Pictures",
        "rss_image_url": "https://antongorlin.com/wp-content/uploads/2017/05/cropped-anton_gorlin_logo_simple_square-32x32.png",
        "rss_description": "Anton Gorlin Photography"
    },
    {
        "title": "The Fashion Camera",
        "url": "http://thefashioncamera.com/",
        "description": "As the name implies, The Fashion Camera is a blog dedicated to fashion photography in all its forms. Articles range from beginner level to more advanced topics.",
        "votes": "0",
        "category": "Photography",
        "e": "Error: Request timed out after 10000ms"
    },
    {
        "title": "Clickin Moms",
        "url": "https://clickinmoms.com/",
        "description": "The Clickin Moms blog aspires to help readers take \"better photos one day at a time\". The focus here is on family and home photography with a few pieces on editing and post-production, too.",
        "votes": "0",
        "category": "Photography",
        "e": "Error: Invalid character in entity name\nLine: 31\nColumn: 433\nChar: &"
    },
    {
        "title": "Photojaanic Photopreneur",
        "url": "https://www.photojaanic.com/blog/photopreneur",
        "description": "Photography is all about skills and creativity, and Photojaanic help you get what it takes to be a Photopreneur. Whether you’re a beginner, a hobbyist, or a semi-pro, our guides will help you learn everything about improving your photography skills and growing a photography business — in other words: becoming a Photopreneur.",
        "votes": "0",
        "category": "Photography",
        "rss_url": "https://www.photojaanic.com/blog/feed",
        "rss_title": "Photojaanic Blog",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Photography and Creative Resources"
    },
    {
        "title": "ShootProof",
        "url": "https://blog.shootproof.com",
        "description": "Based in Atlanta, the Shoot Proof blog is run by a team of photographers, designers, and engineers. With the focus firmly on photography as fun and inspiring, this blog has something for everyone.",
        "votes": "0",
        "category": "Photography",
        "e": "Error: Request timed out after 10000ms"
    },
    {
        "title": "Harvard Health Blog",
        "url": "https://www.health.harvard.edu/blog",
        "description": "Harvard Health Blog derives from Harvard medical school and helps the readers to stay healthy by providing advice on a full range of medical conditions and preventions.",
        "votes": "2602",
        "category": "Health",
        "e": "Error: Attribute without value\nLine: 66\nColumn: 66\nChar: >"
    },
    {
        "title": "WebMD",
        "url": "https://www.webmd.com/",
        "description": "WebMD aims to provide articles and videos that give the audience better information that can improve their lives, they cover topics such as health, fitness, drugs, and supplements.",
        "votes": "1851",
        "category": "Health",
        "rss_url": "https://rssfeeds.webmd.com/rss/rss.aspx?RSSSource=RSS_PUBLIC",
        "rss_title": "WebMD Health",
        "rss_image_url": "https://img.webmd.com/dtmcms/live/webmd/consumer_assets/site_images/logos/webmd/web/rss-webmd-logo.gif",
        "rss_description": "WebMD Health - Trustworthy, Credible and Timely Health Information. The content of this feed is confidential and proprietary. It may not be distributed, copied or otherwise reproduced without express written permission from WebMD."
    },
    {
        "title": "Medical News Today",
        "url": "https://www.medicalnewstoday.com/",
        "description": "Medical News Today provides real and practical advice to help the readers prevent illness and cure ailments through an abundance of articles on the site.",
        "votes": "1480",
        "category": "Health",
        "rss_url": "https://rss.medicalnewstoday.com/featurednews.xml",
        "rss_title": "Featured Health News from Medical News Today",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Latest featured health news - the top stories"
    },
    {
        "title": "mindbodygreen",
        "url": "https://www.mindbodygreen.com/",
        "description": "Mind Body Green uses articles and podcasts to share knowledge of mindfulness, food, movement and lifestyle topics.",
        "votes": "986",
        "category": "Health",
        "e": "Error: Invalid character in tag name\nLine: 3\nColumn: 697\nChar: ;"
    },
    {
        "title": "Mercola Natural Health",
        "url": "https://articles.mercola.com/sites/current.aspx",
        "description": "Mercola promotes natural health and fitness with easy to follow articles providing guidance on how to live a happier and healthier lifestyle.",
        "votes": "771",
        "category": "Health",
        "e": "Error: Status code 520"
    },
    {
        "title": "Authority Nutrition",
        "url": "https://www.healthline.com/nutrition",
        "description": "Healthline Nutrition provides daily articles about nutrition, weight loss and health, all based on scientific evidence.",
        "votes": "365",
        "category": "Health",
        "e": "Error: Unquoted attribute value\nLine: 1\nColumn: 11\nChar: p"
    },
    {
        "title": "Nutrition Facts",
        "url": "https://nutritionfacts.org/",
        "description": "Nutrition Facts helps the readers select a healthier diet on them through a series of articles, videos and podcast episodes, all of the information shared is based on scientific facts.",
        "votes": "278",
        "category": "Health",
        "e": "Error: Unencoded <\nLine: 160\nColumn: 3\nChar: #"
    },
    {
        "title": "Dr. Axe",
        "url": "https://draxe.com/",
        "description": "Dr. Axe releases content on a range of topics such as fitness, remedies, low carb diets, and health advice.",
        "votes": "239",
        "category": "Health",
        "rss_url": "https://draxe.com/feed/",
        "rss_title": "Dr. Axe",
        "rss_image_url": "https://draxe.com/wp-content/plugins/powerpress/rss_default.jpg",
        "rss_description": "Dr. Axe is a Certified Nutrition Specialist, expert in Natural Medicine, a speaker for Fortune 500 Companies (Nissan, Whole Foods) and a doctor of chiropractic."
    },
    {
        "title": "Diet Doctor",
        "url": "https://www.dietdoctor.com/",
        "description": "Diet Doctor is designed to provide the reader with information on low carb and keto diets, so that they are informed to lose healthy weight.",
        "votes": "236",
        "category": "Health",
        "e": "Error: Invalid character in entity name\nLine: 75\nColumn: 327\nChar: &"
    },
    {
        "title": "Wellness Mama",
        "url": "https://wellnessmama.com/",
        "description": "Wellness Mama gives it's audience simple answers to create healthier families whilst discussing health, remedies, recipes, and much more in their articles, books, and podcast episodes.",
        "votes": "134",
        "category": "Health",
        "rss_url": "https://wellnessmama.com/feed/",
        "rss_title": "Wellness Mama®",
        "rss_image_url": "https://wellnessmama.com/wp-content/uploads/cropped-Wellness-Mama-icon-80x80.png",
        "rss_description": "Simple Answers for Healthier Families"
    },
    {
        "title": "Chris Kresser",
        "url": "https://chriskresser.com/",
        "description": "Chris Kresser shares his expertise on a whole host of health and medical topics through articles on the site, he also offers private patient services.",
        "votes": "124",
        "category": "Health",
        "rss_url": "https://chriskresser.com/feed/",
        "rss_title": "Chris Kresser",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Reinvent Healthcare with Functional Medicine"
    },
    {
        "title": "Food Politics",
        "url": "https://www.foodpolitics.com/",
        "description": "Food Politics is a series of articles and publications focused on news, reviews and developments within the global world of food.",
        "votes": "64",
        "category": "Health",
        "e": "Error: Invalid character in entity name\nLine: 99\nColumn: 433\nChar: &"
    },
    {
        "title": "Examine",
        "url": "https://examine.com/",
        "description": "Examine helps it's audience to learn what work with regards to nutrition and supplements, by acting as an unbiased source. Their goal from day one has always been: read the research, make sense of it, and put it online. They're an education company that looks at the research — nothing more, nothing less.",
        "votes": "64",
        "category": "Health",
        "e": "Error: Invalid character in entity name\nLine: 3\nColumn: 252\nChar: ="
    },
    {
        "title": "Weighty Matters",
        "url": "http://www.weightymatters.ca/",
        "description": "Weighty Matters provides weight management advice, covering topics such as obesity and healthy eating.",
        "votes": "39",
        "category": "Health",
        "rss_url": "http://www.weightymatters.ca/feeds/posts/default",
        "rss_title": "Weighty Matters",
        "rss_image_url": "http://www.weightymatters.ca/favicon.ico",
        "rss_description": "Weighty Matters"
    },
    {
        "title": "Mark's Daily Apple",
        "url": "https://www.marksdailyapple.com/",
        "description": "Mark's Daily Apple helps people to understand the fundamentals of living a primal lifestyle, his teachings are shared in articles, a podcast and a community forum where they discuss diet, nutrition, and fitness.",
        "votes": "37",
        "category": "Health",
        "rss_url": "https://www.marksdailyapple.com/feed/",
        "rss_title": "Mark's Daily Apple",
        "rss_image_url": "http://dedtvgd3s2aq7.cloudfront.net/wp-content/uploads/2016/07/logo.jpg",
        "rss_description": ""
    },
    {
        "title": "Bulletproof",
        "url": "https://blog.bulletproof.com/",
        "description": "Whilst Bulletproof are known for their coffee, the site covers health, fitness, and workout advice for it's audience.",
        "votes": "35",
        "category": "Health",
        "e": "Error: Attribute without value\nLine: 21\nColumn: 91\nChar: >"
    },
    {
        "title": "Healthista",
        "url": "https://www.healthista.com/",
        "description": "Healthista wants to help their readers love themselves, though articles on topics such as health, fitness, recipes, diets, and more.",
        "votes": "24",
        "category": "Health",
        "rss_url": "https://www.healthista.com/feed/",
        "rss_title": "Healthista",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Love being you"
    },
    {
        "title": "Healthy. Happy. Life.",
        "url": "http://kblog.lunchboxbunch.com/",
        "description": "Healthy. Happy. Life. is a site by cookery author Kathy Patalsky, she provides in-depth videos and recipes with are all completely vegan.",
        "votes": "14",
        "category": "Health",
        "rss_url": "http://kblog.lunchboxbunch.com/feeds/posts/default",
        "rss_title": "Healthy. Happy. Life.",
        "rss_image_url": "http://kblog.lunchboxbunch.com/favicon.ico"
    },
    {
        "title": "The Paleo Solution",
        "url": "https://robbwolf.com/",
        "description": "Robb Wolf uses his podcast to provide revolutionary solutions to modern life, covering topics such as fitness, weight loss, and various diet reviews.",
        "votes": "11",
        "category": "Health",
        "rss_url": "https://robbwolf.com/feed/",
        "rss_title": "The Paleo Diet  – Robb Wolf on Paleolithic nutrition, intermittent fasting, and fitness",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "The Paleo Solution book and podcast"
    },
    {
        "title": "The Healthy Home",
        "url": "https://www.thehealthyhomeeconomist.com/",
        "description": "The Healthy Home Economist wants to help it's reader to embrace a healthier lifestyle with articles and books covering traditional diets and holistic health.",
        "votes": "10",
        "category": "Health",
        "rss_url": "https://www.thehealthyhomeeconomist.com/feed/",
        "rss_title": "The Healthy Home Economist",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": ""
    },
    {
        "title": "Selfhacked",
        "url": "https://selfhacked.com/",
        "description": "Selfhacked helps it's audience to life healthier lives by discussing nutrition, natural substances, biohacking science, and a range of conditions and the foods to avoid.",
        "votes": "10",
        "category": "Health",
        "rss_url": "https://selfhacked.com/feed/",
        "rss_title": "SelfHacked",
        "rss_image_url": "https://i0.wp.com/selfhacked.com/app/uploads/2019/04/cropped-SH-favicon_1024x1024.png?fit=32%2C32&ssl=1",
        "rss_description": "Cutting-Edge Solutions For a Better Life"
    },
    {
        "title": "Nom Nom Paleo",
        "url": "https://nomnompaleo.com/",
        "description": "Nom Nom Paleo is a resource of recipes, meal plans and cookbooks all related to the paleo diet. The information is shared through a series of articles and podcast episodes.",
        "votes": "9",
        "category": "Health",
        "rss_url": "https://nomnompaleo.com/feed",
        "rss_title": "Nom Nom Paleo®",
        "rss_image_url": "https://nomnompaleo.com/wp-content/uploads/2016/12/cropped-NomNomPaleoBlogIcon-32x32.png",
        "rss_description": "Paleo recipes and more from New York Times bestselling cookbook author Michelle Tam!"
    },
    {
        "title": "Black Girl's Guide to Weight Loss",
        "url": "https://blackgirlsguidetoweightloss.com/",
        "description": "Black Girl's Guide to Weight Loss covers one woman's quest for health, happiness, and healing, whilst inspiring others.",
        "votes": "9",
        "category": "Health",
        "e": "Error: Invalid character in entity name\nLine: 50\nColumn: 433\nChar: &"
    },
    {
        "title": "Kath Eats Real Food",
        "url": "https://www.katheats.com/",
        "description": "Kath Eats Real Food is a lifestyle and healthy food blog which gives wholesome, balanced and nutritious recipe ideas to it's readers.",
        "votes": "8",
        "category": "Health",
        "rss_url": "https://www.katheats.com/feed",
        "rss_title": "Kath Eats Real Food",
        "rss_image_url": "https://www.katheats.com/wp-content/uploads/2017/05/cropped-K-32x32.png",
        "rss_description": "a healthy food, nutrition, and lifestyle blog"
    },
    {
        "title": "Eating Bird Food",
        "url": "https://www.eatingbirdfood.com/",
        "description": "Eating Bird food covers workouts but mainly the creation of new recipes, it is designed to help the audience live happier and healthier lives.",
        "votes": "7",
        "category": "Health",
        "rss_url": "https://www.eatingbirdfood.com/feed/",
        "rss_title": "Eating Bird Food",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "A Healthy Food Blog"
    },
    {
        "title": "fANNEtastic food",
        "url": "https://www.fannetasticfood.com/",
        "description": "Fannetastic Food helps inspire others to lead happier, healthier live by understanding that being healthy doesn't have to be complicated, or indeed dull.",
        "votes": "7",
        "category": "Health",
        "rss_url": "https://www.fannetasticfood.com/feed/",
        "rss_title": "fANNEtastic food | Registered Dietitian Blog | Recipes + Healthy Living + Fitness",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Registered Dietitian blogging about healthy recipe creation, running, travel, and more."
    },
    {
        "title": "The Healthy Foodie",
        "url": "https://thehealthyfoodie.com/",
        "description": "The Healthy Foodie has set out to prove that eating healthily doesn't have to be boring by providing fun and nutritious recipes.",
        "votes": "6",
        "category": "Health",
        "e": "Error: Non-whitespace before first tag.\nLine: 0\nColumn: 1\nChar: \u001f"
    },
    {
        "title": "Fat-Burning Man",
        "url": "http://fatburningman.com/",
        "description": "Fat Burning Man is a blog and podcast designed to share methods of burning fat and building muscle, essentially highlighting their 'wild diet' programme.",
        "votes": "5",
        "category": "Health",
        "rss_url": "https://fatburningman.com/feed/",
        "rss_title": "Fat-Burning Man",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Paleo Podcast, Fast Fat Loss, Free Paleo Recipes, and the Fat-Burning Man Show from Abel James"
    },
    {
        "title": "Rawsome Vegan Life",
        "url": "http://www.thisrawsomeveganlife.com/",
        "description": "This Rawsome Vegan Life guides the readers through a vegan lifestyle in the form of easy to follow recipes, the author also has a range of vegan cookbooks.",
        "votes": "5",
        "category": "Health",
        "e": "Error: Malformed comment\nLine: 56\nColumn: 3\nChar: -"
    },
    {
        "title": "Jeanette's Healthy Living",
        "url": "http://jeanetteshealthyliving.com/",
        "description": "Jeanette's Healthy Living is a collection of recipes designed to be healthy and full or flavour, but also providing goodness to those on special diets or in need of strength.",
        "votes": "4",
        "category": "Health",
        "e": "Error: Non-whitespace before first tag.\nLine: 0\nColumn: 1\nChar: \u001f"
    },
    {
        "title": "Appetite for Health",
        "url": "http://appforhealth.com/",
        "description": "Apetite for Health is run by a pair of nutritionists who aim to help people lose weight, eat better and live healthier lives.",
        "votes": "4",
        "category": "Health",
        "rss_url": "http://appforhealth.com/feed/",
        "rss_title": "",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": ""
    },
    {
        "title": "Nutrition Stripped",
        "url": "https://nutritionstripped.com/",
        "description": "Nutrition Stripped makes it simple for the readers to live a whole life, eat well and feel amazing in the process, through informative articles on the site.",
        "votes": "3",
        "category": "Health",
        "e": "Error: Invalid character in entity name\nLine: 37\nColumn: 386\nChar: &"
    },
    {
        "title": "Danica's Daily",
        "url": "http://www.danicasdaily.com/",
        "description": "Danica's Daily is a source of inspiration to be healthy each and every day, through helpful and practical recipes shared on the site.",
        "votes": "2",
        "category": "Health",
        "e": "Error: Request timed out after 10000ms"
    },
    {
        "title": "Bodyrecomposition",
        "url": "https://www.bodyrecomposition.com/",
        "description": "Body Recomposition covers article topics such as fat loss, muscle gain, training, and nutrition.",
        "votes": "2",
        "category": "Health",
        "e": "Error: Attribute without value\nLine: 27\nColumn: 52\nChar: r"
    },
    {
        "title": "Diane Sanfilippo",
        "url": "https://balancedbites.com/",
        "description": "Balanced Bites is a resource creation to provide tools that allow people to have better nutrition, a healthier mindset and more control in their lives.",
        "votes": "1",
        "category": "Health",
        "rss_url": "https://balancedbites.com/feed/",
        "rss_title": "Balanced Bites",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Practical Paleo, The 21-Day Sugar Detox, The Balanced Bites Podcast, and more."
    },
    {
        "title": "A Nutritionist Eats",
        "url": "http://www.anutritionisteats.com/",
        "description": "A Nutritionist Eats focuses on helping you to create simple and nutritious, family friendly recipes, the founder, Emily, also offers private nutrition counselling.",
        "votes": "0",
        "category": "Health",
        "e": "Error: Request timed out after 10000ms"
    },
    {
        "title": "Daily Garnish",
        "url": "http://www.dailygarnish.com/",
        "description": "Daily Garnish provides very honest and practical, health and lifestyle articles covering a variety of themes.",
        "votes": "0",
        "category": "Health",
        "rss_url": "http://www.dailygarnish.com/feed",
        "rss_title": "Daily Garnish",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "A resource for healthy recipes, cooking tips, and inspiration for active living."
    },
    {
        "title": "Escape from Obesity",
        "url": "http://www.escapefromobesity.net/",
        "description": "Escape from Obesity covers a tale of weight loss and the lessons learnt, helping the readers to understand various recipes and weight loss programme habits.",
        "votes": "0",
        "category": "Health",
        "rss_url": "http://www.escapefromobesity.net/feeds/posts/default",
        "rss_title": "Escape from Obesity",
        "rss_image_url": "http://www.escapefromobesity.net/favicon.ico"
    },
    {
        "title": "One Twenty Five",
        "url": "http://one-twenty-five.tumblr.com/",
        "description": "One Twenty Five is a personal blog which covers the adventures of Liz, as she educates and shares her experiences of running, crossfit, food, and diet.",
        "votes": "0",
        "category": "Health",
        "e": "Error: read ECONNRESET"
    },
    {
        "title": "Gretchen, In-Between",
        "url": "http://www.gretcheninbetween.com/",
        "description": "Gretchen, In-Between is a very personal blog following Gretchen's journey through life, whilst discussing weight issues and introducing new recipes.",
        "votes": "0",
        "category": "Health",
        "rss_url": "http://www.gretcheninbetween.com/feed/",
        "rss_title": "Gretchen, In-Between",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Life, Liberty, and the Pursuit of Chicken Wings"
    },
    {
        "title": "The Amazing Adventures of Diet Girl",
        "url": "https://www.shaunareid.com/blog",
        "description": "ShaunaReid.com is a personal blog of the author as she shares her life experiences, she has also released a couple of books on dieting and running, suitable for all.",
        "votes": "0",
        "category": "Health",
        "e": "Error: Invalid character in entity name\nLine: 41\nColumn: 67\nChar: ="
    },
    {
        "title": "Curvy Yoga",
        "url": "https://www.curvyyoga.com/",
        "description": "Curvy Yoga is a yoga practise site with the intention of helping people feeling good about themselves both inside and out.",
        "votes": "0",
        "category": "Health",
        "e": "Error: Invalid character in entity name\nLine: 28\nColumn: 433\nChar: &"
    },
    {
        "title": "Tara Stiles",
        "url": "http://tarastiles.com/",
        "description": "Tara Stiles is a yoga training manual which covers all aspects of yoga, movement and healthy eating through a mixture of articles, videos, and books.",
        "votes": "0",
        "category": "Health",
        "rss_url": "http://tarastiles.com/feed/",
        "rss_title": "Tara Stiles",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": ""
    },
    {
        "title": "Stephanie Cuestra",
        "url": "https://www.stephcuesta.com/blog",
        "description": "Stephanie shares all aspects of her journey into health including her recent pregnancy updates.",
        "votes": "0",
        "category": "Health",
        "rss_url": "https://www.stephcuesta.com/blog?format=RSS",
        "rss_title": "Blog / Videos - Stephanie Cuesta",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Health &amp; Fitness Blog and Videos"
    },
    {
        "title": "A Healthy Slice of Life",
        "url": "https://www.ahealthysliceoflife.com/",
        "description": "A Healthy Slice of Life is a site about parenting, food and natural living. The author Brittany has also released a weaning book for her audience.",
        "votes": "0",
        "category": "Health",
        "rss_url": "https://www.ahealthysliceoflife.com/feed/",
        "rss_title": "A Healthy Slice of Life",
        "rss_image_url": "https://www.ahealthysliceoflife.com/wp-content/uploads/2018/09/AHS-Monogram-RGB-100x100.png",
        "rss_description": "Delicious recipes, healthy living tips, and fun food facts"
    },
    {
        "title": "Dan John",
        "url": "http://danjohn.net/",
        "description": "Dan John is a famous former Olympian know for both his lift and throwing, the site shares Dan's expertise on various aspects of training.",
        "votes": "0",
        "category": "Health",
        "rss_url": "http://danjohn.net/feed/",
        "rss_title": "Dan John",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "The Wide and Wonderful World of All Things Fitness"
    },
    {
        "title": "neverhomemaker",
        "url": "http://www.neverhomemaker.com/",
        "description": "Never Homemaker shares ideas on how to create a happy, healthy and natural home through lifestyle advice and the sharing of vegetarian and vegan recipes.",
        "votes": "0",
        "category": "Health",
        "rss_url": "http://www.neverhomemaker.com/feeds/posts/default",
        "rss_title": "neverhomemaker",
        "rss_image_url": "http://www.neverhomemaker.com/favicon.ico"
    },
    {
        "title": "Serious Eats",
        "url": "http://www.seriouseats.com/",
        "description": "Well-tested interesting recipes, food science, techniques, equipment, and even food histories. Also has a highly-rated podcast hosted by founder Ed Levine.",
        "votes": "367",
        "category": "Food",
        "e": "Error: Attribute without value\nLine: 53\nColumn: 119\nChar: >"
    },
    {
        "title": "Food52",
        "url": "https://food52.com/",
        "description": "Variety of recipes and cooking-related articles with a focus on thoughtful and stylish living. Many recipes have flavorful twists, and the site offers unique kitchenware for sale.",
        "votes": "321",
        "category": "Food",
        "rss_url": "https://food52.com/blog.rss",
        "rss_title": "Food52",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Eat thoughtfully, live joyfully."
    },
    {
        "title": "Kitchn",
        "url": "https://www.thekitchn.com/",
        "description": "Daily food magazine published by the founders of Apartment Therapy. Recipes, how-to, kitchen style, and shopping in an easy-to-navigate site.",
        "votes": "297",
        "category": "Food",
        "rss_url": "https://www.thekitchn.com/main.rss",
        "rss_title": "Kitchn | Inspiring cooks, nourishing homes",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Inspiring cooks, nourishing homes"
    },
    {
        "title": "smitten kitchen",
        "url": "https://smittenkitchen.com/",
        "description": "Variety of recipes for main meals, baking, drinks, and more. Recipes are made with accessible ingredients you can buy from your local store, and the site also has videos with owner and cookbook author Deb Perelman.",
        "votes": "97",
        "category": "Food",
        "rss_url": "https://smittenkitchen.com/feed/",
        "rss_title": "smitten kitchen",
        "rss_image_url": "https://smittenkitchendotcom.files.wordpress.com/2017/09/cropped-smitten-kitchen-logo_no_text.jpg?w=32",
        "rss_description": "Fearless cooking from a tiny NYC kitchen."
    },
    {
        "title": "Simply Recipes",
        "url": "http://www.simplyrecipes.com/",
        "description": "Primarily in-house developed recipes with seasonal ingredients, along with an archives of over 30 years’ worth of old family recipes. Most recipes use whole foods and are double-tested in real home kitchens.",
        "votes": "93",
        "category": "Food",
        "e": "Error: Invalid character in tag name\nLine: 10\nColumn: 281\nChar: ;"
    },
    {
        "title": "Minimalist Baker",
        "url": "https://minimalistbaker.com/",
        "description": "Elegant, flavorful recipes that are simple to make and mainly vegan and gluten-free. All recipes can be made in under 30 minutes, with one bowl, or with 10 ingredients.",
        "votes": "80",
        "category": "Food",
        "rss_url": "https://minimalistbaker.com/feed/",
        "rss_title": "Minimalist Baker",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Simple Food, Simply Delicious"
    },
    {
        "title": "Budget Bytes",
        "url": "https://www.budgetbytes.com/",
        "description": "Delicious, budget-friendly recipes with cost per recipe and per serving on each tempting image. Recipes are easy to follow, and the site has links to everything from one pot recipes to meal prep.",
        "votes": "57",
        "category": "Food",
        "rss_url": "https://www.budgetbytes.com/feed/",
        "rss_title": "Budget Bytes",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Delicious Recipes Designed for Small Budgets"
    },
    {
        "title": "Skinnytaste",
        "url": "https://www.skinnytaste.com/",
        "description": "Healthy dishes full of flavor with clear, flexible meal plans that have calorie counts and Weight Watchers Freestyle Smart Points. All meal plans are free and include grocery lists and brand recommendations.",
        "votes": "54",
        "category": "Food",
        "rss_url": "https://www.skinnytaste.com/feed/",
        "rss_title": "Skinnytaste",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Delicious Healthy Recipes Made with Real Food"
    },
    {
        "title": "Cookie and Kate",
        "url": "https://cookieandkate.com/",
        "description": "Fresh vegetarian recipes made with real food ingredients. Site has an easy layout with quick links for all categories at the top of the page.",
        "votes": "46",
        "category": "Food",
        "rss_url": "http://feeds.feedburner.com/CookieAndKate",
        "rss_title": "Cookie and Kate",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Whole Foods and Vegetarian Recipe Blog"
    },
    {
        "title": "David Lebovitz",
        "url": "https://www.davidlebovitz.com/",
        "description": "Professional cook, baker, and author David Lebovitz writes this food blog from Paris. Real, wholesome recipes that are accessible for home cooks.",
        "votes": "30",
        "category": "Food",
        "rss_url": "https://www.davidlebovitz.com/feed/",
        "rss_title": "David Lebovitz",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Paris based chef baking and writing cookbooks"
    },
    {
        "title": "Sallys Baking Addiction",
        "url": "https://sallysbakingaddiction.com/",
        "description": "All things baking with options to browse by category, season, or ingredient. Delicious-looking recipes and a baking basics series that covers techniques, tools, and tips.",
        "votes": "28",
        "category": "Food",
        "rss_url": "https://sallysbakingaddiction.com/feed/",
        "rss_title": "Sally's Baking Addiction",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Addictive Recipes from a Self-Taught Baker"
    },
    {
        "title": "Love and Lemons",
        "url": "https://www.loveandlemons.com/",
        "description": "Colorful recipes with seasonal food—often with a twist of lemon. Written by blogging couple Jeanine and Jack, who have also authored a well-received cookbook by the same name.",
        "votes": "25",
        "category": "Food",
        "rss_url": "https://www.loveandlemons.com/feed/",
        "rss_title": "Love and Lemons",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Healthy, Seasonal, Whole Food Recipes Blog"
    },
    {
        "title": "The Pioneer Woman",
        "url": "http://thepioneerwoman.com/",
        "description": "Farmer’s wife Ree has mastered tasty, easy cooking for families and big hungry crowds. Recipes have down-home cooking with modern twists and easy solutions for busy cooks.",
        "votes": "24",
        "category": "Food",
        "e": "Error: read ECONNRESET"
    },
    {
        "title": "Gimme Some Oven",
        "url": "https://www.gimmesomeoven.com/",
        "description": "Fresh, tasty food that’s easy to prepare. Also includes DIY section with lifestyle articles and a general interest blog.",
        "votes": "23",
        "category": "Food",
        "rss_url": "https://www.gimmesomeoven.com/feed/",
        "rss_title": "Gimme Some Oven",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Celebrating Delicious and Easy Recipes"
    },
    {
        "title": "How Sweet Eats",
        "url": "http://www.howsweeteats.com/",
        "description": "Delicious looking food by the author of Seriously Delish and The Pretty Dish (March release). Healthy recipes, comfort food, and a baby blog about life as a Mom.",
        "votes": "20",
        "category": "Food",
        "rss_url": "https://www.howsweeteats.com/feed/",
        "rss_title": "How Sweet Eats",
        "rss_image_url": "https://www.howsweeteats.com/wp-content/themes/howsweetitis3.0/favicon.ico",
        "rss_description": "For people who, like, totally love food."
    },
    {
        "title": "Pinch of Yum",
        "url": "https://pinchofyum.com/",
        "description": "Practical and interesting recipes, mainly vegetarian and lots of noodle dishes. Instant pot, crock pot, and short videos with adaptions for stove-top cooking.",
        "votes": "20",
        "category": "Food",
        "rss_url": "https://pinchofyum.com/feed",
        "rss_title": "Pinch of Yum",
        "rss_image_url": "https://pinchofyum.com/wp-content/uploads/cropped-Pinch-of-Yum-Favicon-512-32x32.png",
        "rss_description": "A food blog with simple and tasty recipes."
    },
    {
        "title": "Oh My Veggies",
        "url": "https://ohmyveggies.com/",
        "description": "The fruit and veggie dishes on this site will make you consider becoming vegetarian if you aren’t already. Potluck recipes, quick and easy dishes, and explanations and recipes about weird and wonderful vegetables.",
        "votes": "18",
        "category": "Food",
        "rss_url": "https://ohmyveggies.com/feed/",
        "rss_title": "Oh My Veggies",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "A Vegetarian Food Site"
    },
    {
        "title": "Our Best Bites",
        "url": "https://ourbestbites.com/",
        "description": "Home cooking for family and friends. Includes kid friendly recipes, a YouTube channel, and tips & tutorials.",
        "votes": "16",
        "category": "Food",
        "rss_url": "https://ourbestbites.com/feed/",
        "rss_title": "Our Best Bites",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Tips, Tricks, and Tastes from Two Real-Life Kitchens"
    },
    {
        "title": "101 Cookbooks",
        "url": "https://www.101cookbooks.com/",
        "description": "Vegetarian recipes with an entire section for instant pot recipes. New York Times bestselling author Heidi Swanson writes tasty recipes with natural foods.",
        "votes": "14",
        "category": "Food",
        "rss_url": "https://www.101cookbooks.com/feed",
        "rss_title": "101 Cookbooks",
        "rss_image_url": "https://www.101cookbooks.com/wp-content/uploads/2018/05/cropped-101fav-1-32x32.png",
        "rss_description": "When you own over 100 cookbooks, it is time to stop buying, and start cooking. This site chronicles a cookbook collection, one recipe at a time."
    },
    {
        "title": "Healthy. Happy. Life.",
        "url": "http://kblog.lunchboxbunch.com/",
        "description": "Vegan recipes, cookbooks, videos, and travel posts on this lifestyle blog. Kathy Patalsky is also the founder of the website Finding Vegan and has been featured across mainstream TV and online.",
        "votes": "13",
        "category": "Food",
        "rss_url": "http://kblog.lunchboxbunch.com/feeds/posts/default",
        "rss_title": "Healthy. Happy. Life.",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media"
    },
    {
        "title": "My Baking Addiction",
        "url": "https://www.mybakingaddiction.com/",
        "description": "Everything you ever wanted to know about baking and sweet recipes is here. Great how-to’s and some pretty impressive giveaways.",
        "votes": "13",
        "category": "Food",
        "rss_url": "https://www.mybakingaddiction.com/feed/",
        "rss_title": "My Baking Addiction",
        "rss_image_url": "https://www.mybakingaddiction.com/wp-content/themes/mybakingaddiction2017/favicon.ico",
        "rss_description": "My Baking Addiction..."
    },
    {
        "title": "Oh She Glows",
        "url": "http://ohsheglows.com/",
        "description": "Plant based food recipes, most of which are also gluten free, soy free, and without processed foods. Great FAQs section with practical answers to genuine reader questions about foods, substitutes, and where to source ingredients.",
        "votes": "12",
        "category": "Food",
        "e": "Error: Invalid character in entity name\nLine: 39\nColumn: 433\nChar: &"
    },
    {
        "title": "A Couple Cooks",
        "url": "https://www.acouplecooks.com/",
        "description": "Writer and photographer couple Sonja and Alex have paired up to share pretty, simple cooking online and in print. Their site has whole foods and delicious meals that are healthy and sustainable.",
        "votes": "11",
        "category": "Food",
        "rss_url": "https://www.acouplecooks.com/feed/",
        "rss_title": "A Couple Cooks",
        "rss_image_url": "https://ob8qxdtnu3-flywheel.netdna-ssl.com/wp-content/uploads/2018/09/2018_0818-Pretty-Simple-Dinner-343.jpg",
        "rss_description": "The food adventures of a married couple in Indianapolis. A food blog."
    },
    {
        "title": "Two Peas & Their Pod",
        "url": "https://www.twopeasandtheirpod.com/",
        "description": "Recipes, meal plans, lifestyle, and a cookie section with almost 200 cookie recipes. Features family-friendly cooking and meals.",
        "votes": "11",
        "category": "Food",
        "rss_url": "https://www.twopeasandtheirpod.com/feed/",
        "rss_title": "Two Peas & Their Pod",
        "rss_image_url": "https://www.twopeasandtheirpod.com/wp-content/uploads/2019/03/cropped-favicon-32x32.png",
        "rss_description": "Our kitchen is always open!"
    },
    {
        "title": "Spoon Fork Bacon",
        "url": "http://www.spoonforkbacon.com/",
        "description": "Delicious meals, side dishes, and sweets that may or may not have bacon in them. Excellent DIY section, and inspiring ideas for eating and entertaining.",
        "votes": "9",
        "category": "Food",
        "rss_url": "http://www.spoonforkbacon.com/feed/",
        "rss_title": "Spoon Fork Bacon",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": ""
    },
    {
        "title": "Brown Eyed Baker",
        "url": "https://www.browneyedbaker.com/",
        "description": "Mostly cooking from scratch, Michelle share recipes for everything from dips to desserts. Links to a variety of shopping portals as well as Baking 101 and videos.",
        "votes": "9",
        "category": "Food",
        "rss_url": "https://www.browneyedbaker.com/feed/",
        "rss_title": "Brown Eyed Baker",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "A food blog with easy, decadent recipes."
    },
    {
        "title": "Alexandra's Kitchen",
        "url": "http://alexandracooks.com/",
        "description": "Seasonal cooking and beautiful looking meals. Alexandra loves cooking everything from scratch including salad dressings, stocks, and beans and legumes.",
        "votes": "9",
        "category": "Food",
        "e": "Error: Non-whitespace before first tag.\nLine: 0\nColumn: 1\nChar: \u001f"
    },
    {
        "title": "Steamy Kitchen",
        "url": "https://steamykitchen.com/",
        "description": "Television chef, recipe developer, and cookbook author Jaden Hair runs this blog on cooking shortcuts, product reviews, and recipes. The site is also a good source for a variety of authentic Asian recipes.",
        "votes": "7",
        "category": "Food",
        "rss_url": "https://steamykitchen.com/feed",
        "rss_title": "Steamy Kitchen Recipes",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Steamy Kitchen: fast recipes, simple recipes, with fresh ingredients to create delicious meals."
    },
    {
        "title": "Molly Yeh",
        "url": "http://mynameisyeh.com/",
        "description": "Molly’s blog is a reflection of her life as a Jewish, Asian, and now Midwestern farmer’s wife. She’s also a Juilliard-trained musician which may make her site the only one with a theme song…",
        "votes": "7",
        "category": "Food",
        "rss_url": "http://mynameisyeh.com/mynameisyeh?format=RSS",
        "rss_title": "molly yeh",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": ""
    },
    {
        "title": "Love & Olive Oil",
        "url": "https://www.loveandoliveoil.com/",
        "description": "Quick, flavorful, and interesting dishes that are designed to be budget friendly. These bloggers have had three cookbooks published that show their wide-ranging food interests such as Breakfast for Dinner and That’s My Jam.",
        "votes": "5",
        "category": "Food",
        "rss_url": "https://www.loveandoliveoil.com/feed",
        "rss_title": "Love and Olive Oil",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Eat to Live. Cook to Love."
    },
    {
        "title": "Sprinkle Bakes",
        "url": "http://www.sprinklebakes.com/",
        "description": "Heather’s site is overflowing with amazing desserts that look too good to be true. She’s brought a background in art to her passion for baking and the combination is baked to perfection.",
        "votes": "4",
        "category": "Food",
        "e": "Error: Invalid character in entity name\nLine: 102\nColumn: 111\nChar: ="
    },
    {
        "title": "BitterSweet",
        "url": "https://bittersweetblog.com/",
        "description": "Enjoying the sweetness of crafts and baking in a sometimes bitter world. Vegan baking (and ice cream!), and free patterns in the craft section.",
        "votes": "4",
        "category": "Food",
        "rss_url": "https://bittersweetblog.com/feed/",
        "rss_title": "BitterSweet",
        "rss_image_url": "https://en.wordpress.com/i/webclip.png",
        "rss_description": "Sweet Musings with a Bitterly Sharp Wit"
    },
    {
        "title": "Joy the Baker",
        "url": "http://joythebaker.com/",
        "description": "Baker, food photographer, and cookbook author Joy inspires with a site full of delicious baking. Easy to follow recipes make all her desserts seem possible, and the hints and tips are valuable extras.",
        "votes": "4",
        "category": "Food",
        "e": "Error: Attribute without value\nLine: 2\nColumn: 17\nChar: i"
    },
    {
        "title": "Chocolate & Zucchini",
        "url": "https://cnz.to/",
        "description": "French food writer Clotilde Dusoulier celebrates the joys of daily cooking with fresh, easy ideas. Clothilde loves healthy, natural foods and easy meals that everyone will enjoy.",
        "votes": "3",
        "category": "Food",
        "rss_url": "https://cnz.to/feed/",
        "rss_title": "Chocolate & Zucchini",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Simple Recipes from my Paris Kitchen"
    },
    {
        "title": "BakersRoyale",
        "url": "http://www.bakersroyale.com/",
        "description": "Recipes for baking and cooking with a cocktail for every occasion on the side. Categories also include sweet, savory, and holiday recipes.",
        "votes": "3",
        "category": "Food",
        "e": "Error: Unexpected close tag\nLine: 0\nColumn: 252\nChar: >"
    },
    {
        "title": "Alton Brown",
        "url": "http://altonbrown.com/",
        "description": "Alton Brown is the host of the Food Network’s Good Eats, Iron Chef America, and Cutthroat Kitchen. The site has recipes, ‘how to’s with great diagrams, videos, podcasts, and tickets to his Eat Your Science shows.",
        "votes": "3",
        "category": "Food",
        "e": "Error: Attribute without value\nLine: 0\nColumn: 680\nChar: i"
    },
    {
        "title": "My New Roots",
        "url": "https://www.mynewroots.org/site/",
        "description": "Holisitic eating is made simple, tasty, and approachable with Sarah’s recipes and explanations. She has recipes for every occasion, along with events, videos, and an app.",
        "votes": "3",
        "category": "Food",
        "rss_url": "https://www.mynewroots.org/site/feed/",
        "rss_title": "My New Roots",
        "rss_image_url": "https://www.mynewroots.org/site/wp-content/uploads/fbrfg/favicon.ico?v=A0024PXGbb",
        "rss_description": "How to make healthy choices every day"
    },
    {
        "title": "Homesick Texan",
        "url": "http://www.homesicktexan.com/",
        "description": "Texas-infused cooking from James Beard Award-winning writer Lisa Fain. Now a New Yorker, Lisa’s recipes are spicy, delicious, and straight from the Lone Star State.",
        "votes": "2",
        "category": "Food",
        "e": "Error: read ECONNRESET"
    },
    {
        "title": "Delicieux",
        "url": "https://www.deliciouseveryday.com/",
        "description": "Vegetarian and vegan cooking made with fresh, whole ingredients. A good variety of everything from beverages to meals to desserts.",
        "votes": "2",
        "category": "Food",
        "rss_url": "https://feeds.feedblitz.com/deliciouseveryday",
        "rss_title": "Delicious Everyday",
        "rss_image_url": "https://users.feedblitz.com/a3767bf28528093db6087f5b31ad2a22/DeliciousEveryday_300dpi.jpg",
        "rss_description": "Vegetarian recipes for every day"
    },
    {
        "title": "Bakerella",
        "url": "http://www.bakerella.com/",
        "description": "Bakerella details some incredibly imaginative and fun easy baking ideas. There are also a range of books and kits available to buy.",
        "votes": "2",
        "category": "Food",
        "rss_url": "http://www.bakerella.com/feed/",
        "rss_title": "bakerella.com",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": ""
    },
    {
        "title": "Baking Bites",
        "url": "http://bakingbites.com/",
        "description": "All things baking, from the simple to the fanciful. Blogger Nicole is also a pastry chef, food writer, and culinary judge.",
        "votes": "1",
        "category": "Food",
        "e": "Error: Status code 503"
    },
    {
        "title": "Vegalicious Recipes",
        "url": "http://vegalicious.recipes/",
        "description": "Vegalicious Recipes provides a huge amount of vegan meal recipes, as well cooking inspiration eBooks.",
        "votes": "1",
        "category": "Food",
        "e": "Error: Unexpected close tag\nLine: 136\nColumn: 11\nChar: >"
    },
    {
        "title": "Green Kitchen Stories",
        "url": "http://www.greenkitchenstories.com/",
        "description": "David and Luise bring healthy and simple vegetarian food to a site full of Instagram worthy food photos. Their recent book Green Kitchen At Home features great recipes from the site that have ingredients that are accessible and non-vegetarian friendly.",
        "votes": "1",
        "category": "Food",
        "e": "Error: read ECONNRESET"
    },
    {
        "title": "Pastry Affair",
        "url": "http://www.pastryaffair.com/",
        "description": "Recipes for the home baker that give space for rough edges with lots of butter and sugar. Diverse selection of bread & yeast recipes along with hundreds of choices for sweet starts and finishes.",
        "votes": "1",
        "category": "Food",
        "e": "Error: Attribute without value\nLine: 1\nColumn: 164\nChar: i"
    },
    {
        "title": "Sprouted Kitchen",
        "url": "https://www.sproutedkitchen.com/",
        "description": "Sprouted Kitchen is a series of family recipe ideas and inspiration, the site also supplies a food photography workshop.",
        "votes": "0",
        "category": "Food",
        "rss_url": "https://www.sproutedkitchen.com/home?format=RSS",
        "rss_title": "Sprouted Kitchen",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": ""
    },
    {
        "title": "Bake at 350",
        "url": "http://www.bakeat350.net/",
        "description": "BakeAt350 presents it's readers with innovative and quirky baking and decorating design ideas,",
        "votes": "0",
        "category": "Food",
        "rss_url": "http://www.bakeat350.net/feeds/posts/default",
        "rss_title": "Bake at 350°",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media"
    },
    {
        "title": "EatMee",
        "url": "http://eatmeerecipes.co.za/",
        "description": "A variety of flavorful dishes that will have you cooking like a pro. Rated 2017 Runner Up on South African Blog Awards.",
        "votes": "0",
        "category": "Food",
        "e": "Error: Attribute without value\nLine: 5\nColumn: 16\nChar: s"
    },
    {
        "title": "A Sweet Spoonful",
        "url": "http://asweetspoonful.com/",
        "description": "Site for seasonal cooking and casual entertaining. The creator of Marge granola, Megan also writes about wholegrain baking.",
        "votes": "0",
        "category": "Food",
        "e": "Error: Invalid character in entity name\nLine: 0\nColumn: 416\nChar: &"
    },
    {
        "title": "The Healthy Apron",
        "url": "https://www.thehealthyapron.com/",
        "description": "As a former line cook with interest in cooking and health, Erin wanted to create a place that provides reliable, accurate, up-to-date information with a realistic approach to health, nutrition, fitness, well-being and above all…FOOD!",
        "votes": "0",
        "category": "Food",
        "rss_url": "https://www.thehealthyapron.com/feed/",
        "rss_title": "The Healthy Apron",
        "rss_image_url": "https://www.thehealthyapron.com/wp-content/uploads/2016/11/cropped-apron-book-150x150.png",
        "rss_description": "Reliable, Accurate and Trustworthy Articles About Health, Fitness and Nutrition"
    },
    {
        "title": "In Jennie's Kitchen",
        "url": "https://www.injennieskitchen.com/",
        "description": "A former restauranteur and cook, Jennie believes food holds the busy-ness of life together. Her site has recipes, food-inspired DIY, and a weekly gratitude journal.",
        "votes": "0",
        "category": "Food",
        "rss_url": "https://www.injennieskitchen.com/feed/",
        "rss_title": "In Jennie's Kitchen",
        "rss_image_url": "https://www.injennieskitchen.com/wp-content/uploads/2016/05/cropped-ijk-favicon-1.png",
        "rss_description": "Meals made easier, one recipe at a time"
    },
    {
        "title": "Muscle and Fitness",
        "url": "https://www.muscleandfitness.com/",
        "description": "Muscle and Fitness provides it's readers with practical workout and nutrition advice that they can follow to get in better shape.",
        "votes": "219",
        "category": "Fitness",
        "rss_url": "https://www.muscleandfitness.com/rss.xml",
        "rss_title": "Muscle & Fitness",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": ""
    },
    {
        "title": "Runtastic",
        "url": "https://www.runtastic.com/blog/en",
        "description": "The Runtastic blog covers aspects of health, fitness, nutrition and weight-loss through it's detailed articles and mobile phone apps.",
        "votes": "68",
        "category": "Fitness",
        "e": "Error: Invalid character in entity name\nLine: 3\nColumn: 955\nChar: ="
    },
    {
        "title": "Fit Bottomed Girls",
        "url": "http://fitbottomedgirls.com/",
        "description": "Fit Bottomed Girls provides articles on podcasts featuring health information and workout advice, the site also features fat-loss coaching.",
        "votes": "34",
        "category": "Fitness",
        "e": "Error: Unquoted attribute value\nLine: 0\nColumn: 27\nChar: e"
    },
    {
        "title": "Breaking Muscle",
        "url": "https://breakingmuscle.com/",
        "description": "BreakingMuscle provides advice and information on fitness, workouts and healthy eating, as well as selling coaching tutorials.",
        "votes": "31",
        "category": "Fitness",
        "rss_url": "https://breakingmuscle.com/feed/rss",
        "rss_title": "Breaking Muscle",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": ""
    },
    {
        "title": "Nerd Fitness",
        "url": "https://www.nerdfitness.com/",
        "description": "Nerd Fitness provides both personalised coaching and a community to help it's members to lose weight, gain strength and become healthier.",
        "votes": "29",
        "category": "Fitness",
        "e": "Error: Unexpected close tag\nLine: 79\nColumn: 7\nChar: >"
    },
    {
        "title": "Ben Greenfield Fitness",
        "url": "https://bengreenfieldfitness.com/",
        "description": "Ben Greenfield Fitness provides advice and information across all aspects of fitness, the site supplies coaching, supplements and gear for sale.",
        "votes": "28",
        "category": "Fitness",
        "rss_url": "https://bengreenfieldfitness.com/feed/",
        "rss_title": "Ben Greenfield Fitness – Diet, Fat Loss and Performance Advice",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Performance, nutrition, fat loss, biohacking, weight lifting, obstacle racing and triathlon advice."
    },
    {
        "title": "Born Fitness",
        "url": "https://www.bornfitness.com/",
        "description": "Born Fitness is a resource of fitness and nutrition knowledge, the site also offers its own coaching programme.",
        "votes": "16",
        "category": "Fitness",
        "rss_url": "https://www.bornfitness.com/feed/",
        "rss_title": "Born Fitness",
        "rss_image_url": "https://i0.wp.com/www.bornfitness.com/wp-content/uploads/2017/10/cropped-BF_Square2.jpg?fit=32%2C32&ssl=1",
        "rss_description": "The Rules of Fitness REBORN"
    },
    {
        "title": "No Meat Athlete",
        "url": "http://www.nomeatathlete.com/",
        "description": "No Meat Athlete explains how you can get enough protein, burn fat and build muscle without the need for meat.",
        "votes": "14",
        "category": "Fitness",
        "e": "Error: Invalid character in entity name\nLine: 39\nColumn: 433\nChar: &"
    },
    {
        "title": "The Fitnessista",
        "url": "https://fitnessista.com/",
        "description": "The Fitnessista offers information and guidance on fitness, recipes, family and lifestyle through a range of books and online articles.",
        "votes": "14",
        "category": "Fitness",
        "rss_url": "https://fitnessista.com/feed/",
        "rss_title": "The Fitnessista",
        "rss_image_url": "https://fitnessista.com/wp-content/uploads//2017/01/cropped-site-identity-32x32.jpg",
        "rss_description": "At-Home Workouts, Fitness Plans and Healthy Living Tips"
    },
    {
        "title": "Fitbit Blog",
        "url": "https://blog.fitbit.com/",
        "description": "Fitbit.com provides advice, help and inspiration for those looking to reach fitness and health goals, the site also supplies it's own Fitbit products.",
        "votes": "13",
        "category": "Fitness",
        "rss_url": "https://blog.fitbit.com/feed/",
        "rss_title": "Fitbit Blog",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Follow the Fitbit blog for individual success stories, expert fitness tips, health and nutrition advice, product announcements, motivation and more."
    },
    {
        "title": "Get Healthy U",
        "url": "https://gethealthyu.com/",
        "description": "Get Healthy U provides guides on how to maintain a happy and healthy life, as well as having an E-Course for it's audience to improve their health.",
        "votes": "12",
        "category": "Fitness",
        "rss_url": "https://gethealthyu.com/feed/",
        "rss_title": "Get Healthy U | Chris Freytag",
        "rss_image_url": "https://gethealthyu.com/wp-content/uploads/2017/03/cropped-GREEN_GHULogoCircle-32x32.png",
        "rss_description": ""
    },
    {
        "title": "The Paleo Solution",
        "url": "https://robbwolf.com/",
        "description": "Robb Wolf offers revolutionary solutions to modern life through his podcast on topics such as diet, fitness, weight-loss and health.",
        "votes": "9",
        "category": "Fitness",
        "rss_url": "https://robbwolf.com/feed/",
        "rss_title": "The Paleo Diet  – Robb Wolf on Paleolithic nutrition, intermittent fasting, and fitness",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "The Paleo Solution book and podcast"
    },
    {
        "title": "Tony Gentilcore",
        "url": "http://tonygentilcore.com/",
        "description": "Tony Gentilcore teaches people how to increase their physical capabilities through articles on the site, coaching and programmes he offers and a number of products for sale.",
        "votes": "9",
        "category": "Fitness",
        "e": "Error: Invalid character in entity name\nLine: 52\nColumn: 433\nChar: &"
    },
    {
        "title": "Blogilates",
        "url": "http://www.blogilates.com/",
        "description": "Blogilates is a fun and innovative exercise site featuring various workouts, food advice and a clothing range.",
        "votes": "8",
        "category": "Fitness",
        "e": "Error: Invalid character in entity name\nLine: 17\nColumn: 382\nChar: &"
    },
    {
        "title": "Life by Daily Burn",
        "url": "http://dailyburn.com/life/",
        "description": "Daily Burn helps it's audience to eat healthier and become fitter with a series of guides and tutorials.",
        "votes": "8",
        "category": "Fitness",
        "e": "Error: Invalid character in entity name\nLine: 179\nColumn: 433\nChar: &"
    },
    {
        "title": "Muscle for Life",
        "url": "https://www.muscleforlife.com/",
        "description": "Muscle For Life shares articles and podcasts on building muscle and burning fat, they also provide custom coaching and meal plans.",
        "votes": "8",
        "category": "Fitness",
        "e": "Error: Attribute without value\nLine: 0\nColumn: 125\nChar: i"
    },
    {
        "title": "Run Eat Repeat",
        "url": "http://runeatrepeat.com/",
        "description": "Run Eat Repeat is a site which covers running, recipes, weight loss and lifestyle topics through it's articles and podcast series.",
        "votes": "6",
        "category": "Fitness",
        "e": "Error: Invalid character in entity name\nLine: 41\nColumn: 82\nChar: ="
    },
    {
        "title": "12 Minute Athlete",
        "url": "https://www.12minuteathlete.com/",
        "description": "12 Minute Athlete is a HIIT workout site which provides it's own exercise app and fitness equipment.",
        "votes": "6",
        "category": "Fitness",
        "rss_url": "https://www.12minuteathlete.com/feed/",
        "rss_title": "12 Minute Athlete",
        "rss_image_url": "https://www.12minuteathlete.com/wp-content/uploads/2018/03/12Mfavicon.png",
        "rss_description": "Unlock Your Potential"
    },
    {
        "title": "Roman Fitness Systems",
        "url": "http://romanfitnesssystems.com/",
        "description": "Roman Fitness Systems teaches people to build strength and muscle through their various books, coaching and programmes.",
        "votes": "4",
        "category": "Fitness",
        "rss_url": "http://romanfitnesssystems.com/home/feed/",
        "rss_title": "\n\tComments on: Home\t",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Filling Your Daily Quota of Fitness Info, Movie Quotes, and Sexual Innuendo"
    },
    {
        "title": "Ali On The Run",
        "url": "http://www.aliontherunblog.com/",
        "description": "Ali On The Run is a running related podcast featuring interviews with influential industry experts, the shows link out to products discussed in the episodes.",
        "votes": "4",
        "category": "Fitness",
        "rss_url": "http://feeds.feedburner.com/AliOnTheRun",
        "rss_title": "Ali On The Run",
        "rss_image_url": "http://www.aliontherunblog.com/wp-content/uploads/2017/01/cropped-Ali-On-The-Run-32x32.jpg",
        "rss_description": ""
    },
    {
        "title": "Preppy Runner",
        "url": "https://preppyrunner.com/",
        "description": "Preppy Runner shows it's audience how to live a healthy and active life, whilst sharing issues of weight and mental health. Running coaching is also offered through the site.",
        "votes": "3",
        "category": "Fitness",
        "rss_url": "https://preppyrunner.com/feed/",
        "rss_title": "Preppy Runner",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Run coach dealing with mental health one workout at a time!"
    },
    {
        "title": "Comeback Momma",
        "url": "https://www.comebackmomma.com/",
        "description": "CombackMomma provides inspiration for a happy and healthy life through articles on health, fitness, food and so much more.",
        "votes": "3",
        "category": "Fitness",
        "rss_url": "https://www.comebackmomma.com/feed/",
        "rss_title": "Comeback Momma",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "A Lifestyle Blog About Family, Travel and Healthy Living"
    },
    {
        "title": "Dai Manuel",
        "url": "https://www.daimanuel.com/",
        "description": "Dai Manuel is a lifestyle mentor who bases his teachings on fun, fitness, family, faith and finances. He offers a coaching programme for his readers.",
        "votes": "3",
        "category": "Fitness",
        "rss_url": "https://www.daimanuel.com/feed/",
        "rss_title": "Dai Manuel: Your Lifestyle Mentor",
        "rss_image_url": "https://www.daimanuel.com/wp-content/uploads/2017/01/DAIMANUEL.COM_.png",
        "rss_description": "Dai Manuel helps people be functionally fit and live a life that they are proud of"
    },
    {
        "title": "Scooby's Home Workouts",
        "url": "http://scoobysworkshop.com/",
        "description": "Scooby's Workshop provides guides on exercises, weight-loss and nutrition whilst also providing tools and a forum to help you on your journey.",
        "votes": "2",
        "category": "Fitness",
        "rss_url": "http://scoobysworkshop.com/feed/",
        "rss_title": "Scooby's Home Workouts",
        "rss_image_url": "http://scoobysworkshop.com/wp-content/uploads/2016/05/cropped-hans-favicon-1-32x32.jpg",
        "rss_description": "Home Fitness & Bodybuilding Workouts"
    },
    {
        "title": "Gymtalk",
        "url": "https://gymtalk.com/",
        "description": "Gymtalk covers everything you'll need on your journey to a better diet, a better routine and a better you.",
        "votes": "2",
        "category": "Fitness",
        "e": "Error: Invalid character in entity name\nLine: 14\nColumn: 47\nChar: ="
    },
    {
        "title": "Men's Fitness",
        "url": "https://www.mensfitness.com/",
        "description": "Men's Fitness teaches it readers with articles all about lifestyle, relationships, grooming, training and nutrition.",
        "votes": "2",
        "category": "Fitness",
        "e": "Error: Invalid character in tag name\nLine: 8\nColumn: 367\nChar: ;"
    },
    {
        "title": "Eat, Live, Run",
        "url": "http://www.eatliverun.com/",
        "description": "Eat, Live, Run is ultimately a lifestyle and health blog offering food recipes, as well as family and travel inspiration.",
        "votes": "1",
        "category": "Fitness",
        "rss_url": "http://www.eatliverun.com/feed/",
        "rss_title": "Eat, Live, Run",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Celebrating life, one crumb at a time"
    },
    {
        "title": "Muscle Hack",
        "url": "https://www.musclehack.com/",
        "description": "Muscle Hack teaches how to shed fat and build muscle through a series of articles and with use of it's T.H.T. workout programme.",
        "votes": "1",
        "category": "Fitness",
        "rss_url": "https://www.musclehack.com/feed/",
        "rss_title": "MuscleHack by Mark McManus",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "free workouts to build muscle & lose fat fast"
    },
    {
        "title": "Natalie Jill Fitness",
        "url": "https://www.nataliejillfitness.com/",
        "description": "Natalie Jill Fitness provides guidance on nutrition and fitness to her audience through articles and programmes featured on the site.",
        "votes": "1",
        "category": "Fitness",
        "e": "Error: Invalid character in entity name\nLine: 49\nColumn: 433\nChar: &"
    },
    {
        "title": "The Workout Mama",
        "url": "http://theworkoutmama.com/",
        "description": "The Workout Mama, ran by a personal trainer and nutrition coach covers topics such as workouts, recipes and motherhood through articles on the site.",
        "votes": "1",
        "category": "Fitness",
        "e": "Error: Invalid character in entity name\nLine: 28\nColumn: 433\nChar: &"
    },
    {
        "title": "Vince DelMonte",
        "url": "http://www.vincedelmontefitness.com/blog",
        "description": "Vince Del Monte offers a no nonsense approach to weight lifting, workouts and nutrition. As well as articles on the site there is also an online course available.",
        "votes": "1",
        "category": "Fitness",
        "e": "Error: No whitespace between attributes\nLine: 32\nColumn: 99\nChar: S"
    },
    {
        "title": "A Foodie Stays Fit",
        "url": "http://www.afoodiestaysfit.com/",
        "description": "A Foodie Stays Fit is running and lifestyle blog which features stories, advice and recommended products.",
        "votes": "1",
        "category": "Fitness",
        "e": "Error: Attribute without value\nLine: 17\nColumn: 66\nChar: >"
    },
    {
        "title": "Fit and Feminist",
        "url": "https://fitandfeminist.com/",
        "description": "Fit and Feminist is a health and fitness blog which is taken from a feminists perspective.",
        "votes": "0",
        "category": "Fitness",
        "rss_url": "https://fitandfeminist.com/feed/",
        "rss_title": "Fit and Feminist",
        "rss_image_url": "https://s0.wp.com/i/buttonw-com.png",
        "rss_description": "Because it takes strong women to smash the patriarchy."
    },
    {
        "title": "Powercakes",
        "url": "http://www.powercakes.net/",
        "description": "Powercakes shows how to eat right and train effectively through the articles on site and their paid online training programmes.",
        "votes": "0",
        "category": "Fitness",
        "e": "Error: Invalid character in entity name\nLine: 32\nColumn: 82\nChar: &"
    },
    {
        "title": "Ross Training",
        "url": "http://rosstraining.com/blog/",
        "description": "Ross Training teaches people to go from ordinary to extraordinary with the help of their articles and forum. The site also has it's own coaching and apparel range.",
        "votes": "0",
        "category": "Fitness",
        "rss_url": "http://rosstraining.com/blog/feed/",
        "rss_title": "RossTraining.com",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Low-tech, high-effect training solutions for beast mode aficionados and fitness enthusiasts "
    },
    {
        "title": "Tabata Times",
        "url": "http://www.tabatatimes.com/",
        "description": "Tabata Times offers advice on weight lifting and CrossFit through informative articles featured on the site.",
        "votes": "0",
        "category": "Fitness",
        "e": "Error: connect ETIMEDOUT 50.63.174.66:80"
    },
    {
        "title": "Yoga Dork",
        "url": "http://yogadork.com/",
        "description": "Yogadork is an online resource to all things yoga with their informative articles, the site also has it's own range of yoga apparel.",
        "votes": "0",
        "category": "Fitness",
        "rss_url": "http://yogadork.com/feed/",
        "rss_title": "YogaDork",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "YogaDork commentary on yoga news, science, pop culture, celebrity gossip, with wit and wisdom"
    },
    {
        "title": "Unapologetically Strong",
        "url": "https://www.jensinkler.com/",
        "description": "Jen Sinkler offering weight training advice and guidance specifically for Women in her site's articles and using workshops for her audience.",
        "votes": "0",
        "category": "Fitness",
        "rss_url": "https://www.jensinkler.com/feed/",
        "rss_title": "Unapologetically Strong",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": ""
    },
    {
        "title": "Vegan Muscle and Fitness",
        "url": "http://www.veganmuscleandfitness.com/",
        "description": "Vegan Muscle and Fitness offers vegan based online personal training and recipe guidance through a series of articles and an eBook.",
        "votes": "0",
        "category": "Fitness",
        "e": "Error: read ECONNRESET"
    },
    {
        "title": "Love Life Surf",
        "url": "http://www.lovelifesurf.com/",
        "description": "Love Life Surf shares stories on life, family and fitness, as well as encouraging it's audience to try things that energise and enliven them.",
        "votes": "0",
        "category": "Fitness",
        "e": "Error: Attribute without value\nLine: 1\nColumn: 164\nChar: i"
    },
    {
        "title": "Pavement Runner",
        "url": "http://pavementrunner.com/",
        "description": "Pavement Runner reviews running events and gear, through the articles on the site, they also have an online store.",
        "votes": "0",
        "category": "Fitness",
        "e": "Error: Invalid character in entity name\nLine: 11\nColumn: 141\nChar: &"
    },
    {
        "title": "Meals and Miles",
        "url": "http://mealsandmiles.com/",
        "description": "Meals and Miles is a personal blog detailing Meghann's journey through food, family and running.",
        "votes": "0",
        "category": "Fitness",
        "rss_url": "https://mealsandmiles.com/feed/",
        "rss_title": "Meals and Miles",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "One Girl's Journey Through Food and Running"
    },
    {
        "title": "Muscle Evo",
        "url": "https://muscleevo.net/",
        "description": "Muscle Evo provides science-based advice to help it's readers to separate fitness fact from fiction.",
        "votes": "0",
        "category": "Fitness",
        "rss_url": "https://muscleevo.net/feed/",
        "rss_title": "Muscle Evo",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": ""
    },
    {
        "title": "The Penny Hoarder",
        "url": "https://www.thepennyhoarder.com/",
        "description": "Founded by Kyle Taylor, the Penny Hoarder is one of the largest personal finance websites, helping millions of readers worldwide who earn and save money by sharing unique job opportunities, personal stories, freebies and more.",
        "votes": "391",
        "category": "Finance",
        "rss_url": "https://www.thepennyhoarder.com/feed/",
        "rss_title": "The Penny Hoarder",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "The Penny Hoarder is one of the largest personal finance websites in America, receiving millions of visitors each month looking to make and save extra money."
    },
    {
        "title": "NerdWallet",
        "url": "https://www.nerdwallet.com/blog",
        "description": "NerdWallet's tailored advice, content and tools ensure safe money investment with good return. The website also provide clarity for all of life's financial decisions.",
        "votes": "282",
        "category": "Finance",
        "e": "Error: Invalid character in tag name\nLine: 14\nColumn: 374\nChar: ;"
    },
    {
        "title": "Of Dollars And Data",
        "url": "https://ofdollarsanddata.com/",
        "description": "Founded by Nick Maggiulli, the ofdollarsanddata website provides valuable insights about personal finance and investing using data analysis.",
        "votes": "189",
        "category": "Finance",
        "rss_url": "https://ofdollarsanddata.com/feed/",
        "rss_title": "Of Dollars And Data",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Personal Finance Using Data Analysis"
    },
    {
        "title": "A Wealth of Common Sense",
        "url": "http://awealthofcommonsense.com/",
        "description": "Awealthofcommonsense provides detailed investment plans and manages portfolios for institutions and individuals to help them achieve their goals.",
        "votes": "138",
        "category": "Finance",
        "e": "Error: read ECONNRESET"
    },
    {
        "title": "The Simple Dollar",
        "url": "https://www.thesimpledollar.com/",
        "description": "Founded by Trent Hamm in 2006, Thesimpledollar has been simplifying personal finance for eleven years and counting. It serves around one million visitors per month, and is ranked as a Top Ten Personal Finance Blog on Kiplinger.",
        "votes": "104",
        "category": "Finance",
        "e": "Error: Invalid character in tag name\nLine: 29\nColumn: 443\nChar: ;"
    },
    {
        "title": "Two Cents",
        "url": "https://twocents.lifehacker.com/",
        "description": "Two Cents is a Lifehacker sub-blog dedicated to personal finance. It provides financial advice regarding personal or educational loans, tax returns, volunteer work and other financial matters.",
        "votes": "88",
        "category": "Finance",
        "rss_url": "https://twocents.lifehacker.com/rss",
        "rss_title": "Two Cents",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Money, Investing, Budgeting and Saving Tips, Tricks and Hacks."
    },
    {
        "title": "Money Crashers",
        "url": "https://www.moneycrashers.com/",
        "description": "MoneyCrashers strives to educate individuals in making wise choices about credit and debt, investing, education, real estate, insurance, spending and more.",
        "votes": "82",
        "category": "Finance",
        "rss_url": "https://www.moneycrashers.com/feed/",
        "rss_title": "Money Crashers",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Personal Finance Blog, Your Guide to Financial Fitness"
    },
    {
        "title": "Wise Bread",
        "url": "http://www.wisebread.com/",
        "description": "Wise Bread is a community of bloggers which provides financial advice and helps people thrive on a small budget. Essentially providing tailored career and money-making ideas for their customers.",
        "votes": "72",
        "category": "Finance",
        "e": "Error: Invalid character in tag name\nLine: 4\nColumn: 381\nChar: ;"
    },
    {
        "title": "Money Under 30",
        "url": "https://www.moneyunder30.com/",
        "description": "A website by man who dug himself out of more than $80,000 in debt in just three years. Money Under 30 contains everything one needs to know about money, written by real people who’ve been there.",
        "votes": "66",
        "category": "Finance",
        "e": "Error: Status code 405"
    },
    {
        "title": "MintLife Blog",
        "url": "https://blog.mint.com/",
        "description": "The mission of blog.mint is powering prosperity around the world. No matter one's financial need, mint have a solution that can help the consumer, whether self-employed, or a small business owner.",
        "votes": "52",
        "category": "Finance",
        "rss_url": "http://feeds.feedburner.com/MyMint",
        "rss_title": "MintLife Blog",
        "rss_image_url": "https://blog.mint.com/wp-content/uploads/2019/04/cropped-CB_M_Pref_I_RGB.png?w=32",
        "rss_description": "Personal Finance News & Advice"
    },
    {
        "title": "The Financial Diet",
        "url": "http://thefinancialdiet.com/",
        "description": "Founded by Chelsea Fagan in 2014, TheFinancialDiet is a blog about personal finance and living better. With a wide community of contributors, hundreds of personal stories, and expert testimonies in everything from creating a budget to avoiding $10 office salads.",
        "votes": "52",
        "category": "Finance",
        "e": "Error: Invalid character in entity name\nLine: 27\nColumn: 145\nChar: &"
    },
    {
        "title": "Budgets Are Sexy",
        "url": "http://www.budgetsaresexy.com/",
        "description": "A money blog trying to spice things up a bit, it advises on budget planning, retirement, credit cards, 401k, templates and becoming a millionaire.",
        "votes": "44",
        "category": "Finance",
        "e": "Error: Invalid character in entity name\nLine: 66\nColumn: 433\nChar: &"
    },
    {
        "title": "Mr. Money Mustache",
        "url": "http://www.mrmoneymustache.com/",
        "description": "Founded by Peter Adeney, Mrmoneymustache is a personal financial blog in which the author shares the secrets about how one can create a life that is better than your current one.",
        "votes": "30",
        "category": "Finance",
        "rss_url": "http://www.mrmoneymustache.com/feed/",
        "rss_title": "Mr. Money Mustache",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Early Retirement through Badassity"
    },
    {
        "title": "Financial Samurai",
        "url": "https://www.financialsamurai.com/",
        "description": "FinancialSamurai provides an honest and in-depth review of the best financial products to help you achieve financial independence.",
        "votes": "22",
        "category": "Finance",
        "rss_url": "https://www.financialsamurai.com/feed/",
        "rss_title": "Financial Samurai",
        "rss_image_url": "https://www.financialsamurai.com/wp-content/uploads/2017/02/cropped-FinancialSamurai-Site-Icon-700x700-32x32.png",
        "rss_description": "Slicing Through Money's Mysteries"
    },
    {
        "title": "Retire by 40",
        "url": "http://retireby40.org/",
        "description": "Founded by Joe Udo, Retireby40 is a personal blog about achieving financial freedom using passive income ideas. The website narrates the steps in an easy manner for everyone to understand the science of money.",
        "votes": "20",
        "category": "Finance",
        "e": "Error: Attribute without value\nLine: 0\nColumn: 144\nChar: s"
    },
    {
        "title": "I Will Teach You To Be Rich",
        "url": "https://www.iwillteachyoutoberich.com/",
        "description": "Founded by Ramit Sethi, I will teach you to be rich is a website that provides deep insights about how money works, how to invest and how to acquire financial freedom.",
        "votes": "19",
        "category": "Finance",
        "rss_url": "https://www.iwillteachyoutoberich.com/feed/",
        "rss_title": "I Will Teach You To Be Rich",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "by Ramit Sethi"
    },
    {
        "title": "You Need a Budget",
        "url": "https://www.youneedabudget.com/blog/",
        "description": "YNAB is driven by a small, steadily growing and passionate team. The website teaches you to gain control of money matters. YNAB, with its ability to change lives, is something really special.",
        "votes": "19",
        "category": "Finance",
        "e": "Error: Invalid character in entity name\nLine: 25\nColumn: 942\nChar: &"
    },
    {
        "title": "Think Save Retire",
        "url": "https://thinksaveretire.com/",
        "description": "With over 700,000 views in the year 2017, thinksaveretire provides guidance towards managing personal finance and achieving the path toward early retirement.",
        "votes": "19",
        "category": "Finance",
        "e": "Error: Invalid character in entity name\nLine: 14\nColumn: 433\nChar: &"
    },
    {
        "title": "Dollar Sprout",
        "url": "https://www.dollarsprout.com/",
        "description": "Dollar Sprout want everyone to worry less about money and spend more time on the things that truly matter in life. By bringing you their latest ideas on how to make and save money and make smarter financial choices, they are doing their small part to help.",
        "votes": "19",
        "category": "Finance",
        "rss_url": "https://www.dollarsprout.com/feed/",
        "rss_title": "DollarSprout",
        "rss_image_url": "https://www.dollarsprout.com/wp-content/uploads/2017/09/ava@2x-34x34.png",
        "rss_description": "How to Make & Save Extra Money"
    },
    {
        "title": "Get Rich Slowly",
        "url": "http://www.getrichslowly.org/",
        "description": "Founded by J.D. Roth, Getrichslowly provides a clear pathway towards greater financial freedom. Tips are shared for digging your way out of debt and building a better financial future, as well as stock-market investing.",
        "votes": "18",
        "category": "Finance",
        "e": "Error: Invalid character in entity name\nLine: 37\nColumn: 433\nChar: &"
    },
    {
        "title": "Maple Money",
        "url": "https://maplemoney.com/",
        "description": "MapleMoney’s mission is to help you learn how to make money, save money, invest money, and spend money in a way that helps you create lasting financial freedom.",
        "votes": "15",
        "category": "Finance",
        "rss_url": "https://maplemoney.com/feed/",
        "rss_title": "MapleMoney",
        "rss_image_url": "https://maplemoney.com/wp-content/themes/maple-money/images/favicon.png",
        "rss_description": "The Canadian Source For Personal Finance"
    },
    {
        "title": "Len Penzo",
        "url": "http://lenpenzo.com/blog",
        "description": "With over a 9 million page views and 4 million unique visitors, Lenpenzo is an off beat personal finance blog for responsible people.",
        "votes": "14",
        "category": "Finance",
        "e": "Error: Attribute without value\nLine: 2\nColumn: 17\nChar: i"
    },
    {
        "title": "Good Financial Cents",
        "url": "https://www.goodfinancialcents.com/",
        "description": "Goodfinancialcents is a website by Jeff, a certified finance planner. The website provides guidanceto gain full control of your money situations so that the site's readers can be financially independent.",
        "votes": "12",
        "category": "Finance",
        "rss_url": "https://www.goodfinancialcents.com/feed/",
        "rss_title": "Good Financial Cents®",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Making Cents Of Investing and Financial Planning"
    },
    {
        "title": "My Money Blog",
        "url": "http://www.mymoneyblog.com/",
        "description": "With over 13,000 subscribers worldwide, Mymoneyblog gives financial advice, money making and money growing techniques. They discuss safe, high return investments and much more.",
        "votes": "11",
        "category": "Finance",
        "e": "Error: Invalid character in entity name\nLine: 95\nColumn: 433\nChar: &"
    },
    {
        "title": "ESI Money",
        "url": "https://esimoney.com/",
        "description": "Esimoney is a website about managing money so one can become wealthy. The blog provides tips that have helped the author amass a sizable net worth.",
        "votes": "11",
        "category": "Finance",
        "rss_url": "https://esimoney.com/feed/",
        "rss_title": "ESI Money",
        "rss_image_url": "https://esimoney.com/wp-content/uploads/2015/11/cropped-ESI-MONEY-ICON-3_512px-75x75.png",
        "rss_description": "Three Simple Steps to Wealth"
    },
    {
        "title": "20 Something Finance",
        "url": "https://20somethingfinance.com/",
        "description": "Founded by G.E. Miller, 20somethingfinance is a personal blog teaching financial independence, hacking the way to spending extremely low levels and learning the basics of personal finance.",
        "votes": "9",
        "category": "Finance",
        "rss_url": "https://20somethingfinance.com/feed/",
        "rss_title": "20somethingfinance.com",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Personal Finance Blog for Young Professionals"
    },
    {
        "title": "MoneyNing",
        "url": "http://moneyning.com/",
        "description": "MoneyNing is all about helping to become Debt Free, showing how to build wealth through time and prove how financial choices impact your life.",
        "votes": "9",
        "category": "Finance",
        "e": "Error: Invalid character in entity name\nLine: 43\nColumn: 433\nChar: &"
    },
    {
        "title": "The Billfold",
        "url": "https://www.thebillfold.com/",
        "description": "Billfold helps by talking about difficult money issues, and create a space to have an honest conversation about how to save, spend and repay the debts.",
        "votes": "9",
        "category": "Finance",
        "rss_url": "https://www.thebillfold.com/feed/atom/",
        "rss_title": "The Billfold",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media"
    },
    {
        "title": "Millennial Revolution",
        "url": "https://www.millennial-revolution.com/",
        "description": "Millennial revolution comprises of a series of real life inspirations to become financially free. The website also provides step-by-step training about how investing works, and how to retire at an early age - becoming financially free.",
        "votes": "8",
        "category": "Finance",
        "e": "Error: Invalid character in entity name\nLine: 38\nColumn: 433\nChar: &"
    },
    {
        "title": "Modest Money",
        "url": "https://www.modestmoney.com/",
        "description": "ModestMoney.com is single source for breaking investment news, including stock market developments, currency trading reports, and the latest commodities events. Modest Money provides insightful investment analysis from a diverse array of investment and financial minds.",
        "votes": "8",
        "category": "Finance",
        "rss_url": "https://www.modestmoney.com/feed",
        "rss_title": "Modest Money",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Personal Finance Blog for Everyday People"
    },
    {
        "title": "PT Money",
        "url": "https://ptmoney.com/",
        "description": "Full of interesting, original, and unique personal finance tips, PTmoney helps readers to make some extra money, save more money, and spend it wisely.",
        "votes": "8",
        "category": "Finance",
        "rss_url": "https://feeds.feedburner.com/PrimeTimeMoney",
        "rss_title": "Part-Time Money®",
        "rss_image_url": "https://ptmoney.com/wp-content/uploads/2016/05/cropped-favpt-32x32.png",
        "rss_description": "Make extra money in your free time."
    },
    {
        "title": "Go Curry Cracker!",
        "url": "https://gocurrycracker.com/",
        "description": "Founded by Winnie and Jeremy, Gocurrycracker blog is a resource for living life without worrying about financial problems and generate sources of passive income for travel and other ventures.",
        "votes": "6",
        "category": "Finance",
        "e": "Error: Invalid character in entity name\nLine: 23\nColumn: 150\nChar: &"
    },
    {
        "title": "Money Saving Mom",
        "url": "http://moneysavingmom.com/",
        "description": "Founded by Crystal Paine, MoneySavingMom is a website that provides a comprehensive list of free services, from personal financial advice to small coupon and store deals.",
        "votes": "6",
        "category": "Finance",
        "e": "Error: Attribute without value\nLine: 111\nColumn: 38\nChar: d"
    },
    {
        "title": "1500 Days to Freedom",
        "url": "https://www.1500days.com/",
        "description": "1500days is a personal blog where the writers goal was to build a debt-free portfolio of $1,000,000 by February of 2017, 1500 days from the birth of this blog. Worth checking out.",
        "votes": "5",
        "category": "Finance",
        "rss_url": "https://www.1500days.com/feed/",
        "rss_title": "1500 Days to Freedom",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Think different and escape the rat race."
    },
    {
        "title": "Mad Fientist",
        "url": "https://www.madfientist.com/",
        "description": "Madifientist is focused specifically on providing advice and innovative tax-avoidance methods for people planning to break away from full-time employment very early in life.",
        "votes": "5",
        "category": "Finance",
        "e": "Error: Invalid character in entity name\nLine: 47\nColumn: 44\nChar: ="
    },
    {
        "title": "Frugalwoods",
        "url": "http://www.frugalwoods.com/",
        "description": "Frugalwoods is about simple, joyful, luxurious frugality as well as personal finance and homesteading.The website motivates to achieve financial independence through simple living.",
        "votes": "5",
        "category": "Finance",
        "rss_url": "https://feeds.feedburner.com/Frugalwoods",
        "rss_title": "Frugalwoods",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Financial independence and simple living"
    },
    {
        "title": "Root of Good",
        "url": "http://rootofgood.com/",
        "description": "RootofGood is a personal blog about personal finance, financial independence, investing, travel, money hacks and anything else that makes life more awesome.",
        "votes": "3",
        "category": "Finance",
        "e": "Error: Request timed out after 10000ms"
    },
    {
        "title": "The Simple Path to Wealth",
        "url": "http://jlcollinsnh.com/",
        "description": "The blog is best known for the Stock Series and teaches about the subjects Money – Life – Travel – Business. The blog provides a simple path to wealth and financial freedom.",
        "votes": "3",
        "category": "Finance",
        "e": "Error: Attribute without value\nLine: 2\nColumn: 17\nChar: i"
    },
    {
        "title": "Kasasa",
        "url": "https://blog.kasasa.com/",
        "description": "A community-focused personal finance blog helping you save money.",
        "votes": "3",
        "category": "Finance",
        "rss_url": "https://blog.kasasa.com/feed/",
        "rss_title": "Kasasa Blog",
        "rss_image_url": "https://blog.kasasa.com/wp-content/uploads/sites/6/cropped-K-512px-32x32.png",
        "rss_description": "A community financial blog."
    },
    {
        "title": "Millennial Boss",
        "url": "https://millennialboss.com/blog/",
        "description": "Blogging for over three years, 'J' teaches everything she's learned on her journey to paying off over $100,000 in debt.",
        "votes": "3",
        "category": "Finance",
        "rss_url": "https://millennialboss.com/feed/",
        "rss_title": "Millennial Boss",
        "rss_image_url": "https://millennialboss.com/wp-content/uploads/2016/07/cropped-MB-1-32x32.jpg",
        "rss_description": ""
    },
    {
        "title": "Our Next Life",
        "url": "https://ournextlife.com/",
        "description": "OurNextLife is a website by Tanja Hester and Mark Bunge who educate about retiring at age of 30 and enjoying a financial worry free life. The website provides some deep insights about managing money.",
        "votes": "2",
        "category": "Finance",
        "rss_url": "https://ournextlife.com/feed/",
        "rss_title": "Our Next Life",
        "rss_image_url": "https://i1.wp.com/ournextlife.com/wp-content/uploads/2017/05/cropped-Our-Next-Life-Logo-Color-Stacked.jpg?fit=32%2C32&ssl=1",
        "rss_description": "Early Retirement // Financial Independence // Adventure // Happiness"
    },
    {
        "title": "Penny Pinchin' Mom",
        "url": "https://www.pennypinchinmom.com/",
        "description": "A personal blog by Tracie started when she managed to work her way out from a $35,000 debt. The blog shares tips on life, family and finances - to help others achieve this same goal of living a debt free life!",
        "votes": "2",
        "category": "Finance",
        "e": "Error: socket hang up"
    },
    {
        "title": "Early Retirement Extreme",
        "url": "http://earlyretirementextreme.com/",
        "description": "ERE is a set of principles that are based on a systems theoretic approach to “lifestyle design” allowing each individual to create their own robust strategy to a flexible lifestyle that is resilient and economic.",
        "votes": "2",
        "category": "Finance",
        "rss_url": "http://earlyretirementextreme.com/feed",
        "rss_title": "Early Retirement Extreme",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "--- a combination of simple living, anticonsumerism, DIY ethics, self-reliance, resilience, and applied capitalism"
    },
    {
        "title": "One Hundred Dollars a Month",
        "url": "https://www.onehundreddollarsamonth.com/",
        "description": "A personal blog by Mavis where the author shares budget costing, living within budget and devises ways to save money. The blog is primarily dedicated to cutting down grocery expenses.",
        "votes": "1",
        "category": "Finance",
        "e": "Error: Invalid character in entity name\nLine: 34\nColumn: 433\nChar: &"
    },
    {
        "title": "The Frugal Girl",
        "url": "http://www.thefrugalgirl.com/",
        "description": "Founded by Kristen, the frugalgirl is a blog about green living, food waste, mindful spending, and buying super high-quality stuff that lasts.",
        "votes": "1",
        "category": "Finance",
        "e": "Error: Attribute without value\nLine: 0\nColumn: 6761\nChar: >"
    },
    {
        "title": "Free Money Finance",
        "url": "http://www.freemoneyfinance.com/",
        "description": "This site is about one simple thing, growing your net worth. The website shares personal life long experiences about managing finances in one's life.",
        "votes": "0",
        "category": "Finance",
        "e": "Error: Unexpected close tag\nLine: 58\nColumn: 7\nChar: >"
    },
    {
        "title": "Consumerism Commentary",
        "url": "https://www.consumerismcommentary.com/",
        "description": "Consumerism Commentary is a premiere blog focusing on personal finance, money management, and investing for the future. The website is dedicated to unbiased reviews of banking and other consumer finance products.",
        "votes": "0",
        "category": "Finance",
        "e": "Error: Status code 405"
    },
    {
        "title": "DoughRoller",
        "url": "https://www.doughroller.net/",
        "description": "With over 23,000 subscribers worldwide, The Dough Roller is a blog focusing on money, how to make it, give it, save it, and spend it in a way that moves us closer to financial freedom.",
        "votes": "0",
        "category": "Finance",
        "rss_url": "https://www.doughroller.net/podcast",
        "rss_title": "The Dough Roller Money Podcast",
        "rss_image_url": "http://www.doughroller.net/wp-content/uploads/2013/11/doughroller-podcast.jpg",
        "rss_description": "The #1 Money Podcast covering personal finance, investing, money management and financial freedom"
    },
    {
        "title": "My Open Wallet",
        "url": "http://www.myopenwallet.net/",
        "description": "Myopenwallet is a personal blog by Madame X, where the author shares information about how much money they make. They also discuss how much to save, how to plan budget, home-buying experiences, setting financial goals, what it means to be rich or poor, and anything else that relates to money.",
        "votes": "0",
        "category": "Finance",
        "e": "Error: Malformed comment\nLine: 22\nColumn: 3\nChar: -"
    },
    {
        "title": "Mozilla Hacks",
        "url": "https://hacks.mozilla.org/",
        "description": "Mozilla Hacks is written for web developers, designers and everyone who builds for the web. Hacks is produced by Mozilla's Developer Relations team and features hundreds of posts from Mozilla.",
        "votes": "674",
        "category": "Design & Development",
        "rss_url": "https://hacks.mozilla.org/feed/",
        "rss_title": "Mozilla Hacks – the Web developer blog",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "hacks.mozilla.org"
    },
    {
        "title": "A List Apart",
        "url": "https://alistapart.com/",
        "description": "A next level website that explores the design, development, and meaning of web content, with a special focus on web standards and best practices.",
        "votes": "303",
        "category": "Design & Development",
        "e": "Error: Status code 404"
    },
    {
        "title": "Smashing Magazine",
        "url": "https://www.smashingmagazine.com/",
        "description": "Founded in September 2006, Smashing Magazine delivers reliable, useful, but most importantly practical articles to web designers and developers.",
        "votes": "244",
        "category": "Design & Development",
        "rss_url": "https://www.smashingmagazine.com/feed/",
        "rss_title": "Articles on Smashing Magazine — For Web Designers And Developers",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Recent content in Articles on Smashing Magazine — For Web Designers And Developers"
    },
    {
        "title": "Signal v. Noise",
        "url": "https://m.signalvnoise.com/",
        "description": "Founded in 1999, Signal v noise is a website for sharing strong opinions and shared thoughts on design, business and technology.",
        "votes": "180",
        "category": "Design & Development",
        "rss_url": "https://m.signalvnoise.com/feed/",
        "rss_title": "Signal v. Noise",
        "rss_image_url": "https://i2.wp.com/m.signalvnoise.com/wp-content/uploads/2019/01/cropped-svn-icon.gif?fit=32%2C32&ssl=1",
        "rss_description": "Strong opinions and shared thoughts on design, business, and tech. By the makers (and friends) of <a href=\"https://www.basecamp.com\" target=\"_blank\" rel=\"noopener\">Basecamp</a>. Since 1999."
    },
    {
        "title": "Webdesigner Depot",
        "url": "https://www.webdesignerdepot.com/",
        "description": "With over 1.1 million subscribers, Webdesignerdepot is one of the best websites providing some of the best insights on design and user experience. The company is working with real clients and bringing real world experience.",
        "votes": "162",
        "category": "Design & Development",
        "rss_url": "https://www.webdesignerdepot.com/feed/",
        "rss_title": "Webdesigner Depot",
        "rss_image_url": "https://www.webdesignerdepot.com/cdn-origin/uploads/2017/12/cropped-favicon-32x32.png",
        "rss_description": "Web Design Resources and Tutorials"
    },
    {
        "title": "Tuts+ Web Design",
        "url": "https://webdesign.tutsplus.com/",
        "description": "Webdesign provides free tutorials, learning guides, and online courses on interface design, UX, front-end development, motion design, accessibility, business and alike.",
        "votes": "111",
        "category": "Design & Development",
        "rss_url": "https://tutsplus.com/posts.atom",
        "rss_title": "Envato Tuts+ Tutorials",
        "rss_image_url": "https://static.tutsplus.com/assets/favicon-9e8b377989d9949ad1003dc5298cd8ef.png"
    },
    {
        "title": "Kinsta",
        "url": "https://kinsta.com/blog/",
        "description": "Sharing everything you know to speed up your WordPress site and the plugins you need to succeed, Kinsta has you covered.",
        "votes": "75",
        "category": "Design & Development",
        "e": "Error: Invalid character in entity name\nLine: 14\nColumn: 133\nChar: &"
    },
    {
        "title": "David Walsh",
        "url": "https://davidwalsh.name/",
        "description": "A website sharing name of its author David Walsh, comprises of popular topics such as HTML5, CSS Animations, Firefox OS, jQuery,MooTools, PHP, CSS3, WordPress, Mobile, SEO, JavaScript and Dojo Toolkit.",
        "votes": "69",
        "category": "Design & Development",
        "rss_url": "https://davidwalsh.name/feed/atom",
        "rss_title": "David Walsh Blog",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media"
    },
    {
        "title": "Node.js Blog",
        "url": "https://nodejs.org/en/",
        "description": "Node.js is a JavaScript runtime built on Chrome's V8 engine. It is use to build scalable network application.",
        "votes": "65",
        "category": "Design & Development",
        "rss_url": "https://nodejs.org/en/feed/blog.xml",
        "rss_title": "Node.js Blog",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Node.js Blog"
    },
    {
        "title": "Sitepoint",
        "url": "https://www.sitepoint.com/",
        "description": "Founded by Mark Harbottle and Matt Mickiewicz in 1999, SitePoint is for web professionals, by web professionals. Perfect for developers, designers, programmers, product creators and entrepreneurs alike.",
        "votes": "54",
        "category": "Design & Development",
        "rss_url": "https://www.sitepoint.com/feed/",
        "rss_title": "SitePoint",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Learn CSS | HTML5 | JavaScript | Wordpress | Tutorials-Web Development | Reference | Books and More"
    },
    {
        "title": "Web Design Ledger",
        "url": "https://webdesignledger.com/",
        "description": "Web Design Ledger contains information on a number of aspects of web design such as eCommerce, WordPress, Plugins, Portfolios and so much more.",
        "votes": "53",
        "category": "Design & Development",
        "rss_url": "https://webdesignledger.com/feed/",
        "rss_title": "Web Design Ledger",
        "rss_image_url": "https://webdesignledger.com/wp-content/uploads/2015/08/cropped-Web-Design-Ledger-512x512-Pixel-32x32.png",
        "rss_description": "By Web Designers for Web Designers"
    },
    {
        "title": "Tuts+ Code",
        "url": "https://code.tutsplus.com/",
        "description": "A website with thousands of free tutorials and online courses on software development, web applications, design and crafting. It helps with improving coding skills and workflow.",
        "votes": "45",
        "category": "Design & Development",
        "rss_url": "https://tutsplus.com/posts.atom",
        "rss_title": "Envato Tuts+ Tutorials",
        "rss_image_url": "https://static.tutsplus.com/assets/favicon-9e8b377989d9949ad1003dc5298cd8ef.png"
    },
    {
        "title": "Speckyboy",
        "url": "https://speckyboy.com/",
        "description": "Launched in 2007, Speckyboy publishes insightful tutorials and tips, time-saving techniques and resources, and share inspirational UI designs. The website also covers web and mobile app design, UX design, graphic design, and even the occasional Lego post.",
        "votes": "43",
        "category": "Design & Development",
        "rss_url": "https://speckyboy.com/feed/",
        "rss_title": "Speckyboy Web Design Magazine",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Web Design News, Resources & Inspiration"
    },
    {
        "title": "UX Booth",
        "url": "http://www.uxbooth.com/",
        "description": "Trusted by over 100,000 experienced professionals, UXbooth is a a publication by and for the user experience community. The website covers analytics, interaction design, visual design, content strategy and alike.",
        "votes": "36",
        "category": "Design & Development",
        "e": "Error: Unexpected close tag\nLine: 54\nColumn: 11\nChar: >"
    },
    {
        "title": "Line25",
        "url": "https://line25.com/",
        "description": "Created in 2009, Line25 is now a wonderful place to share web design ideas and inspiration through articles, tutorials and examples of stunning site designs.",
        "votes": "30",
        "category": "Design & Development",
        "rss_url": "https://feeds2.feedburner.com/Line25",
        "rss_title": "Line25",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Ideas and Inspiration from the Drawing Board of Creative Web Design"
    },
    {
        "title": "Spoon Graphics",
        "url": "https://blog.spoongraphics.co.uk/",
        "description": "Founded by Chris Spooner, SpoonGraphics is home to a range of design tutorials, free resources and inspiration. Three main types of content include tutorials, freebies and articles to share theory and inspiration from various creative genres.",
        "votes": "25",
        "category": "Design & Development",
        "rss_url": "http://feeds2.feedburner.com/SpoonGraphics",
        "rss_title": "Spoon Graphics",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Design Tutorials and Free Resource Downloads"
    },
    {
        "title": "Simple Programmer",
        "url": "https://simpleprogrammer.com/",
        "description": "Founded by John Sonmez, the simple programmer is focused on helping software developers, programmers and other IT professionals improve their careers and live better lives.",
        "votes": "25",
        "category": "Design & Development",
        "e": "Error: Attribute without value\nLine: 21\nColumn: 205\nChar: >"
    },
    {
        "title": "php[architect]",
        "url": "https://www.phparch.com/",
        "description": "Since 2002, PHParch has been publishing a magazine dedicated to PHP, design, optimizations and efficient execution. The website shares some of the best practices in PHP.",
        "votes": "20",
        "category": "Design & Development",
        "rss_url": "https://www.phparch.com/feed/",
        "rss_title": "php[architect]",
        "rss_image_url": "https://www.phparch.com/wp-content/plugins/powerpress/rss_default.jpg",
        "rss_description": "The site for PHP professionals, Magazine, Training, Books, Conferences"
    },
    {
        "title": "Treehouse Blog",
        "url": "http://blog.teamtreehouse.com/",
        "description": "With over 200 courses and 27,000 minutes of videos, Team Tree House is committed to making education accessible to students of all races, genders, sexual orientations, and socio-economic backgrounds.",
        "votes": "15",
        "category": "Design & Development",
        "e": "Error: Invalid character in entity name\nLine: 34\nColumn: 433\nChar: &"
    },
    {
        "title": "Graphic Design Junction",
        "url": "http://graphicdesignjunction.com/",
        "description": "Founded in 2010, Graphic Design Junction is the leading site in design and inspiration, showcasing Junction for web designers and developers through daily resources and their premium web design and development platform.",
        "votes": "13",
        "category": "Design & Development",
        "e": "Error: Request timed out after 10000ms"
    },
    {
        "title": "CatsWhoCode",
        "url": "https://www.catswhocode.com/blog",
        "description": "A great website founded in 2008, dedicated to those who create and maintain websites. Such as web developers, web designers, webmasters and so on.",
        "votes": "13",
        "category": "Design & Development",
        "e": "Error: Request timed out after 10000ms"
    },
    {
        "title": "UX Magazine",
        "url": "http://uxmag.com/",
        "description": "UXMag is a free community resource exploring all facets of experience design. They work closely with practitioners and industry leaders versed in all areas of UX to provide a steady stream of engaging and useful content.",
        "votes": "13",
        "category": "Design & Development",
        "e": "Error: Invalid character in tag name\nLine: 8\nColumn: 338\nChar: ;"
    },
    {
        "title": "Web Design Dev",
        "url": "http://www.webdesigndev.com/",
        "description": "A simple but worth visiting web design blog that brings design inspiration, how to design a website, web design tutorials and much more.",
        "votes": "12",
        "category": "Design & Development",
        "rss_url": "http://www.webdesigndev.com/feed/",
        "rss_title": "Web Design Blog | Magazine for Designers",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": ""
    },
    {
        "title": "1stWebDesigner",
        "url": "https://1stwebdesigner.com/",
        "description": "1st web designer is a wonderful platform where the content is created by web design professionals, for web design professionals. The website share insights that help make the web even better.",
        "votes": "11",
        "category": "Design & Development",
        "e": "Error: Invalid character in entity name\nLine: 75\nColumn: 433\nChar: &"
    },
    {
        "title": "Stack Overflow",
        "url": "https://stackoverflow.blog/",
        "description": "With over 50 million visits per month, Stackoverflow is the largest, most trusted online community for developers to learn, share their knowledge, and build their careers. The website helps to solve coding problems, develop new skills, and find job opportunities.",
        "votes": "11",
        "category": "Design & Development",
        "e": "Error: Invalid character in entity name\nLine: 32\nColumn: 433\nChar: &"
    },
    {
        "title": "LukeW",
        "url": "http://www.lukew.com/",
        "description": "Over 23 years of leadership and execution in digital product design, Lukew shares the articles about the big picture and the crucial details behind online software.",
        "votes": "9",
        "category": "Design & Development",
        "e": "Error: Invalid character in entity name\nLine: 4\nColumn: 60\nChar:  "
    },
    {
        "title": "Noupe",
        "url": "https://www.noupe.com/",
        "description": "Noupe passionately delivers stylish and dynamic news for designers and web developers across the globe on all subjects of design. Ranging from CSS, Ajax, JavaScript, Web design, graphics, typography, advertising and much more.",
        "votes": "8",
        "category": "Design & Development",
        "rss_url": "https://www.noupe.com/feed",
        "rss_title": "noupe",
        "rss_image_url": "https://www.noupe.com/wp-content/uploads/2017/01/cropped-favicon-300x300.png",
        "rss_description": "THE magazine for webworkers and site owners"
    },
    {
        "title": "Clean Coder Blog",
        "url": "http://blog.cleancoder.com/",
        "description": "A series of informative articles on efficient design and coding. A must read blog by Robert C. Martin. The blog shares insights to the real world design problems and their solutions as well.",
        "votes": "6",
        "category": "Design & Development",
        "rss_url": "http://blog.cleancoder.com/atom.xml",
        "rss_title": "The Clean Code Blog",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media"
    },
    {
        "title": "Developer Drive",
        "url": "http://www.developerdrive.com/",
        "description": "Founded in 2011, DeveloperDrive is a dynamic hub of inspiration, tutorials, tips and opinion articles on all things web development. It helps the readers to learn and grow as web developers, to hone their skills, to share, support and challenge each other,",
        "votes": "6",
        "category": "Design & Development",
        "e": "Error: Unexpected close tag\nLine: 53\nColumn: 7\nChar: >"
    },
    {
        "title": "Christian Heilmann",
        "url": "https://christianheilmann.com/",
        "description": "A personal blog founded by Christian Heilmann, delivers insights on web development, website design and optimization, issues with poor web designs and how to avoid them.",
        "votes": "6",
        "category": "Design & Development",
        "rss_url": "https://christianheilmann.com/feed/",
        "rss_title": "Christian Heilmann",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "For a better web with more professional jobs - can talk, will travel"
    },
    {
        "title": "Retro Supply Co.",
        "url": "https://www.retrosupply.co/blogs/retrosupply-blog",
        "description": "RetroSupply was made for any designer, illustrator, creative, or hobbyist who want resources that bring those nostalgic touches to their work.",
        "votes": "6",
        "category": "Design & Development",
        "rss_url": "https://www.retrosupply.co/blogs/retrosupply-blog.atom",
        "rss_title": "RetroSupply Co. - RetroSupply Blog",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media"
    },
    {
        "title": "GV Library",
        "url": "https://library.gv.com/",
        "description": "Read writing about Design in GV (Google Ventures) Library. Advice, lessons, and tips from GV partners and their community of entrepreneurs.",
        "votes": "5",
        "category": "Design & Development",
        "e": "Error: Invalid character in entity name\nLine: 0\nColumn: 3284\nChar: &"
    },
    {
        "title": "Subtraction.com",
        "url": "https://www.subtraction.com/",
        "description": "Founded by by Khoi Vinh, Subtraction is a blog about design, technology and culture. It includes a large archive of useful articles focused towards design and development of content.",
        "votes": "3",
        "category": "Design & Development",
        "rss_url": "https://www.subtraction.com/feed/",
        "rss_title": "Subtraction.com + Feed",
        "rss_image_url": "https://s0.wp.com/i/blank.jpg",
        "rss_description": "<strong>Khoi Vinh’s</strong> Web site"
    },
    {
        "title": "Web Designer Wall",
        "url": "http://webdesignerwall.com/",
        "description": "Webdesignerwall is a personal blog by Nick La. It is dedicated to discussions about design ideas, trends, and tutorials.The website is a great collection of stock icons, WordPress themes, illustrations and CSS websites.",
        "votes": "3",
        "category": "Design & Development",
        "e": "Error: Invalid character in entity name\nLine: 113\nColumn: 433\nChar: &"
    },
    {
        "title": "Official jQuery Blog",
        "url": "http://blog.jquery.com/",
        "description": "A one stop for every thing related to jquery. Founded by jquery foundation, the blog delivers all the updates, new releases, issues, bugs and their fixes here.",
        "votes": "2",
        "category": "Design & Development",
        "rss_url": "http://blog.jquery.com/feed/",
        "rss_title": "Official jQuery Blog",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "New Wave Javascript"
    },
    {
        "title": "Onextrapixel",
        "url": "https://onextrapixel.com/",
        "description": "Onextrapixel (OXP) is a leading online magazine and resource site for designers and web developers. It aims to collect, explore, as well as share useful tips, news, tutorials, tools and resources, on design, development and other inspirational topics.",
        "votes": "2",
        "category": "Design & Development",
        "e": "Error: Attribute without value\nLine: 69\nColumn: 103\nChar: >"
    },
    {
        "title": "Code Geekz",
        "url": "https://codegeekz.com/",
        "description": "A comprehensive archive of useful articles and tutorials on web design, WordPress, plugins, code and web development.",
        "votes": "1",
        "category": "Design & Development",
        "rss_url": "https://feeds2.feedburner.com/codegeekz",
        "rss_title": "Code Geekz",
        "rss_image_url": "http://codegeekz.com/wp-content/uploads/2012/11/codegeekz-logo-white.jpg",
        "rss_description": ""
    },
    {
        "title": "Eric's Thoughts",
        "url": "https://meyerweb.com/eric/thoughts/",
        "description": "Founded by Eric A. Meyer, MeyerWeb is a huge collection of articles, tutorials, tools, and learning material for web developers, designers and web security experts.",
        "votes": "1",
        "category": "Design & Development",
        "e": "Error: Invalid character in entity name\nLine: 14\nColumn: 433\nChar: &"
    },
    {
        "title": "codediesel",
        "url": "https://www.codediesel.com/",
        "description": "Founded by Alan Kay, CodeDiesel comprises of articles, tutorials, and comments on software in general and php/mysql in particular. The website is interesting and useful for other web professionals.",
        "votes": "1",
        "category": "Design & Development",
        "e": "Error: Invalid character in entity name\nLine: 131\nColumn: 242\nChar: ="
    },
    {
        "title": "Bootstrap Blog",
        "url": "http://blog.getbootstrap.com/",
        "description": "This is a dedicated blog of news and announcements for all things Bootstrap, including new releases, Bootstrap Themes and Bootstrap Jobs.",
        "votes": "1",
        "category": "Design & Development",
        "e": "Error: Attribute without value\nLine: 51\nColumn: 15\nChar: s"
    },
    {
        "title": "Bruce Lawson",
        "url": "http://www.brucelawson.co.uk/",
        "description": "Founded by Bruce Lawson, the website provides useful, informative and worth reading web links each month for web developers, designers and other relevant fields.",
        "votes": "1",
        "category": "Design & Development",
        "e": "Error: Unquoted attribute value\nLine: 1\nColumn: 12\nChar: e"
    },
    {
        "title": "9lessons Programming",
        "url": "https://www.9lessons.info/",
        "description": "Founded by Srinivas Tamada, 9Lessons provides tutorials and information related to Javascript, PHP, Ionic, Angular, React, Jquery and many others.",
        "votes": "0",
        "category": "Design & Development",
        "rss_url": "https://www.9lessons.info/feeds/posts/default",
        "rss_title": "9lessons Programming Blog",
        "rss_image_url": "http://creativecommons.org/images/public/somerights20.gif",
        "rss_description": "9lessons is a popular tech blog maintained by Srinivas Tamada from India. Topics focus on Programming, Javascript, Angular, React JS, PHP, Java, Jquery, Mysql, Database, Resources and inspiration. "
    },
    {
        "title": "Codrops",
        "url": "https://tympanus.net/codrops",
        "description": "Codrops is a web design and development blog that publishes articles and tutorials about the latest web trends, techniques and new possibilities.",
        "votes": "0",
        "category": "Design & Development",
        "e": "Error: Unexpected close tag\nLine: 120\nColumn: 8\nChar: >"
    },
    {
        "title": "CSS-Tricks",
        "url": "https://css-tricks.com/",
        "description": "Founded by Chris Coyier in 2007, CSS-Tricks has developed to become a site about all things web design and development.",
        "votes": "0",
        "category": "Design & Development",
        "rss_url": "http://feeds.feedburner.com/CssTricks",
        "rss_title": "CSS-Tricks",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Tips, Tricks, and Techniques on using Cascading Style Sheets."
    },
    {
        "title": "Design Shack",
        "url": "https://designshack.net/",
        "description": "Established in 2003, Design Shack showcases inspiring examples of design, alongside resources and articles that teach how to succeed in the same way.",
        "votes": "0",
        "category": "Design & Development",
        "e": "Error: Unquoted attribute value\nLine: 0\nColumn: 27\nChar: e"
    },
    {
        "title": "Queness",
        "url": "http://www.queness.com/",
        "description": "Queness is a hybrid of a web blog and online community with heaps of design inspirations and a great collection of javascript/jquery tutorials.",
        "votes": "0",
        "category": "Design & Development",
        "e": "Error: Attribute without value\nLine: 78\nColumn: 17\nChar: s"
    },
    {
        "title": "Robert's Talk",
        "url": "https://robertnyman.com/",
        "description": "With the love for HTML5, Robert Nyman developed this website which shares some insights on coding, HTML5, website optimization for browsers and alike.",
        "votes": "0",
        "category": "Design & Development",
        "rss_url": "http://feeds.feedburner.com/robertnyman",
        "rss_title": "Robert's talk",
        "rss_image_url": "https://robertnyman.com/apple-touch-icon.png",
        "rss_description": "Web development and Internet trends"
    },
    {
        "title": "Ryan Seddon",
        "url": "https://www.thecssninja.com/",
        "description": "A dedicated website towards CSS. The css ninja is a collection of thoughts and tutorials of Ryan Seddan in the web development business.",
        "votes": "0",
        "category": "Design & Development",
        "rss_url": "https://www.thecssninja.com/feed",
        "rss_title": "Ryan Seddon",
        "rss_image_url": "https://www.thecssninja.com/wp-content/uploads/2016/05/cropped-logo-1-1-32x32.png",
        "rss_description": ""
    },
    {
        "title": "Katz Got Your Tongue",
        "url": "http://yehudakatz.com/",
        "description": "A long-form writing by Yehuda Katz, co-creator of Ember.js and serial Open Sourcerer. The website is dedicated to web designs, developments, security and other related topics.",
        "votes": "0",
        "category": "Design & Development",
        "e": "Error: Unexpected close tag\nLine: 97\nColumn: 7\nChar: >"
    },
    {
        "title": "Tutorialzine",
        "url": "https://tutorialzine.com/articles",
        "description": "TutorialZine is a collection of very informative articles related to JavaScript CSS and HTML. The collection covers web development, web design, web security and cryptocurrency related information.",
        "votes": "0",
        "category": "Design & Development",
        "rss_url": "https://tutorialzine.com/feed",
        "rss_title": "Tutorialzine",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Web Development Tutorials & Resources"
    },
    {
        "title": "Cointelegraph",
        "url": "https://cointelegraph.com/",
        "description": "Founded in 2013, Cointelegraph is a completely independent publication covering cryptocurrency, the blockchain, decentralized applications, the internet of finance and the next gen web.",
        "votes": "3473",
        "category": "Cryptocurrency",
        "rss_url": "https://cointelegraph.com/rss",
        "rss_title": "Cointelegraph.com News",
        "rss_image_url": "https://cointelegraph.com/assets/img/CT_Logo_YG_tag.png",
        "rss_description": "Cointelegraph covers fintech, blockchain and Bitcoin bringing you the latest news and analyses on the future of money."
    },
    {
        "title": "CoinDesk",
        "url": "https://www.coindesk.com/",
        "description": "With over 10 million unique visitors, CoinDesk is the leading digital media, events and information service company for the crypto asset and blockchain technology community.",
        "votes": "2689",
        "category": "Cryptocurrency",
        "rss_url": "https://feeds.feedburner.com/CoinDesk",
        "rss_title": "CoinDesk",
        "rss_image_url": "https://www.coindesk.com/wp-content/uploads/2017/05/cropped-coindesk-new-favicon.png",
        "rss_description": "Leader in blockchain news."
    },
    {
        "title": "CCN",
        "url": "https://www.ccn.com/",
        "description": "CCN provides the latest Bitcoin news, as well as other cryptocurrencies like Ethereum, NEO, Litecoin and ICOs.",
        "votes": "2017",
        "category": "Cryptocurrency",
        "rss_url": "https://www.ccn.com/feed",
        "rss_title": "CCN",
        "rss_image_url": "https://www.ccn.com/wp-content/uploads/2017/12/cropped-favicon-4-32x32.png",
        "rss_description": "We Are Anti-Elite, We Are Anti-Centralization"
    },
    {
        "title": "AMBCrypto",
        "url": "https://ambcrypto.com/",
        "description": "With over 3,000 Telegram followers and 1.5 million monthly pageviews, AMBCrypto covers the latest in cryptocurrency news.",
        "votes": "1289",
        "category": "Cryptocurrency",
        "e": "Error: Status code 403"
    },
    {
        "title": "NewsBTC",
        "url": "http://www.newsbtc.com/",
        "description": "Founded in 2013, NewsBtc brings quality news content, reviews, technical analysis and other unique insights to the ever-growing cryptocurrency community.",
        "votes": "739",
        "category": "Cryptocurrency",
        "e": "Error: Invalid character in entity name\nLine: 1\nColumn: 433\nChar: &"
    },
    {
        "title": "Bitcoinist",
        "url": "http://bitcoinist.com/",
        "description": "Bitcoinist is the prime source for information about Bitcoin, digital currency and blockchain technology. Bitcoinist provides up-to-date news and insightful analysis related to business news and technical price analysis to community events.",
        "votes": "672",
        "category": "Cryptocurrency",
        "e": "Error: Attribute without value\nLine: 0\nColumn: 644\nChar: >"
    },
    {
        "title": "Bitcoin News",
        "url": "https://news.bitcoin.com/",
        "description": "Bitcoin.com is a premier source for everything Bitcoin related. The website features the latest news and updates, it also provides facility to engage with the community on a Bitcoin Forum.",
        "votes": "492",
        "category": "Cryptocurrency",
        "rss_url": "https://news.bitcoin.com/feed/",
        "rss_title": "Bitcoin News",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Daily Bitcoin News"
    },
    {
        "title": "Kraken Blog",
        "url": "https://blog.kraken.com/",
        "description": "Trusted by hundreds of thousands of traders, institutions, and authorities, including Germany’s BaFin regulated Fidor Bank, Kraken blog is the blog of kraken- crypto currency exchange, which provides daily market reports about cryptocurrencies.",
        "votes": "406",
        "category": "Cryptocurrency",
        "rss_url": "https://blog.kraken.com/feed/",
        "rss_title": "Kraken Blog",
        "rss_image_url": "https://i2.wp.com/blog.kraken.com/wp-content/uploads/2019/01/krakenfav.png?fit=32%2C32&ssl=1",
        "rss_description": "News and market reports from Kraken Digital Asset Exchange"
    },
    {
        "title": "Bitcoin Magazine",
        "url": "https://bitcoinmagazine.com/",
        "description": "The oldest and most established source of news, information and expert commentary on Bitcoin, blockchain technology and the digital currency industry.",
        "votes": "366",
        "category": "Cryptocurrency",
        "e": "Error: connect ECONNREFUSED 127.0.0.1:80"
    },
    {
        "title": "The Coinbase Blog",
        "url": "https://blog.coinbase.com/",
        "description": "Coinbase blog is dedicated to the latest crypto world news and recommendations, including stories from Coinbase, the most popular place to buy and sell digital currency.",
        "votes": "308",
        "category": "Cryptocurrency",
        "e": "Error: Invalid character in entity name\nLine: 0\nColumn: 3345\nChar: &"
    },
    {
        "title": "Coin Central",
        "url": "https://coincentral.com/",
        "description": "Coin Central present new developments with cryptocurrencies and blockchain move at the speed of light--and so should you if you want to catch the waves of opportunity. New coins, exchanges, scams, and opportunities are popping up everyday as the crypto universe expands. Your knowledge base has to expand with it, and they’re committed to only sharing the knowledge we consider 100% useful and 100% accurate and trustworthy.",
        "votes": "119",
        "category": "Cryptocurrency",
        "rss_url": "https://coincentral.com/feed/",
        "rss_title": "CoinCentral",
        "rss_image_url": "https://coincentral.com/wp-content/uploads/2018/06/cropped-coin-central-icon-32x32.png",
        "rss_description": "Your Bitcoin, Ethereum, and other Cryptocurrency HQ"
    },
    {
        "title": "CryptoPotato",
        "url": "https://cryptopotato.com/",
        "description": "A one stop resource for finding anything related to the cryptocurrencies world including Bitcoins, Altcoins and, crypto trading.",
        "votes": "87",
        "category": "Cryptocurrency",
        "rss_url": "https://cryptopotato.com/feed/",
        "rss_title": "CryptoPotato",
        "rss_image_url": "https://cryptopotato.com/wp-content/uploads/2017/07/potato-logo55.png",
        "rss_description": "crypto blog"
    },
    {
        "title": "Crypto Coin Updates",
        "url": "https://www.cryptocoinupdates.com/",
        "description": "The website dedicated to the promotion of the Crypto Revolution – a non-violent revolution that is enabling peer-to-peer trustless (bankless) transactions within peer-to-peer economies driven by decentralized blockchains.",
        "votes": "78",
        "category": "Cryptocurrency",
        "e": "Error: Invalid character in entity name\nLine: 32\nColumn: 1309\nChar: ="
    },
    {
        "title": "Coinspeaker",
        "url": "https://www.coinspeaker.com/",
        "description": "With over 450,000 unique visitors per month, CoinSpeaker covers every aspect of the bitcoin and altcoin markets, featuring a mix of regular tech wraps, daily and weekly market updates, features, interviews and much more.",
        "votes": "77",
        "category": "Cryptocurrency",
        "rss_url": "https://www.coinspeaker.com/feed/",
        "rss_title": "Coinspeaker",
        "rss_image_url": "https://www.coinspeaker.com/wp-content/uploads/2018/03/favicon.png",
        "rss_description": "News about Bitcoin, Blockchain, ICO, FinTech, IoT"
    },
    {
        "title": "The Merkle",
        "url": "https://themerkle.com/",
        "description": "Founded in 2014, TheMerkle brings the latest crypto, finance, infosec, and tech news. It also compares exchanges and cryptocurrencies.",
        "votes": "77",
        "category": "Cryptocurrency",
        "rss_url": "https://themerkle.com/feed/",
        "rss_title": "The Merkle Hash",
        "rss_image_url": "https://themerkle.com/wp-content/uploads/2016/03/cropped-merkle-white-1-32x32.png",
        "rss_description": ""
    },
    {
        "title": "BTCManager",
        "url": "https://btcmanager.com/",
        "description": "A reliable source of fair, honest, and accurate, free of bias and influence BTC news, suggestions, recommendations and reviews in fields of cryptocurrencies, ICO's and exchanges.",
        "votes": "61",
        "category": "Cryptocurrency",
        "rss_url": "https://btcmanager.com/feed/",
        "rss_title": "BTCMANAGER",
        "rss_image_url": "https://btcmanager.com/wp-content/uploads/2017/09/cropped-btcmanagerlogo-800x800-60x60.jpg",
        "rss_description": "Bitcoin, Blockchain & Cryptocurrency News"
    },
    {
        "title": "Coin Idol",
        "url": "https://coinidol.com/",
        "description": "Coinidol is an international crypto and currencies media outlet focusing on the latest news about Bitcoin and altcoins, Blockchain and distributed ledger technology solutions, FinTech and financial innovations on the world's market.",
        "votes": "50",
        "category": "Cryptocurrency",
        "e": "Error: Invalid character in entity name\nLine: 10\nColumn: 455\nChar: &"
    },
    {
        "title": "Use The Bitcoin",
        "url": "https://usethebitcoin.com/",
        "description": "Use The Bitcoin presents the most important and relevant Bitcoin and Cryptocurrency news. They cover all things from new coins, ICOs, and Blockchain information.",
        "votes": "34",
        "category": "Cryptocurrency",
        "e": "Error: Invalid character in entity name\nLine: 18\nColumn: 58\nChar: ="
    },
    {
        "title": "Let's Talk Bitcoin",
        "url": "https://letstalkbitcoin.com/",
        "description": "Lets Talk Bitcoin presents the ideas and people involved with cryptocurrency through podcasts, articles, and discussion forums.",
        "votes": "22",
        "category": "Cryptocurrency",
        "e": "Error: Unquoted attribute value\nLine: 39\nColumn: 45\nChar: \\"
    },
    {
        "title": "99Bitcoins",
        "url": "https://99bitcoins.com/",
        "description": "99 Bitcoins is the largest information source for non technical newbies including Bitcoin basics, Bitcoin trading tips and techniques and even information about mining Bitcoins.",
        "votes": "16",
        "category": "Cryptocurrency",
        "rss_url": "https://99bitcoins.com/feed/",
        "rss_title": "99 Bitcoins",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "A non technical blog about Bitcoin - Tutorial, Reviews and Guides"
    },
    {
        "title": "Blockchain Blog",
        "url": "https://blog.blockchain.com/",
        "description": "Founded by Peter Smith, Blockchain blog is dedicated to the latest news about blockchain, wallets and updates in the cryptospace.",
        "votes": "12",
        "category": "Cryptocurrency",
        "rss_url": "https://blog.blockchain.com/rss/",
        "rss_title": "Blockchain Blog",
        "rss_image_url": "https://blog.blockchain.com/favicon.png",
        "rss_description": "Thoughts, stories and ideas."
    },
    {
        "title": "Cointelligence",
        "url": "https://www.cointelligence.com/",
        "description": "Cointelligence, feel that there is a growing need in the entire crypto community for an impartial and accurate rating system. The felt so strongly about this that they created their own impartial rating system.",
        "votes": "12",
        "category": "Cryptocurrency",
        "e": "Error: Attribute without value\nLine: 1\nColumn: 23\nChar: d"
    },
    {
        "title": "Cryptogon",
        "url": "http://www.cryptogon.com/",
        "description": "Founded by Kevin Flaherty, Cryptogon strives to disseminate information and perspectives that have been ignored, covered up or otherwise belittled by government, media, and corporations.",
        "votes": "6",
        "category": "Cryptocurrency",
        "e": "Error: Invalid character in entity name\nLine: 17\nColumn: 433\nChar: &"
    },
    {
        "title": "The BitPay Blog",
        "url": "https://blog.bitpay.com/",
        "description": "An open, staff-driven blog bringing insights to exciting developments, upcoming opportunities, and lessons learned in developing enterprise-grade infrastructure for bitcoin.",
        "votes": "6",
        "category": "Cryptocurrency",
        "rss_url": "https://blog.bitpay.com/rss/",
        "rss_title": "The BitPay Blog",
        "rss_image_url": "https://blog.bitpay.com/favicon.png",
        "rss_description": "A staff-driven look into enterprise bitcoin development."
    },
    {
        "title": "Crypto Mining Blog",
        "url": "http://cryptomining-blog.com/",
        "description": "A wonderful blog for cryptocurrency miners and users of Bitcoin (BTC), Litecoin (LTC), Ethereum (ETH), ZCash (ZEC) and many others.",
        "votes": "4",
        "category": "Cryptocurrency",
        "e": "Error: Unexpected close tag\nLine: 215\nColumn: 240\nChar: >"
    },
    {
        "title": "Mineable",
        "url": "https://mineable.com/",
        "description": "Minable is a one-stop source for exclusive cryptocurrency news & innovations in Bitcoin mining. Bringing you the latest news, guides on Ethereum mining, GPU mining hardware & software. Tutorials and reviews about blockchain technology, price analysis & market predictions.",
        "votes": "2",
        "category": "Cryptocurrency",
        "e": "Error: Attribute without value\nLine: 158\nColumn: 77\nChar: >"
    },
    {
        "title": "Bitfinex Blog",
        "url": "http://blog.bitfinex.com/",
        "description": "The blog of the Bitfinix website, provides latest news about trading coin pairs added on Bitfinex. The news lets investors keep track of all coins available to trade.",
        "votes": "1",
        "category": "Cryptocurrency",
        "rss_url": "http://blog.bitfinex.com/feed/",
        "rss_title": "Bitfinex blog",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Bitcoin, Litecoin and Ethereum Exchange and Margin Trading Platform"
    },
    {
        "title": "CoinBundle",
        "url": "https://medium.com/coinbundle",
        "description": "CoinBundle is the easiest way for people to invest in cryptocurrencies responsibly. They provide a wealth of information and take all the hard work out of investing, letting you build your portfolio according to your needs.",
        "votes": "0",
        "category": "Cryptocurrency",
        "rss_url": "https://medium.com/feed/coinbundle",
        "rss_title": "CoinBundle - Medium",
        "rss_image_url": "https://cdn-images-1.medium.com/proxy/1*TGH72Nnw24QL3iV9IOm4VA.png",
        "rss_description": "We&#39;re not another typical boring crypto project. Follow us to get the best crypto-articles and of course big announcements about CoinBundle. - Medium"
    },
    {
        "title": "CoinSpectator",
        "url": "https://blog.coinspectator.com/",
        "description": "Founded by Darren Rowse of Problogger fame, Digital Photography School helps both beginner and advanced Photographers get to grip with the techniques and tips they need.",
        "votes": "0",
        "category": "Cryptocurrency",
        "rss_url": "https://blog.coinspectator.com/feed/",
        "rss_title": "CoinSpectator Blog",
        "rss_image_url": "https://blog.coinspectator.com/wp-content/uploads/2018/08/cropped-favicon-32x32-32x32.png",
        "rss_description": "Cryptocurrency news, insight and everything in between."
    },
    {
        "title": "All Coins News",
        "url": "http://allcoinsnews.com/",
        "description": "Owned by Asia tech media, Allcoinsnews.com provides news and information on the Bitcoin and the digital currency industry.",
        "votes": "0",
        "category": "Cryptocurrency",
        "e": "Error: Invalid character in entity name\nLine: 15\nColumn: 367\nChar: &"
    },
    {
        "title": "Coin Noob",
        "url": "http://coinnoob.com/",
        "description": "Founded by Pascal Thellmann, CoinNoob provides easy to understand but detailed information about cryptocurrencies, their usage and tips related to saving them securely.",
        "votes": "0",
        "category": "Cryptocurrency",
        "e": "Error: Attribute without value\nLine: 21\nColumn: 52\nChar: r"
    },
    {
        "title": "CoinJournal",
        "url": "https://coinjournal.net/",
        "description": "CoinJournal brings the latest Bitcoin, cryptocurrency and blockchain news from around the world.",
        "votes": "0",
        "category": "Cryptocurrency",
        "rss_url": "https://coinjournal.net/feed/",
        "rss_title": "Coinjournal",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Bitcoin News"
    },
    {
        "title": "CoinReport",
        "url": "https://coinreport.net/",
        "description": "CoinReport provides the most accurate (unbiased) and up to date news and analysis on cryptocurrencies and anything related to them.",
        "votes": "0",
        "category": "Cryptocurrency",
        "e": "Error: Invalid character in entity name\nLine: 100\nColumn: 367\nChar: &"
    },
    {
        "title": "CryptoNinjas",
        "url": "https://www.cryptoninjas.net/",
        "description": "CryptoNinjas is a global news and market research website that supplies economic and industry information related to the cryptocurrency sector.",
        "votes": "0",
        "category": "Cryptocurrency",
        "e": "Error: Client network socket disconnected before secure TLS connection was established"
    },
    {
        "title": "Ethereum Blog",
        "url": "https://blog.ethereum.org/",
        "description": "Ethereum blog is dedicated to world's second cryptocurrency ethereum, it features latest news, developments and announcements related to ethereum.",
        "votes": "0",
        "category": "Cryptocurrency",
        "e": "Error: Unexpected close tag\nLine: 31\nColumn: 7\nChar: >"
    },
    {
        "title": "ForkLog",
        "url": "http://forklog.net/",
        "description": "ForkLog keeps track of news, covering the events and conferences, interviews with Bitcoin community figures, and so on.",
        "votes": "0",
        "category": "Cryptocurrency",
        "e": "Error: Attribute without value\nLine: 5\nColumn: 2\nChar: i"
    },
    {
        "title": "Brave New Coin",
        "url": "https://bravenewcoin.com/news",
        "description": "Brave New Coin (BNC) is a Blockchain and Digital Currency Market Data company, which publishes technical analysis and research, used by key decision makers.",
        "votes": "0",
        "category": "Cryptocurrency",
        "e": "Error: connect ECONNREFUSED 127.0.0.1:80"
    },
    {
        "title": "CoinJar phoblographer",
        "url": "https://blog.coinjar.com/",
        "description": "CoinJar blog, providing latest news and announcements related to the CoinJar website as well as the general cryptocurrency space.",
        "votes": "0",
        "category": "Cryptocurrency",
        "rss_url": "https://blog.coinjar.com/feed/",
        "rss_title": "CoinJar Blog",
        "rss_image_url": "https://i0.wp.com/blog.coinjar.com/wp-content/uploads/2019/03/favicon.png?fit=64%2C64&ssl=1",
        "rss_description": "News and info from the CoinJar team"
    },
    {
        "title": "TradingBeasts",
        "url": "https://tradingbeasts.com/cryptocurrency-trading/",
        "description": "TradingBeasts is a blog about day trading cryptocurrencies, forex and other CFD instruments. They publish news from the crypto world, warn about scam brokers and systems and compare the best-regulated brokers on the market.",
        "votes": "0",
        "category": "Cryptocurrency",
        "rss_url": "https://tradingbeasts.com/feed/",
        "rss_title": "",
        "rss_image_url": "https://tradingbeasts.com/wp-content/uploads/2017/12/ikonka-50x50.jpg",
        "rss_description": "Learn how to trade Cryptocurrencies, Forex and Binary options"
    },
    {
        "title": "SearchEngineJournal",
        "url": "https://www.searchenginejournal.com/",
        "description": "Launched in 2003, SEJ is unique in its community-based approach to search marketing content. They educate and empower the SEO community by providing the freshest news and latest best practices.",
        "votes": "1507",
        "category": "Business & Marketing",
        "rss_url": "https://www.searchenginejournal.com/feed/",
        "rss_title": "Search Engine Journal",
        "rss_image_url": "https://cdn.searchenginejournal.com/wp-content/uploads/2017/04/sej-nofeatured-2x.jpg",
        "rss_description": "SEO, Search Marketing News and Tutorials"
    },
    {
        "title": "HubSpot",
        "url": "https://blog.hubspot.com/",
        "description": "Founded by B. Halligan and D. Shah in 2006, HubSpot is an inbound marketing and sales platform that helps companies attract visitors, convert leads, and close customers.",
        "votes": "1369",
        "category": "Business & Marketing",
        "e": "Error: Invalid character in entity name\nLine: 165\nColumn: 44\nChar: ="
    },
    {
        "title": "Search Engine Land",
        "url": "https://searchengineland.com/",
        "description": "Search Engine Land is a leading daily publication that covers all aspects of the search marketing industry. It also features contributed articles filled with practical tips, tactics and strategies for running successful marketing campaigns.",
        "votes": "869",
        "category": "Business & Marketing",
        "rss_url": "http://feeds.searchengineland.com/searchengineland",
        "rss_title": "Search Engine Land: News & Info About SEO, PPC, SEM, Search Engines & Search Marketing",
        "rss_image_url": "http://searchengineland.com/images/sel-logo-144.jpg",
        "rss_description": "Search Engine Land's feed keeps you updated throughout the day on the latest news with Google, Yahoo, Microsoft's Bing and the world of search engine marketing, search engine optimization and search engines in general."
    },
    {
        "title": "Social Media Examiner",
        "url": "https://www.socialmediaexaminer.com/",
        "description": "Boasting over 450,000 email subscribers, Social Media Examiner helps millions of businesses discover how to best use social media to connect with customers, drive traffic, generate awareness and increase sales.",
        "votes": "807",
        "category": "Business & Marketing",
        "e": "Error: Attribute without value\nLine: 1\nColumn: 91\nChar: i"
    },
    {
        "title": "Moz",
        "url": "https://moz.com/blog",
        "description": "Backed by the largest community of SEOs on the planet, Moz builds tools that make SEO, inbound marketing, link building, and content marketing easy.",
        "votes": "741",
        "category": "Business & Marketing",
        "rss_url": "http://feedpress.me/mozblog",
        "rss_title": "The Moz Blog",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media"
    },
    {
        "title": "SEMRush",
        "url": "https://www.semrush.com/blog/",
        "description": "SEMrush consists of two hundred specialists in four countries focused on one goal: Creating the best competitive intelligence solution for all digital marketing spheres.",
        "votes": "572",
        "category": "Business & Marketing",
        "rss_url": "https://www.semrush.com/blog/feed/",
        "rss_title": "SEMrush blog",
        "rss_image_url": "https://cdn.semrush.com/blog/static/build/favicons/favicon.ico",
        "rss_description": "SEMrush blog"
    },
    {
        "title": "TopRank",
        "url": "http://www.toprankblog.com/",
        "description": "Started in December 2003 by Lee Odden, TopRank’s Online Marketing Blog helps companies increase sales, brand visibility online and develop better customer engagement.",
        "votes": "326",
        "category": "Business & Marketing",
        "e": "Error: Invalid character in entity name\nLine: 30\nColumn: 433\nChar: &"
    },
    {
        "title": "Search Engine Roundtable",
        "url": "https://www.seroundtable.com/",
        "description": "Search Engine Roundtable provides a comprehensive view on search engines and search engine marketing from five segments of the Web population represented by senior members of the major SEO/SEM forums on the Internet.",
        "votes": "322",
        "category": "Business & Marketing",
        "rss_url": "https://www.seroundtable.com/index.rdf",
        "rss_title": "Search Engine Roundtable",
        "rss_image_url": "https://www.seroundtable.com/apple-touch-icon.png",
        "rss_description": "A well-rounded view on search engines and search engine marketing from five segments of the Web population represented by senior members of the major SEO/SEM forums on the Internet."
    },
    {
        "title": "Convince & Convert",
        "url": "http://www.convinceandconvert.com/",
        "description": "Founded by Jay Baer in 2008, ConvertandConvince helps world-class organizations to make digital marketing and customer experiences remarkable.",
        "votes": "267",
        "category": "Business & Marketing",
        "e": "Error: Invalid character in entity name\nLine: 67\nColumn: 433\nChar: &"
    },
    {
        "title": "Smart Insights",
        "url": "https://www.smartinsights.com/",
        "description": "Started by two cofounders, Dr Dave Chaffey and Stu Miller, SmartInsights helps members plan, manage and optimize their marketing using the downloadable planning templates, guides and interactive learning tools.",
        "votes": "255",
        "category": "Business & Marketing",
        "rss_url": "https://www.smartinsights.com/feed/",
        "rss_title": "Smart Insights",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Digital Marketing > The Marketing Strategy Blog"
    },
    {
        "title": "Copyblogger",
        "url": "https://www.copyblogger.com/",
        "description": "Copyblogger, founded by Brian Clark, is also known as \"The bible of content marketing\". Brian teaches people how to create content that attracts attention, drives traffic and builds your business.",
        "votes": "240",
        "category": "Business & Marketing",
        "e": "Error: Invalid character in entity name\nLine: 38\nColumn: 367\nChar: &"
    },
    {
        "title": "Marketing Profs",
        "url": "http://www.marketingprofs.com/",
        "description": "Trusted by 600,000 professionals globally, MarketingProfs is a source that individual marketers, marketing teams, and some of the world's largest organizations turn to for modern marketing tools, training and discussions.",
        "votes": "239",
        "category": "Business & Marketing",
        "e": "Error: Invalid character in entity name\nLine: 10\nColumn: 43\nChar: ="
    },
    {
        "title": "Search Engine Watch",
        "url": "https://searchenginewatch.com/",
        "description": "Founded by Danny Sullivan in 1996, SearchEngineWatch provides news articles, guides, reviews and commentary about Search, PPC, Social, Mobile, Analytics and more.",
        "votes": "228",
        "category": "Business & Marketing",
        "rss_url": "https://searchenginewatch.com/feed/",
        "rss_title": "Search Engine Watch",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": ""
    },
    {
        "title": "WordStream",
        "url": "https://www.wordstream.com/blog",
        "description": "A premier Google Partner, WordStream develops online marketing software, provides managed PPC advertising services, and shares online marketing advice through their blog.",
        "votes": "221",
        "category": "Business & Marketing",
        "e": "Error: Invalid character in entity name\nLine: 3\nColumn: 185\nChar: ="
    },
    {
        "title": "Backlinko",
        "url": "https://backlinko.com/",
        "description": "Backlinko is where beginner and professional marketers turn for proven SEO (and specifically link building) advice.",
        "votes": "189",
        "category": "Business & Marketing",
        "e": "Error: Unexpected close tag\nLine: 56\nColumn: 66\nChar: >"
    },
    {
        "title": "Yoast",
        "url": "https://yoast.com/",
        "description": "With a team of over 50 experts, Yoast provides SEO and marketing services and is also home to the popular Wordpress for SEO plugin used by millions.",
        "votes": "178",
        "category": "Business & Marketing",
        "e": "Error: Invalid character in entity name\nLine: 95\nColumn: 43\nChar: ="
    },
    {
        "title": "Unbounce",
        "url": "https://unbounce.com/blog/",
        "description": "Unbounce’s landing page and conversion marketing platform allows marketers to quickly create, launch and test high-converting landing pages without the need for developers.",
        "votes": "133",
        "category": "Business & Marketing",
        "rss_url": "http://feeds.feedburner.com/unbounce",
        "rss_title": "Unbounce",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "Landing Pages: Build Publish & Test Without I.T."
    },
    {
        "title": "Matthew Woodward",
        "url": "https://www.matthewwoodward.co.uk/",
        "description": "Matthew Woodward helps his readers to create bespoke SEO strategies based around the businesses needs and goals.",
        "votes": "120",
        "category": "Business & Marketing",
        "rss_url": "https://www.matthewwoodward.co.uk/feed/",
        "rss_title": "Matthew Woodward",
        "rss_image_url": "https://cdn.matthewwoodward.co.uk/wp-content/uploads/2015/02/home.jpg",
        "rss_description": "Tried & Tested SEO"
    },
    {
        "title": "Ahrefs",
        "url": "https://ahrefs.com/blog/",
        "description": "The Ahrefs blog provides a comprehensive archive of articles including tutorials and case studies with powerful marketing strategies that beginner and advanced SEO's alike can benefit from.",
        "votes": "110",
        "category": "Business & Marketing",
        "e": "Error: Invalid character in entity name\nLine: 1\nColumn: 433\nChar: &"
    },
    {
        "title": "Smart Blogger",
        "url": "https://smartblogger.com/",
        "description": "Smart Blogger is the next step in the evolution of Boost Blog Traffic (BBT), created by popular blogger Jon Morrow in 2012.",
        "votes": "105",
        "category": "Business & Marketing",
        "rss_url": "https://smartblogger.com/feed/",
        "rss_title": "Smart Blogger",
        "rss_image_url": "https://smartblogger.com/wp-content/uploads/2019/04/smartblogger-cutting-edge-advice-about-blogging-fb.png",
        "rss_description": "How to get more readers, become an authority in your niche, and get the attention you deserve."
    },
    {
        "title": "Detailed",
        "url": "https://detailed.com/blog/",
        "description": "Yours truly. The Detailed content marketing blog that gives you advanced insights into marketing tactics you can actually use.",
        "votes": "92",
        "category": "Business & Marketing",
        "e": "Error: Attribute without value\nLine: 60\nColumn: 118\nChar: >"
    },
    {
        "title": "ProBlogger",
        "url": "https://problogger.com/",
        "description": "Founded by Darren Rowse, ProBlogger help other bloggers learn the skills of blogging, share their own experiences and promote the blogging medium.",
        "votes": "84",
        "category": "Business & Marketing",
        "e": "Error: Attribute without value\nLine: 16\nColumn: 76\nChar: /"
    },
    {
        "title": "Authority Hacker",
        "url": "https://www.authorityhacker.com/",
        "description": "Founded by Gael Breton and Mark Webster, Authority Hacker suggests actionable advice based on actual, real-time, up-to-date experience to grow online businesses in a concrete way.",
        "votes": "75",
        "category": "Business & Marketing",
        "rss_url": "https://www.authorityhacker.com/feed/",
        "rss_title": "Authority Hacker",
        "rss_image_url": "https://www.authorityhacker.com/wp-content/uploads/2018/11/ms-icon-144x144.png",
        "rss_description": "Actionable marketing to dominate your niche"
    },
    {
        "title": "CoSchedule",
        "url": "https://coschedule.com/blog/",
        "description": "Boasting over 220,000 newsletter subscribers, CoSchedule covers topics ranking from content marketing to workflow management.",
        "votes": "54",
        "category": "Business & Marketing",
        "rss_url": "https://coschedule.com/feed/",
        "rss_title": "CoSchedule Blog",
        "rss_image_url": "https://media.coschedule.com/uploads/cropped-coschedule-favicon-512-32x32.png",
        "rss_description": "The Ultimate Marketing Blog"
    },
    {
        "title": "cognitiveSEO",
        "url": "https://cognitiveseo.com/blog",
        "description": "At cognitiveSEO, the target is to create a toolset that will help users monitor and rank their websites. The blog is an accompaniment to the service they offer.",
        "votes": "44",
        "category": "Business & Marketing",
        "e": "Error: Attribute without value\nLine: 12\nColumn: 92\nChar: >"
    },
    {
        "title": "Credo Blog",
        "url": "https://www.getcredo.com/blog/",
        "description": "Founded by John Doherty, Credo provides SEO insights for marketers and businesses looking to take their results to the next level.",
        "votes": "38",
        "category": "Business & Marketing",
        "rss_url": "https://www.getcredo.com/feed/",
        "rss_title": "Credo",
        "rss_image_url": "https://www.getcredo.com/wp-content/uploads/2019/02/cropped-logo_facebook-32x32.png",
        "rss_description": "Find and hire vetted digital marketing agencies and consultants"
    },
    {
        "title": "Portent",
        "url": "https://www.portent.com/blog",
        "description": "Founded by Ian Lurie in 1995, Portent provides SEO, PPC and SMB services along with creative content, social advertisement and analytics.",
        "votes": "37",
        "category": "Business & Marketing",
        "rss_url": "https://www.portent.com/feed",
        "rss_title": "Portent",
        "rss_image_url": "https://www.portent.com/images/2018/11/favicon.png",
        "rss_description": "Digital Marketing Agency - Seattle, WA"
    },
    {
        "title": "Smart Passive Income",
        "url": "https://www.smartpassiveincome.com/",
        "description": "Smart Passive Income is a resource ran by Pat Flynn which teaches proven strategies for running an online business and optimizing it for passive income.",
        "votes": "32",
        "category": "Business & Marketing",
        "rss_url": "https://www.smartpassiveincome.com/feed/",
        "rss_title": "The Smart Passive Income Blog",
        "rss_image_url": "https://cdn.smartpassiveincome.com/wp-content/uploads/2013/11/Homepage-Hero.jpg",
        "rss_description": "Smart Ways to Live a Passive Income Lifestyle On the Internet with SmartPassiveIncome.com"
    },
    {
        "title": "A Smart Bear",
        "url": "https://blog.asmartbear.com/",
        "description": "Startups, marketing, entrepreneurship, ideas, tips, and geeky stuff from Jason Cohen, founder of WP Engine and Smart Bear Software.",
        "votes": "31",
        "category": "Business & Marketing",
        "rss_url": "https://blog.asmartbear.com/feed",
        "rss_title": "@ASmartBear",
        "rss_image_url": "https://blog.asmartbear.com/wp-content/uploads/2019/02/favicon-0.png",
        "rss_description": "Startups + Marketing + Geekery"
    },
    {
        "title": "Chris Brogan",
        "url": "http://chrisbrogan.com/",
        "description": "Chris Brogan is CEO of Owner Media Group which provides marketing strategies and skills for the modern business.",
        "votes": "26",
        "category": "Business & Marketing",
        "rss_url": "https://chrisbrogan.com/feed/",
        "rss_title": "Chris Brogan Media",
        "rss_image_url": "https://i1.wp.com/chrisbrogan.com/wp-content/uploads/2019/04/cropped-PodcastGraphic_HeadCrop_400px.jpg?fit=32%2C32&ssl=1",
        "rss_description": "Retrofitting Humans for the Digital Age - Creativity and Collaboration Help for Companies"
    },
    {
        "title": "SEObook",
        "url": "http://www.seobook.com/",
        "description": "SEOBook is a leading SEO blog founded in 2003 by Aaron Wall and his team.",
        "votes": "26",
        "category": "Business & Marketing",
        "e": "Error: Invalid character in entity name\nLine: 11\nColumn: 79\nChar: ="
    },
    {
        "title": "Internet Marketing Ninjas",
        "url": "https://www.internetmarketingninjas.com/blog/",
        "description": "Founded by Jim Boykin, one of the original SEO's, the Internet Marketing Ninjas are a successful marketing agency with clients around the globe.",
        "votes": "19",
        "category": "Business & Marketing",
        "rss_url": "https://www.internetmarketingninjas.com/blog/feed/",
        "rss_title": "Internet Marketing Ninjas Blog",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "The latest SEO Industry news, notes, and chat."
    },
    {
        "title": "Crowdspring",
        "url": "https://www.crowdspring.com/blog/",
        "description": "Insights on growth hacking, the tools to use when marketing your sites and more.",
        "votes": "18",
        "category": "Business & Marketing",
        "rss_url": "https://www.crowdspring.com/blog/feed/",
        "rss_title": "crowdspring Blog",
        "rss_image_url": "https://www.crowdspring.com/blog/wp-content/uploads/2017/08/favicon.png",
        "rss_description": "crowdspring's blog about marketing, startups, small business, design and more."
    },
    {
        "title": "Fizzle",
        "url": "https://fizzle.co/sparkline",
        "description": "Founded by Corbett Barr and Chase Reeves, Fizzle is a blog for independent creatives and entrepreneurs building things that matter.",
        "votes": "9",
        "category": "Business & Marketing",
        "e": "Error: Invalid character in entity name\nLine: 42\nColumn: 433\nChar: &"
    },
    {
        "title": "SEO by the Sea",
        "url": "http://www.seobythesea.com/",
        "description": "Founded by Bill Slawski, SEO by the Sea uses professional, ethical, and proactive approaches to help webmasters and their intended audiences find each other.",
        "votes": "9",
        "category": "Business & Marketing",
        "rss_url": "http://www.seobythesea.com/feed/",
        "rss_title": "SEO by the Sea ⚓",
        "rss_image_url": "http://www.seobythesea.com/wp-content/favicon.bmp",
        "rss_description": "Learn SEO Directly from the Search Engines"
    },
    {
        "title": "eConsultancy",
        "url": "https://econsultancy.com/blog/",
        "description": "Founded by Ashley Friedlein, Econsultancy is home to the largest community of marketing and eCommerce professionals in the world.",
        "votes": "8",
        "category": "Business & Marketing",
        "rss_url": "https://econsultancy.com/feed/",
        "rss_title": "Econsultancy",
        "rss_image_url": "https://econsultancy.imgix.net/content/uploads/2018/09/10104102/econ-favicon.ico",
        "rss_description": ""
    },
    {
        "title": "Chris Ducker",
        "url": "http://www.chrisducker.com/",
        "description": "A melting pot of information to get clients kitted-out with all the tools, tips and tactics needed to start, run, support and grow a business in the 21st century.",
        "votes": "5",
        "category": "Business & Marketing",
        "e": "Error: Invalid character in entity name\nLine: 45\nColumn: 367\nChar: &"
    },
    {
        "title": "VideoFruit",
        "url": "https://videofruit.com/blog/",
        "description": "VideoFruit is a series of guides and software to help you to grow your website's email subscriber list.",
        "votes": "5",
        "category": "Business & Marketing",
        "rss_url": "https://videofruit.com/feed/",
        "rss_title": "Videofruit",
        "rss_image_url": "https://videofruit.wpengine.com/wp-content/uploads/2013/09/favicon-5.ico",
        "rss_description": "step by step formulas to grow your business with video"
    },
    {
        "title": "RankXL",
        "url": "https://www.rankxl.com/blog/",
        "description": "Founded by Chris Lee, RankXL is a personal blog where strategies, tips, and lessons learned are shared for online business owners.",
        "votes": "5",
        "category": "Business & Marketing",
        "e": "Error: Invalid character in entity name\nLine: 42\nColumn: 433\nChar: &"
    },
    {
        "title": "Social Triggers",
        "url": "https://socialtriggers.com/",
        "description": "Social triggers provides a perfect blend of data driven marketing and content marketing to help readers grow traffic, attract customers and sell products online.",
        "votes": "4",
        "category": "Business & Marketing",
        "e": "Error: Client network socket disconnected before secure TLS connection was established"
    },
    {
        "title": "Buffer Blog",
        "url": "https://blog.bufferapp.com",
        "description": "The blog of the popular social media tracking tool, Buffer share their insights to navigating the social media and online marketing landscape.",
        "votes": "4",
        "category": "Business & Marketing",
        "e": "Error: Invalid character in entity name\nLine: 8\nColumn: 94\nChar: ="
    },
    {
        "title": "Gaps.com",
        "url": "https://gaps.com/",
        "description": "Gaps is a bootstrapped, three-man operation with the sole focus of helping create more online success stories by sharing unique business opportunities based on profitable case studies.",
        "votes": "4",
        "category": "Business & Marketing",
        "rss_url": "https://gaps.com/feed/",
        "rss_title": "Gaps",
        "rss_image_url": "https://gaps.com/wp-content/uploads/launch2.jpg",
        "rss_description": "Data-backed business opportunities."
    },
    {
        "title": "Niche Hacks",
        "url": "https://nichehacks.com/",
        "description": "NicheHacks helps every day people find their perfect online business idea and win back their freedom, even if they don't have any business experience.",
        "votes": "4",
        "category": "Business & Marketing",
        "rss_url": "https://nichehacks.com/feed/",
        "rss_title": "NicheHacks",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": "\"The Wikipedia of Online Marketing...\""
    },
    {
        "title": "Search Engine People",
        "url": "https://www.searchenginepeople.com/blog",
        "description": "Search Engine People shares an abundance of information on SEO and Marketing, as well as solutions for reaching your goals in these fields.",
        "votes": "2",
        "category": "Business & Marketing",
        "e": "Error: Request timed out after 10000ms"
    },
    {
        "title": "Seth's Blog",
        "url": "http://sethgodin.typepad.com/seths_blog/",
        "description": "Seth Godin riffs on marketing, respect, and the ways ideas spread. He's a best selling author of over a dozen books, and one of the web's first prolific bloggers.",
        "votes": "2",
        "category": "Business & Marketing",
        "e": "Error: Feed not recognized as RSS 1 or 2."
    },
    {
        "title": "Kaiserthesage",
        "url": "https://kaiserthesage.com/",
        "description": "Kaiserthesage is a personal blog of Jason Acidre – a Manila-based Digital Marketing Consultant with a heavy focus on SEO, Content, Links & Web Analytics.",
        "votes": "2",
        "category": "Business & Marketing",
        "rss_url": "https://kaiserthesage.com/feed/",
        "rss_title": "Kaiserthesage",
        "rss_image_url": "https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media",
        "rss_description": ""
    },
    {
        "title": "Niche Pursuits",
        "url": "https://www.nichepursuits.com/",
        "description": "Founded by Spencer Haws, Nichepursuits is a one stop shop website to find online business ideas, marketing tactics and more.",
        "votes": "2",
        "category": "Business & Marketing",
        "rss_url": "https://www.nichepursuits.com/feed/",
        "rss_title": "Niche Pursuits",
        "rss_image_url": "https://www.nichepursuits.com/wp-content/uploads/2018/02/cropped-NP_Favicon-150x150.jpg",
        "rss_description": "Find Business Ideas, Niche Websites, and much more!"
    },
    {
        "title": "BlogTyrant",
        "url": "https://www.blogtyrant.com",
        "description": "Founded by Australian blogger Ramsay Taplin, Blog Tyrant covers all the author knows about building a successful blog.",
        "votes": "1",
        "category": "Business & Marketing",
        "rss_url": "https://www.blogtyrant.com/feed/",
        "rss_title": "Blog Tyrant: How to Start a Blog and Work from the Couch",
        "rss_image_url": "https://www.blogtyrant.com/wp-content/uploads/powerpress/btxp-961.jpg",
        "rss_description": ""
    },
    {
        "title": "QuickSprout",
        "url": "https://www.quicksprout.com/blog/",
        "description": "Founded by Neil Patel, QuickSprout is a business and marketing blog. The sites main focus is to help you grow your website traffic.",
        "votes": "1",
        "category": "Business & Marketing",
        "rss_url": "https://www.quicksprout.com/feed/",
        "rss_title": "Quick Sprout",
        "rss_image_url": "https://www.quicksprout.com/wp-content/uploads/2015/11/quicksprout.png",
        "rss_description": "Make Better Content"
    },
    {
        "title": "I'm From the Future",
        "url": "https://imfromthefuture.com/blog/",
        "description": "The blog from the popular agency I'm From the Future named 'The Flux' shares their insights on all aspects of SEO.",
        "votes": "0",
        "category": "Business & Marketing",
        "e": "Error: socket hang up"
    }
]   

let retval = [];
for(let i=0;i<dis.length;i++)
{
    let e = dis[i];
    if(!e.e)
    {
        //@ts-ignore
        e.votes = parseInt(e.votes);
        retval.push(e);
    }
}
export default retval;


// WEBPACK FOOTER //
// ./src/data/discovery.ts